// GENERATED by scripts/build-crs-rules.mjs from OWASP CRS v4.29.0 — do not edit.
// THREATCRUSH_RULES at the end are ThreatCrush's own, not CRS.
// Source: vendor/coreruleset (REQUEST-913-SCANNER-DETECTION.conf, REQUEST-930-APPLICATION-ATTACK-LFI.conf, REQUEST-931-APPLICATION-ATTACK-RFI.conf, REQUEST-932-APPLICATION-ATTACK-RCE.conf, REQUEST-933-APPLICATION-ATTACK-PHP.conf, REQUEST-934-APPLICATION-ATTACK-GENERIC.conf, REQUEST-941-APPLICATION-ATTACK-XSS.conf, REQUEST-942-APPLICATION-ATTACK-SQLI.conf, REQUEST-944-APPLICATION-ATTACK-JAVA.conf).
// OWASP CRS is Apache-2.0; see ./LICENSE and ./NOTICE. Regenerate with
// `pnpm --filter @profullstack/threatcrush crs:build`.
/* eslint-disable */
import type { CrsRule } from './types.js';

export const CRS_VERSION = "4.29.0";

/** Rules removed by id after measurement (reason in the generator's EXCLUDED). */
export const CRS_EXCLUDED_IDS: readonly number[] = [];

/** PL1 rules not ported, grouped by the reason. */
export const CRS_SKIPPED: ReadonlyArray<{ reason: string; ids: number[] }> = [
  {
    "reason": "paranoia level > 1",
    "ids": [
      930121,
      931130,
      931131,
      932371,
      932231,
      932131,
      932200,
      932205,
      932206,
      932207,
      932220,
      932240,
      932281,
      932210,
      932271,
      932300,
      932310,
      932320,
      932236,
      932239,
      932161,
      932390,
      932232,
      932237,
      932238,
      932290,
      932190,
      932350,
      932301,
      932311,
      932321,
      932331,
      933151,
      933152,
      933153,
      933131,
      933161,
      933111,
      933190,
      933211,
      934101,
      934120,
      934140,
      934180,
      934220,
      934210,
      941101,
      941150,
      941181,
      941320,
      941330,
      941340,
      941380,
      942120,
      942130,
      942131,
      942150,
      942180,
      942200,
      942210,
      942260,
      942300,
      942310,
      942330,
      942340,
      942361,
      942362,
      942370,
      942380,
      942390,
      942400,
      942410,
      942470,
      942480,
      942430,
      942440,
      942450,
      942510,
      942520,
      942521,
      942522,
      942101,
      942152,
      942321,
      942251,
      942490,
      942420,
      942431,
      942460,
      942511,
      942530,
      942421,
      942432,
      944151,
      944200,
      944210,
      944240,
      944250,
      944260,
      944300,
      944152
    ]
  },
  {
    "reason": "no target visible in an access log",
    "ids": [
      932180,
      933110,
      933220,
      944140
    ]
  },
  {
    "reason": "control rule (no paranoia-level tag)",
    "ids": [
      941010
    ]
  }
];

export const CRS_RULES: readonly CrsRule[] = [
  {
    "id": 913100,
    "msg": "Found User-Agent associated with security scanner",
    "severity": "CRITICAL",
    "tags": [
      "attack-reputation-scanner"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent"
    ],
    "transforms": [],
    "op": {
      "type": "pm",
      "phrases": [
        "arachni",
        "betabot",
        "bewica-security-scan",
        "BFAC",
        "commix",
        "Detectify",
        "dirbuster",
        "fimap",
        "fuzz faster",
        "whatwaf",
        "gobuster",
        "havij",
        "hexometer",
        "jbrofuzz",
        "jorgee",
        "libwhisker",
        "masscan",
        "morfeus",
        "Mozlila",
        "Mozilla/5.g",
        "nessus",
        "netlab360",
        "netsparker",
        "nettacker",
        "nikto",
        "nmap",
        "nuclei",
        "openvas",
        "securityagent",
        "sitelockspider",
        "sqlmap",
        "sysscan",
        "TsunamiSecurityScanner",
        "w3af.org",
        "webbandit",
        "webshag",
        "wfuzz",
        "whatweb",
        "wprecon",
        "wpscan",
        "feroxbuster",
        "l9explore",
        "l9tcpid",
        "wapiti",
        "vega",
        "appspider",
        "ironwasp",
        "skipfish",
        "qualysguard",
        "n-stalker",
        "acunetix",
        "cmsmap",
        "sqlninja",
        "xsstrike",
        "xsser",
        "joomscan",
        "droopescan",
        "zgrab",
        "Ghauri",
        "zmeu",
        "WPProbe",
        "SSTIMap",
        "Mozilla/4.0 (Hydra)",
        "tplmap",
        "DotDotPwn",
        "shortscan",
        "Kadimus",
        "LFISuite",
        "Mozilla/5.0 (compatible; Panoptic",
        "LFImap",
        "graphw00f",
        "graphql-cop",
        "jSQL",
        "noseyparker",
        "TruffleHog",
        "YesWeHack-Hunter",
        "TInjA",
        "Mozilla/5.0 (compatible; AppScan;"
      ],
      "negated": false
    }
  },
  {
    "id": 930100,
    "msg": "Path Traversal Attack (/../) or (/.../)",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi"
    ],
    "targets": [
      "REQUEST_URI_RAW",
      "ARGS",
      "REQUEST_HEADERS:User-Agent"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:[/\\x5c]|%(?:2(?:f|5(?:2f|5c|c(?:1%259c|0%25af))|%46)|5c|c(?:0%(?:[2aq]f|5c|9v)|1%(?:[19p]c|8s|af))|(?:bg%q|(?:e|f(?:8%8)?0%8)0%80%a)f|u(?:221[56]|EFC8|F025|002f)|%3(?:2(?:%(?:%6|4)6|F)|5%%63)|1u)|0x(?:2f|5c))(?:\\.(?:%0[01]|\\?)?|\\?\\.?|%(?:2(?:(?:5(?:2|c0%25a))?e|%45)|c0(?:\\.|%[256aef]e)|u(?:(?:ff0|002)e|2024)|%32(?:%(?:%6|4)5|E)|(?:e|f(?:(?:8|c%80)%8)?0%8)0%80%ae)|0x2e){2,3}(?:[/\\x5c]|%(?:2(?:f|5(?:2f|5c|c(?:1%259c|0%25af))|%46)|5c|c(?:0%(?:[2aq]f|5c|9v)|1%(?:[19p]c|8s|af))|(?:bg%q|(?:e|f(?:8%8)?0%8)0%80%a)f|u(?:221[56]|EFC8|F025|002f)|%3(?:2(?:%(?:%6|4)6|F)|5%%63)|1u)|0x(?:2f|5c))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 930110,
    "msg": "Path Traversal Attack (/../) or (/.../)",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi"
    ],
    "targets": [
      "REQUEST_URI_RAW",
      "ARGS",
      "REQUEST_HEADERS:User-Agent"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "removeNulls",
      "cmdLine"
    ],
    "multiMatch": true,
    "op": {
      "type": "rx",
      "source": "(?:^|[/;\\x5c])\\.{2,3}[/;\\x5c]",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 930120,
    "msg": "OS File Access Attempt",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "normalizePathWin"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        ".access/",
        ".addressbook",
        ".anydesk/",
        ".aptitude/config",
        ".atom/",
        ".aws/",
        ".azure/",
        ".bash_",
        ".bashrc",
        ".boto",
        ".cache/",
        ".cache/notify-osd.log",
        ".cargo/",
        ".config.local.php",
        ".config/",
        ".coverage",
        ".coveralls.yml",
        ".credentials",
        ".cshrc",
        ".cups/",
        ".cvs",
        ".dbus/",
        ".deployment-secrets.txt",
        ".docker/",
        ".dockerenv",
        ".dockerignore",
        ".drush/",
        ".DS_Store",
        ".envrc",
        ".eslintignore",
        ".fbcindex",
        ".forward",
        ".ftpconfig",
        ".gem/",
        ".git/",
        ".gitattributes",
        ".gitconfig",
        ".gitignore",
        ".gitkeep",
        ".gitmodules",
        ".gnome/",
        ".gnome2/",
        ".gnomerc/",
        ".gnupg/",
        ".google_authenticator",
        ".gsutil/",
        ".hg/",
        ".hgignore",
        "/.history",
        ".hplip/hplip.conf",
        ".htaccess",
        ".htdigest",
        ".htpasswd",
        ".ipynb_checkpoints/",
        ".java/",
        ".ksh_history",
        ".kube/",
        ".lesshst",
        ".lftp/",
        ".lhistory",
        ".lighttpdpassword",
        ".lldb-history",
        ".local/bin/",
        ".local/lib/",
        ".local/share/",
        ".local/state/",
        ".lynx_cookies",
        ".minikube/",
        ".msmtprc",
        ".my.cnf",
        ".myscmserverinfo",
        ".mysql_history",
        ".nano_history",
        ".netrc",
        ".node_repl_history",
        ".npm/",
        ".npmrc",
        ".nsconfig",
        ".nsr",
        ".nvm/",
        ".oh-my-",
        ".password-store",
        ".pearrc",
        ".pgpass",
        ".php_history",
        ".pinerc",
        ".pki/",
        ".proclog",
        ".procmailrc",
        "/.profile",
        ".psql_history",
        ".pytest_cache/",
        ".python_history",
        ".rediscli_history",
        ".remote-sync.json",
        ".rhistory",
        ".rhosts",
        ".rustup",
        ".rustup/",
        ".s3cfg",
        ".secrets",
        ".selected_editor",
        ".settings/",
        ".sh_history",
        ".snap/",
        ".sqlite_history",
        ".ssh/",
        ".subversion/",
        ".svn/",
        ".svnignore",
        ".tconn/",
        ".tcshrc",
        ".terraform.lock.hcl",
        ".terraform/",
        ".thunderbird/",
        ".tmux.conf",
        ".tools/",
        ".tor/",
        ".travis.yaml",
        ".travis.yml",
        ".vagrant.d/",
        ".vidalia/",
        ".vim/",
        ".viminfo",
        ".vimrc",
        ".vmware/",
        ".vscode",
        ".web.config.swp",
        ".wget-hsts",
        ".www_acl",
        ".wwwacl",
        ".xauthority",
        ".yarnrc",
        ".zhistory",
        ".zsh_history",
        ".zshenv",
        ".zshrc",
        "/php.ini",
        "/tmp/",
        "config.asp",
        "config_dev.asp",
        "config-dev.asp",
        "config.dev.asp",
        "config_prod.asp",
        "config-prod.asp",
        "config.prod.asp",
        "config.sample.asp",
        "config-sample.asp",
        "config_sample.asp",
        "config_test.asp",
        "config-test.asp",
        "config.test.asp",
        "config.ini",
        "config_dev.ini",
        "config-dev.ini",
        "config.dev.ini",
        "config_prod.ini",
        "config-prod.ini",
        "config.prod.ini",
        "config.sample.ini",
        "config-sample.ini",
        "config_sample.ini",
        "config_test.ini",
        "config-test.ini",
        "config.test.ini",
        "config.json",
        "config_dev.json",
        "config-dev.json",
        "config.dev.json",
        "config_prod.json",
        "config-prod.json",
        "config.prod.json",
        "config.sample.json",
        "config-sample.json",
        "config_sample.json",
        "config_test.json",
        "config-test.json",
        "config.test.json",
        "config.php",
        "config_dev.php",
        "config-dev.php",
        "config.dev.php",
        "config_prod.php",
        "config-prod.php",
        "config.prod.php",
        "config.sample.php",
        "config-sample.php",
        "config_sample.php",
        "config_test.php",
        "config-test.php",
        "config.test.php",
        "config.pl",
        "config_dev.pl",
        "config-dev.pl",
        "config.dev.pl",
        "config_prod.pl",
        "config-prod.pl",
        "config.prod.pl",
        "config.sample.pl",
        "config-sample.pl",
        "config_sample.pl",
        "config_test.pl",
        "config-test.pl",
        "config.test.pl",
        "config.py",
        "config_dev.py",
        "config-dev.py",
        "config.dev.py",
        "config_prod.py",
        "config-prod.py",
        "config.prod.py",
        "config.sample.py",
        "config-sample.py",
        "config_sample.py",
        "config_test.py",
        "config-test.py",
        "config.test.py",
        "config.rb",
        "config_dev.rb",
        "config-dev.rb",
        "config.dev.rb",
        "config_prod.rb",
        "config-prod.rb",
        "config.prod.rb",
        "config.sample.rb",
        "config-sample.rb",
        "config_sample.rb",
        "config_test.rb",
        "config-test.rb",
        "config.test.rb",
        "config.toml",
        "config_dev.toml",
        "config-dev.toml",
        "config.dev.toml",
        "config_prod.toml",
        "config-prod.toml",
        "config.prod.toml",
        "config.sample.toml",
        "config-sample.toml",
        "config_sample.toml",
        "config_test.toml",
        "config-test.toml",
        "config.test.toml",
        "config.txt",
        "config_dev.txt",
        "config-dev.txt",
        "config.dev.txt",
        "config_prod.txt",
        "config-prod.txt",
        "config.prod.txt",
        "config.sample.txt",
        "config-sample.txt",
        "config_sample.txt",
        "config_test.txt",
        "config-test.txt",
        "config.test.txt",
        "config.xml",
        "config_dev.xml",
        "config-dev.xml",
        "config.dev.xml",
        "config_prod.xml",
        "config-prod.xml",
        "config.prod.xml",
        "config.sample.xml",
        "config-sample.xml",
        "config_sample.xml",
        "config_test.xml",
        "config-test.xml",
        "config.test.xml",
        "config.yaml",
        "config_dev.yaml",
        "config-dev.yaml",
        "config.dev.yaml",
        "config_prod.yaml",
        "config-prod.yaml",
        "config.prod.yaml",
        "config.sample.yaml",
        "config-sample.yaml",
        "config_sample.yaml",
        "config_test.yaml",
        "config-test.yaml",
        "config.test.yaml",
        "config.yml",
        "config_dev.yml",
        "config-dev.yml",
        "config.dev.yml",
        "config_prod.yml",
        "config-prod.yml",
        "config.prod.yml",
        "config.sample.yml",
        "config-sample.yml",
        "config_sample.yml",
        "config_test.yml",
        "config-test.yml",
        "config.test.yml",
        "config.sample.inc.php",
        "credentials.json",
        "secrets.json",
        "secrets.yaml",
        "secrets.yml",
        ".sql.001",
        ".sql.7z",
        ".sql.bz",
        ".sql.ace",
        ".sql.arj",
        ".sql.cpio",
        ".sql.gz",
        ".sql.lha",
        ".sql.lz",
        ".sql.pa",
        ".sql.pea",
        ".sql.r00",
        ".sql.r01",
        ".sql.r02",
        ".sql.r03",
        ".sql.r04",
        ".sql.r05",
        ".sql.r06",
        ".sql.r07",
        ".sql.r08",
        ".sql.r09",
        ".sql.rar",
        ".sql.rev",
        ".sql.tar",
        ".sql.taz",
        ".sql.tbz",
        ".sql.tgz",
        ".sql.txz",
        ".sql.uha",
        ".sql.xz",
        ".sql.yz1",
        ".sql.z",
        "phpinfo.php",
        "aws.yaml",
        "aws.yml",
        "aws-key.yaml",
        "aws-key.yml",
        "__pycache__/",
        "boot.ini",
        "system.ini",
        "win.ini",
        "pm2.log",
        "debug.log",
        "debian.cnf",
        "my.cnf",
        "mysql.cnf",
        "mysqldump.cnf",
        "ftp-sync.json",
        "yarn-debug.log",
        "yarn-error.log",
        "coverage.xml",
        "apache/access.conf",
        "apache/apache.conf",
        "apache/apache2.conf",
        "apache/audit_log",
        "apache/conf",
        "apache/default-server.conf",
        "apache/error_log",
        "apache/error.log",
        "apache/httpd.conf",
        "apache/log",
        "apache2/apache.conf",
        "apache2/apache2.conf",
        "apache2/conf",
        "apache2/default-server.conf",
        "apache2/envvars",
        "apache2/httpd.conf",
        "apache2/httpd2.conf",
        "apache2/logs",
        "apache2/mods",
        "apache2/ports.conf",
        "apache2/sites",
        "apache2/ssl-global.conf",
        "apache2/vhosts.d",
        "apache22/conf",
        "apache22/httpd.conf",
        "apache22/logs",
        "apache24/conf",
        "apache24/httpd.conf",
        "apache24/logs",
        "app/etc/local.xml",
        "boot.ini",
        "boot/grub/grub.cfg",
        "boot/grub/menu.lst",
        "config.sample.php",
        "config.inc.php",
        "config/app.php",
        "config/custom.php",
        "config/database.php",
        "config/parameters.php",
        "config/settings.inc.php",
        "configuration.php",
        "cpanel/logs",
        "database.yaml",
        "database.yml",
        "data/elasticsearch",
        "data/kafka",
        "defaults.inc.php",
        "etc/.java",
        "etc/acpi",
        "etc/adduser.conf",
        "etc/alias",
        "etc/alsa",
        "etc/alternatives",
        "etc/amavis",
        "etc/anacrontab",
        "etc/ansible",
        "etc/apache/access.conf",
        "etc/apache/apache.conf",
        "etc/apache/default-server.conf",
        "etc/apache/httpd.conf",
        "etc/apache/vhosts.conf",
        "etc/apache2",
        "etc/apm",
        "etc/apparmor",
        "etc/apport",
        "etc/apt",
        "etc/asciidoc",
        "etc/at.allow",
        "etc/at.deny",
        "etc/audit",
        "etc/avahi",
        "etc/bash.bashrc",
        "etc/bash_completion.d",
        "etc/bashrc",
        "etc/bind",
        "etc/binfmt.d",
        "etc/bluetooth",
        "etc/bonobo-activation",
        "etc/bootptab",
        "etc/brltty",
        "etc/byobu",
        "etc/ca-certificates",
        "etc/calendar",
        "etc/casper.conf",
        "etc/centos-release",
        "etc/chatscripts",
        "etc/chkrootkit.conf",
        "etc/chromium-browser",
        "etc/chrootusers",
        "etc/chttp.conf",
        "etc/clam.d",
        "etc/clamav",
        "etc/cni",
        "etc/console-setup",
        "etc/coraza-waf",
        "etc/cracklib",
        "etc/cron.allow",
        "etc/cron.d",
        "etc/cron.hourly",
        "etc/cron.monthly",
        "etc/cron.weekly",
        "etc/cron.yearly",
        "etc/crontab",
        "etc/crowdsec",
        "etc/crypttab",
        "etc/cups",
        "etc/cvs-cron.conf",
        "etc/cvs-pserver.conf",
        "etc/dbus-1",
        "etc/dconf",
        "etc/debconf.conf",
        "etc/debian_version",
        "etc/default",
        "etc/deluser.conf",
        "etc/depmod.d",
        "etc/dhcp",
        "etc/dictionaries-common",
        "etc/dkms",
        "etc/dns2tcpd.conf",
        "etc/dnsmasq.d",
        "etc/docker",
        "etc/dockeretc/dpkg",
        "etc/dovecot",
        "etc/e2fsck.conf",
        "etc/elasticsearch",
        "etc/emacs",
        "etc/env.php",
        "etc/environment.d",
        "etc/esound/esd.conf",
        "etc/etter.conf",
        "etc/exports",
        "etc/fail2ban",
        "etc/fedora-release",
        "etc/firebird",
        "etc/firefox",
        "etc/firewall",
        "etc/fonts",
        "etc/foremost.conf",
        "etc/freshclam.conf",
        "etc/fstab",
        "etc/ftpaccess",
        "etc/ftpchroot",
        "etc/ftphosts",
        "etc/ftpusers",
        "etc/fuse.conf",
        "etc/fwupd",
        "etc/gconf",
        "etc/gdb",
        "etc/gdm3",
        "etc/geoclue",
        "etc/ghostscript",
        "etc/gimp",
        "etc/gitlab",
        "etc/glvnd",
        "etc/gnome",
        "etc/gnucash",
        "etc/gnustep",
        "etc/groff",
        "etc/group",
        "etc/grub.conf",
        "etc/grub.d",
        "etc/gshadow",
        "etc/gss",
        "etc/gtk-2.0",
        "etc/gtk-3.0",
        "etc/hdparm.conf",
        "etc/host.conf",
        "etc/hostname",
        "etc/hosts",
        "etc/hp",
        "etc/http/conf",
        "etc/http/httpd.conf",
        "etc/httpd",
        "etc/ifplugd",
        "etc/imagemagick-6",
        "etc/inetd.conf",
        "etc/init",
        "etc/insserv.conf.d",
        "etc/ipfw",
        "etc/iproute2",
        "etc/iptables",
        "etc/issue",
        "etc/java",
        "etc/kafka",
        "etc/kbd/config",
        "etc/kernel",
        "etc/kibana",
        "etc/ld.so.conf",
        "etc/ldap",
        "etc/letsencrypt",
        "etc/libblockdev",
        "etc/libibverbs.d",
        "etc/libnl-3",
        "etc/libpaper.d",
        "etc/libreoffice",
        "etc/lighttpd",
        "etc/lilo.conf",
        "etc/logcheck",
        "etc/login.defs",
        "etc/logrotate.conf",
        "etc/logrotate.d",
        "etc/logstash",
        "etc/logwatch",
        "etc/lsb-release",
        "etc/ltrace.conf",
        "etc/lvm",
        "etc/lynx",
        "etc/mail",
        "etc/mandrake-release",
        "etc/manpath.config",
        "etc/mc",
        "etc/menu",
        "etc/miredo-server.conf",
        "etc/miredo.conf",
        "etc/miredo/miredo-server.conf",
        "etc/miredo/miredo.conf",
        "etc/modprobe.d",
        "etc/modsecurity",
        "etc/modulesf",
        "etc/mongod.conf",
        "etc/monit",
        "etc/mono",
        "etc/motd",
        "etc/mplayer",
        "etc/mpv",
        "etc/mtab",
        "etc/mtools.conf",
        "etc/muddleftpd",
        "etc/muddleftpd.com",
        "etc/muttrc.d",
        "etc/my.cnf",
        "etc/my.conf",
        "etc/mysql",
        "etc/netplan",
        "etc/network",
        "etc/networkmanager",
        "etc/newsyslog.conf",
        "etc/newt",
        "etc/nghttpx",
        "etc/nginx",
        "etc/nikto",
        "etc/npasswd",
        "etc/nsswitch.conf",
        "etc/nuxeo.conf",
        "etc/odbcdatasources",
        "etc/openal",
        "etc/opendkim",
        "etc/opendmarc",
        "etc/openldap/ldap.conf",
        "etc/openmpi",
        "etc/opt",
        "etc/os-release",
        "etc/osxhttpd",
        "etc/osync",
        "etc/packagekit",
        "etc/pam.conf",
        "etc/pam.d",
        "etc/pam.d/proftpd",
        "etc/passwd",
        "etc/password",
        "etc/pcmcia",
        "etc/perl",
        "etc/php",
        "etc/pki",
        "etc/pm",
        "etc/polkit-1",
        "etc/postfix",
        "etc/postgresql",
        "etc/ppp",
        "etc/printcap",
        "etc/profile",
        "etc/proftp.conf",
        "etc/proftpd",
        "etc/pulse",
        "etc/pure-ftpd",
        "etc/pureftpd",
        "etc/python",
        "etc/qemu",
        "etc/rc.conf",
        "etc/rc.d/rc.httpd",
        "etc/rc0.d",
        "etc/rc1.d",
        "etc/rc2.d",
        "etc/rc3.d",
        "etc/rc4.d",
        "etc/rc5.d",
        "etc/rc6.d",
        "etc/rcs.d",
        "etc/redhat-release",
        "etc/redis-sentinel.conf",
        "etc/redis.conf",
        "etc/resolv.conf",
        "etc/resolvconf",
        "etc/rsyslog.d",
        "etc/samba",
        "etc/sane.d",
        "etc/scw-release",
        "etc/security",
        "etc/selinux",
        "etc/sensors.conf",
        "etc/sensors.d",
        "etc/sensors3.conf",
        "etc/sgml",
        "etc/shadow",
        "etc/signon-ui",
        "etc/skel",
        "etc/slackware-release",
        "etc/smb.conf",
        "etc/smbpasswd",
        "etc/smi.conf",
        "etc/snmp",
        "etc/sogo",
        "etc/sound",
        "etc/spamassassin",
        "etc/speech-dispatcher",
        "etc/squid",
        "etc/squirrelmail",
        "etc/ssh",
        "etc/ssl",
        "etc/sso",
        "etc/stunnel",
        "etc/subgid",
        "etc/subuid",
        "etc/subversion",
        "etc/sudoers",
        "etc/suse-release",
        "etc/sw-cp-server/applications.d",
        "etc/sysconfig",
        "etc/sysctl.conf",
        "etc/sysctl.d",
        "etc/syslog.conf",
        "etc/sysstat",
        "etc/system-release-cpe",
        "etc/systemd",
        "etc/termcap",
        "etc/terminfo",
        "etc/texmf",
        "etc/thermald",
        "etc/thnuclnt",
        "etc/thunderbird",
        "etc/timezone",
        "etc/timidity",
        "etc/tinyproxy",
        "etc/tmpfiles.d",
        "etc/tor/tor-tsocks.conf",
        "etc/tsocks.conf",
        "etc/ubuntu-advantage",
        "etc/udev",
        "etc/udisks2",
        "etc/ufw",
        "etc/unbound",
        "etc/update-manager",
        "etc/update-motd.d",
        "etc/update-notifier",
        "etc/updatedb.conf",
        "etc/upower",
        "etc/urlview",
        "etc/usb_modeswitch.d",
        "etc/utmp",
        "etc/vhcs2/proftpd/proftpd.conf",
        "etc/vim",
        "etc/vmware",
        "etc/vsftpd.chroot_list",
        "etc/vsftpd.conf",
        "etc/vsftpd/vsftpd.conf",
        "etc/vulkan",
        "etc/w3m",
        "etc/webmin",
        "etc/wicd",
        "etc/wireshark",
        "etc/wpa_supplicant",
        "etc/wu-ftpd",
        "etc/x11",
        "etc/xdg",
        "etc/xml",
        "gitlab.rb",
        "gitlab_config_",
        "gruntfile.js",
        "home/postgres",
        "http/httpd.conf",
        "httpd/conf/httpd.conf",
        "includes/configure.php",
        "inetpub/wwwroot/global.asa",
        "initial_root_password",
        "jakarta/dist/tomcat",
        "jakarta/tomcat/conf",
        "jakarta/tomcat/logs",
        "library/webserver/documents",
        "lighttpd/conf",
        "lighttpd/lighttpd.conf",
        "lighttpd/log",
        "localsettings.php",
        "logs/access_log",
        "logs/access.log",
        "logs/error_log",
        "logs/error.log",
        "logs/pure-ftpd.log",
        "logs/samba.log",
        "logs/security_debug_log",
        "logs/security_log",
        "lsws/conf",
        "lsws/logs",
        "mysql/bin/my.ini",
        "mysql/data",
        "mysql/my.cnf",
        "mysql/my.ini",
        "nginx/conf/nginx.conf",
        "npm-debug.log",
        "opt/apache",
        "opt/apache2",
        "opt/httpd/apache.conf",
        "opt/httpd/apache2.conf",
        "opt/httpd/conf/",
        "opt/jboss",
        "opt/lampp",
        "opt/nuxeo",
        "opt/tomcat",
        "opt/xampp",
        "package-lock.json",
        "package.json",
        "parameters.yml",
        "pgsql/bin/pg_passwd",
        "pgsql/data",
        "php/apache.conf",
        "php/apache2.conf",
        "php/httpd.conf",
        "php5/apache.conf",
        "php5/apache2.conf",
        "php5/httpd.conf",
        "postgresql/log/",
        "/proc/",
        "proc/0",
        "proc/1",
        "proc/2",
        "proc/3",
        "proc/4",
        "proc/5",
        "proc/6",
        "proc/7",
        "proc/8",
        "proc/9",
        "proc/acpi",
        "proc/asound",
        "proc/bootconfig",
        "proc/buddyinfo",
        "proc/bus",
        "proc/cgroups",
        "proc/cmdline",
        "proc/config.gz",
        "proc/consoles",
        "proc/cpuinfo",
        "proc/crypto",
        "proc/devices",
        "proc/diskstats",
        "proc/dma",
        "proc/docker",
        "proc/driver",
        "proc/dynamic_debug",
        "proc/execdomains",
        "proc/fb",
        "proc/filesystems",
        "proc/fs",
        "proc/interrupts",
        "proc/iomem",
        "proc/ioports",
        "proc/ipmi",
        "proc/irq",
        "proc/kallsyms",
        "proc/kcore",
        "proc/key-users",
        "proc/keys",
        "proc/kmsg",
        "proc/kpagecgroup",
        "proc/kpagecount",
        "proc/kpageflags",
        "proc/latency_stats",
        "proc/loadavg",
        "proc/locks",
        "proc/mdstat",
        "proc/meminfo",
        "proc/misc",
        "proc/modules",
        "proc/mounts",
        "proc/mpt",
        "proc/mtd",
        "proc/mtrr",
        "proc/net",
        "proc/pagetypeinfo",
        "proc/partitions",
        "proc/pressure",
        "proc/sched_debug",
        "proc/schedstat",
        "proc/scsi",
        "proc/self",
        "proc/slabinfo",
        "proc/softirqs",
        "proc/stat",
        "proc/swaps",
        "proc/sys",
        "proc/sysrq-trigger",
        "proc/sysvipc",
        "proc/thread-self",
        "proc/timer_list",
        "proc/timer_stats",
        "proc/tty",
        "proc/uptime",
        "proc/version",
        "proc/version_signature",
        "proc/vmallocinfo",
        "proc/vmstat",
        "proc/zoneinfo",
        "program files",
        "psa/admin",
        "pureftpd/etc",
        "root/anaconda-ks.cfg",
        "routing.yml",
        "samba/lib",
        "sb/config",
        "security.yml",
        "server/default/conf",
        "server/default/deploy",
        "server/default/log",
        "services.yml",
        "sftp.json",
        "sites/default/default.settings.php",
        "sites/default/settings.local.php",
        "sites/default/settings.php",
        "squirrelmail/www",
        "/sys/",
        "sys/block",
        "sys/bus",
        "sys/class",
        "sys/dev",
        "sys/devices",
        "sys/firmware",
        "sys/fs",
        "sys/hypervisor",
        "sys/kernel",
        "sys/module",
        "sys/power",
        "system/library/webobjects/adaptors",
        "system32/config",
        "system32/inetsrv/config",
        "tmp/access.log",
        "tmp/kafka-logs",
        "typo3conf/localconf.php",
        "usr/etc/pure-ftpd.conf",
        "usr/home/user/lighttpd",
        "usr/lib/cron/log",
        "usr/lib/php",
        "usr/lib/rpm/rpm.log",
        "usr/lib/security",
        "usr/local/zeus/web",
        "usr/pkg/etc/httpd",
        "usr/pkgsrc/net/pureftpd",
        "usr/ports/contrib/pure-ftpd",
        "usr/ports/ftp/pure-ftpd",
        "usr/sbin/mudlogd",
        "usr/sbin/mudpasswd",
        "usr/share/adduser",
        "usr/share/logs",
        "usr/share/squirrelmail",
        "usr/share/tomcat",
        "usr/spool/lp",
        "usr/spool/mqueue",
        "var/adm",
        "var/apache/logs",
        "var/apache2/config.inc",
        "var/cpanel",
        "var/cron/log",
        "var/data/elasticsearch",
        "var/data/mysql-bin",
        "var/htmp",
        "var/lib/elasticsearch",
        "var/lib/mysql",
        "var/lib/pgsql",
        "var/lib/squirrelmail",
        "var/lighttpd",
        "var/local/www/conf",
        "var/log",
        "var/lp/logs",
        "var/mail",
        "var/mysql-bin",
        "var/mysql.log",
        "var/nm2/postgresql.conf",
        "var/postgresql",
        "var/run/utmp",
        "var/saf/_log",
        "var/saf/port/log",
        "var/spool",
        "var/webmin",
        "var/www",
        "volumes/macintosh_hd",
        "volumes/webbackup",
        "wamp/bin/apache",
        "wamp/bin/mysql",
        "wamp/bin/php",
        "wamp/logs",
        "web.config",
        "META-INF/",
        "WEB-INF/",
        "webpack.config.js",
        "windows/comsetup.log",
        "windows/debug/netsetup.log",
        "windows/odbc.ini",
        "windows/repair/setup.log",
        "windows/setupact.log",
        "windows/setupapi.log",
        "windows/setuperr.log",
        "windows/system32",
        "windows/syswow64",
        "windows/updspapi.log",
        "windows/windowsupdate.log",
        "windows/wmsetup.log",
        "winnt/repair",
        "winnt/system32/logfiles",
        "wp-config.",
        "wp-config-",
        "wp-config_",
        "wp-cli.",
        "www/conf/httpd.conf",
        "www/logs",
        "xampp/apache/logs",
        "xampp/filezillaftp",
        "xampp/htdocs",
        "xampp/mercurymail",
        "xampp/mysql/data",
        "xampp/php",
        "xampp/sendmail",
        "xampp/webalizer/webalizer.conf",
        "yarn.lock",
        "cargo.toml",
        ".ashrc",
        ".ash_history",
        "config.nu",
        ".csh_history",
        ".kshrc",
        "config.fish",
        ".tcsh_history",
        "pyproject.toml",
        "pytest.ini",
        "go.mod",
        "go.sum",
        "setup.py",
        "build.zig.zon",
        ".screenrc",
        ".chocolatey/",
        ".gradle/",
        ".idlerc/",
        ".kaggle/",
        ".keras/",
        ".mypy_cache/",
        ".redhat/",
        "node_modules/",
        ".bun/",
        ".bunfig.toml",
        ".irbrc/",
        ".irb_history",
        ".pryrc/",
        ".gemrc",
        ".gem/",
        ".bundle/",
        ".rbenv/",
        ".rvm/",
        ".rubocop.yml",
        ".pip/",
        ".condarc",
        "anaconda3/",
        "miniconda3/",
        ".pyenv/",
        ".m2/",
        ".sdkman/",
        ".eclipse/",
        ".npm-global/",
        ".yarnrc.yml",
        ".prettierrc",
        ".node-gyp",
        ".curlrc",
        ".wgetrc",
        ".perldb",
        ".perl_repl_history",
        ".perlhistory",
        "perl/",
        ".cpan/",
        ".cpanplus/",
        ".plenv",
        ".konan/",
        ".kotlinc_history",
        ".git-credentials",
        ".openvpn/",
        "openvpn/",
        "wg-clients/",
        ".gftp/",
        ".lftprc",
        ".ncftp/",
        ".rsync_exclude",
        "rsync.log",
        ".wine/",
        ".nanorc",
        ".nano/",
        ".pg_service.conf",
        ".mylogin.cnf",
        ".mongodb/",
        ".mongoshrc.js",
        ".dbshell",
        ".pgadmin/",
        ".pm2/",
        ".stubby.yml",
        ".getdns/",
        ".digrc",
        ".unbound/",
        ".mbsyncrc",
        ".offlineimaprc",
        ".getmail/",
        ".usermin/",
        ".cpanel/",
        ".openssl.cnf",
        ".terraformrc",
        ".terraform.d/",
        ".pulumi/",
        ".linode-cli/",
        ".oci/",
        ".opc/",
        ".sqlplus_history",
        "login.sql",
        ".editorconfig",
        ".datadog-agent/",
        ".wp-cli/",
        ".bluemix/",
        ".ibmcloud/"
      ],
      "negated": false
    }
  },
  {
    "id": 930130,
    "msg": "Restricted File Access Attempt",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi"
    ],
    "targets": [
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "normalizePathWin"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        ".htaccess",
        ".htdigest",
        ".htpasswd",
        ".access/",
        ".addressbook",
        ".anydesk/",
        ".aptitude/config",
        ".atom/",
        ".aws/",
        ".azure/",
        ".bash_",
        ".bashrc",
        ".boto",
        ".cache/",
        ".cache/notify-osd.log",
        ".cargo/",
        ".config.local.php",
        ".config/",
        ".coverage",
        ".coveralls.yml",
        ".credentials",
        ".cshrc",
        ".cups/",
        ".cvs",
        ".dbus/",
        ".deployment-secrets.txt",
        ".aiignore",
        ".cursorignore",
        ".docker/",
        ".dockerenv",
        ".dockerignore",
        ".drush/",
        ".env",
        ".envrc",
        ".eslintignore",
        ".fbcindex",
        ".forward",
        ".ftpconfig",
        ".gem/",
        ".git/",
        ".gitattributes",
        ".gitconfig",
        ".gitignore",
        ".gitkeep",
        ".gitmodules",
        ".gnome/",
        ".gnome2/",
        ".gnomerc/",
        ".gnupg/",
        ".google_authenticator",
        ".gsutil/",
        ".hg/",
        ".hgignore",
        ".hplip/hplip.conf",
        ".htaccess",
        ".htdigest",
        ".htpasswd",
        ".ipynb_checkpoints/",
        ".java/",
        ".ksh_history",
        ".kube/",
        ".lesshst",
        ".lftp/",
        ".lhistory",
        ".lighttpdpassword",
        ".lldb-history",
        ".local/bin/",
        ".local/lib/",
        ".local/share/",
        ".local/state/",
        ".lynx_cookies",
        ".minikube/",
        ".msmtprc",
        ".my.cnf",
        ".myscmserverinfo",
        ".mysql_history",
        ".nano_history",
        ".netrc",
        ".node_repl_history",
        ".npm/",
        ".npmrc",
        ".nsconfig",
        ".nsr",
        ".nvm/",
        ".oh-my-",
        ".pass",
        ".passwd",
        ".password-store",
        ".pearrc",
        ".pgpass",
        ".php_history",
        ".pinerc",
        ".pki/",
        ".proclog",
        ".procmailrc",
        ".profile",
        ".psql_history",
        ".pwd",
        ".pytest_cache/",
        ".python_history",
        ".rediscli_history",
        ".remote-sync.json",
        ".rhistory",
        ".rhosts",
        ".rustup",
        ".s3cfg",
        ".secrets",
        ".selected_editor",
        ".settings/",
        ".sh_history",
        ".snap/",
        ".sqlite_history",
        ".ssh/",
        ".subversion/",
        ".svn/",
        ".svnignore",
        ".tconn/",
        ".tcshrc",
        ".terraform.lock.hcl",
        ".terraform/",
        ".thunderbird/",
        ".tmux.conf",
        ".tools/",
        ".tor/",
        ".travis.yaml",
        ".travis.yml",
        ".vagrant.d/",
        ".vidalia/",
        ".vim/",
        ".viminfo",
        ".vimrc",
        ".vmware/",
        ".vscode",
        ".web.config.swp",
        ".wget-hsts",
        ".www_acl",
        ".wwwacl",
        ".xauthority",
        ".yarnrc",
        ".zhistory",
        ".zsh_history",
        ".zshenv",
        ".zshrc",
        "config.asp",
        "config_dev.asp",
        "config-dev.asp",
        "config.dev.asp",
        "config_prod.asp",
        "config-prod.asp",
        "config.prod.asp",
        "config.sample.asp",
        "config-sample.asp",
        "config_sample.asp",
        "config_test.asp",
        "config-test.asp",
        "config.test.asp",
        "config.ini",
        "config_dev.ini",
        "config-dev.ini",
        "config.dev.ini",
        "config_prod.ini",
        "config-prod.ini",
        "config.prod.ini",
        "config.sample.ini",
        "config-sample.ini",
        "config_sample.ini",
        "config_test.ini",
        "config-test.ini",
        "config.test.ini",
        "config.json",
        "config_dev.json",
        "config-dev.json",
        "config.dev.json",
        "config_prod.json",
        "config-prod.json",
        "config.prod.json",
        "config.sample.json",
        "config-sample.json",
        "config_sample.json",
        "config_test.json",
        "config-test.json",
        "config.test.json",
        "config.php",
        "config_dev.php",
        "config-dev.php",
        "config.dev.php",
        "config_prod.php",
        "config-prod.php",
        "config.prod.php",
        "config.sample.php",
        "config-sample.php",
        "config_sample.php",
        "config_test.php",
        "config-test.php",
        "config.test.php",
        "config.pl",
        "config_dev.pl",
        "config-dev.pl",
        "config.dev.pl",
        "config_prod.pl",
        "config-prod.pl",
        "config.prod.pl",
        "config.sample.pl",
        "config-sample.pl",
        "config_sample.pl",
        "config_test.pl",
        "config-test.pl",
        "config.test.pl",
        "config.py",
        "config_dev.py",
        "config-dev.py",
        "config.dev.py",
        "config_prod.py",
        "config-prod.py",
        "config.prod.py",
        "config.sample.py",
        "config-sample.py",
        "config_sample.py",
        "config_test.py",
        "config-test.py",
        "config.test.py",
        "config.rb",
        "config_dev.rb",
        "config-dev.rb",
        "config.dev.rb",
        "config_prod.rb",
        "config-prod.rb",
        "config.prod.rb",
        "config.sample.rb",
        "config-sample.rb",
        "config_sample.rb",
        "config_test.rb",
        "config-test.rb",
        "config.test.rb",
        "config.toml",
        "config_dev.toml",
        "config-dev.toml",
        "config.dev.toml",
        "config_prod.toml",
        "config-prod.toml",
        "config.prod.toml",
        "config.sample.toml",
        "config-sample.toml",
        "config_sample.toml",
        "config_test.toml",
        "config-test.toml",
        "config.test.toml",
        "config.txt",
        "config_dev.txt",
        "config-dev.txt",
        "config.dev.txt",
        "config_prod.txt",
        "config-prod.txt",
        "config.prod.txt",
        "config.sample.txt",
        "config-sample.txt",
        "config_sample.txt",
        "config_test.txt",
        "config-test.txt",
        "config.test.txt",
        "config.xml",
        "config_dev.xml",
        "config-dev.xml",
        "config.dev.xml",
        "config_prod.xml",
        "config-prod.xml",
        "config.prod.xml",
        "config.sample.xml",
        "config-sample.xml",
        "config_sample.xml",
        "config_test.xml",
        "config-test.xml",
        "config.test.xml",
        "config.yaml",
        "config_dev.yaml",
        "config-dev.yaml",
        "config.dev.yaml",
        "config_prod.yaml",
        "config-prod.yaml",
        "config.prod.yaml",
        "config.sample.yaml",
        "config-sample.yaml",
        "config_sample.yaml",
        "config_test.yaml",
        "config-test.yaml",
        "config.test.yaml",
        "config.yml",
        "config_dev.yml",
        "config-dev.yml",
        "config.dev.yml",
        "config_prod.yml",
        "config-prod.yml",
        "config.prod.yml",
        "config.sample.yml",
        "config-sample.yml",
        "config_sample.yml",
        "config_test.yml",
        "config-test.yml",
        "config.test.yml",
        "config.sample.inc.php",
        "credentials.json",
        "secrets.json",
        "secrets.yaml",
        "secrets.yml",
        ".sql.001",
        ".sql.7z",
        ".sql.bz",
        ".sql.ace",
        ".sql.arj",
        ".sql.cpio",
        ".sql.gz",
        ".sql.lha",
        ".sql.lz",
        ".sql.pa",
        ".sql.pea",
        ".sql.r00",
        ".sql.r01",
        ".sql.r02",
        ".sql.r03",
        ".sql.r04",
        ".sql.r05",
        ".sql.r06",
        ".sql.r07",
        ".sql.r08",
        ".sql.r09",
        ".sql.rar",
        ".sql.rev",
        ".sql.tar",
        ".sql.taz",
        ".sql.tbz",
        ".sql.tgz",
        ".sql.txz",
        ".sql.uha",
        ".sql.xz",
        ".sql.yz1",
        ".sql.z",
        "gitlab.rb",
        "gitlab_config_",
        "initial_root_password",
        "aws.yaml",
        "aws.yml",
        "aws-key.yaml",
        "aws-key.yml",
        "/auth.json",
        "/debug.log",
        "/error.log",
        "/errors.log",
        "wp-config.",
        "wp-config-",
        "wp-config_",
        "/config/parameters.yml",
        "/config/routing.yml",
        "/config/security.yml",
        "/config/services.yml",
        "/sites/default/default.settings.php",
        "/sites/default/settings.php",
        "/sites/default/settings.local.php",
        "/config/settings.inc.php",
        "/app/config/parameters.php",
        "/app/etc/env.php",
        "/app/etc/local.xml",
        "/Web.config",
        "/package.json",
        "/package-lock.json",
        "/npm-shrinkwrap.json",
        "/gruntfile.js",
        "/npm-debug.log",
        "/webpack.config.js",
        "/yarn.lock",
        "/composer.json",
        "/composer.lock",
        "/packages.json",
        "/.DS_Store",
        "/.ws_ftp.ini",
        ".idea",
        "nbproject/",
        "bower.json",
        ".bowerrc",
        ".eslintrc",
        ".jshintrc",
        ".gitlab-ci.yml",
        ".travis.yml",
        "database.yaml",
        "database.yml",
        "Dockerfile",
        ".php_cs.dist",
        ".phpcs.xml",
        "phpcs.xml",
        ".phpcs.xml.dist",
        "phpcs.xml.dist",
        "Desktop.ini",
        "Thumbs.db",
        ".user.ini",
        "php.ini",
        "weblogic.xml",
        "php_error.log",
        "php_errors.log",
        "META-INF/",
        "WEB-INF/",
        "sslvpn_websession",
        "BlockCypher.log",
        "config.inc.php",
        "config.sample.php",
        "defaults.inc.php",
        "sendgrid.env",
        ".fish",
        "fish_variables",
        "ldap-authentication-report.csv",
        "user_secrets.yml",
        "secrets.json",
        "compose.yml",
        "compose.yaml",
        "phpinfo.php",
        "__pycache__/",
        "boot.ini",
        "system.ini",
        "win.ini",
        "pm2.log",
        "debug.log",
        "debian.cnf",
        "my.cnf",
        "mysql.cnf",
        "mysqldump.cnf",
        "ftp-sync.json",
        "yarn-debug.log",
        "yarn-error.log",
        "coverage.xml",
        "proc/0",
        "proc/1",
        "proc/2",
        "proc/3",
        "proc/4",
        "proc/5",
        "proc/6",
        "proc/7",
        "proc/8",
        "proc/9",
        "proc/acpi",
        "proc/asound",
        "proc/bootconfig",
        "proc/buddyinfo",
        "proc/bus",
        "proc/cgroups",
        "proc/cmdline",
        "proc/config.gz",
        "proc/consoles",
        "proc/cpuinfo",
        "proc/crypto",
        "proc/devices",
        "proc/diskstats",
        "proc/dma",
        "proc/docker",
        "proc/driver",
        "proc/dynamic_debug",
        "proc/execdomains",
        "proc/fb",
        "proc/filesystems",
        "proc/fs",
        "proc/interrupts",
        "proc/iomem",
        "proc/ioports",
        "proc/ipmi",
        "proc/irq",
        "proc/kallsyms",
        "proc/kcore",
        "proc/key-users",
        "proc/keys",
        "proc/kmsg",
        "proc/kpagecgroup",
        "proc/kpagecount",
        "proc/kpageflags",
        "proc/latency_stats",
        "proc/loadavg",
        "proc/locks",
        "proc/mdstat",
        "proc/meminfo",
        "proc/misc",
        "proc/modules",
        "proc/mounts",
        "proc/mpt",
        "proc/mtd",
        "proc/mtrr",
        "proc/net",
        "proc/pagetypeinfo",
        "proc/partitions",
        "proc/pressure",
        "proc/sched_debug",
        "proc/schedstat",
        "proc/scsi",
        "proc/self",
        "proc/slabinfo",
        "proc/softirqs",
        "proc/stat",
        "proc/swaps",
        "proc/sys",
        "proc/sysrq-trigger",
        "proc/sysvipc",
        "proc/thread-self",
        "proc/timer_list",
        "proc/timer_stats",
        "proc/tty",
        "proc/uptime",
        "proc/version",
        "proc/version_signature",
        "proc/vmallocinfo",
        "proc/vmstat",
        "proc/zoneinfo",
        "/proc/",
        "sftp.json",
        "sys/block",
        "sys/bus",
        "sys/class",
        "sys/dev",
        "sys/devices",
        "sys/firmware",
        "sys/fs",
        "sys/hypervisor",
        "sys/kernel",
        "sys/module",
        "sys/power",
        "/sys/",
        "/@fs/",
        "/@id/",
        "cargo.toml",
        ".ashrc",
        ".ash_history",
        "config.nu",
        ".csh_history",
        ".kshrc",
        "config.fish",
        ".tcsh_history",
        "pyproject.toml",
        "pytest.ini",
        "go.mod",
        "go.sum",
        "setup.py",
        "build.zig.zon",
        ".screenrc",
        ".chocolatey/",
        ".gradle/",
        ".idlerc/",
        ".kaggle/",
        ".keras/",
        ".mypy_cache/",
        ".redhat/",
        "node_modules/.bin/",
        "node_modules/.cache/",
        ".bun/",
        ".bunfig.toml",
        ".irbrc/",
        ".irb_history",
        ".pryrc/",
        ".gemrc",
        ".gem/",
        ".bundle/",
        ".rbenv/",
        ".rvm/",
        ".rubocop.yml",
        ".pip/",
        ".condarc",
        "anaconda3/",
        "miniconda3/",
        ".pyenv/",
        ".m2/",
        ".sdkman/",
        ".eclipse/",
        ".npm-global/",
        ".yarnrc.yml",
        ".prettierrc",
        ".node-gyp",
        ".curlrc",
        ".wgetrc",
        ".perldb",
        ".perl_repl_history",
        ".perlhistory",
        "perl/lib",
        "perl/bin",
        ".cpan/",
        ".cpanplus/",
        ".plenv",
        ".konan/",
        ".kotlinc_history",
        ".git-credentials",
        ".openvpn/",
        "openvpn/",
        "wg-clients/",
        ".gftp/",
        ".lftprc",
        ".ncftp/",
        ".rsync_exclude",
        "rsync.log",
        ".wine/",
        ".nanorc",
        ".nano/",
        ".pg_service.conf",
        ".mylogin.cnf",
        ".mongodb/",
        ".mongoshrc.js",
        ".dbshell",
        ".pgadmin/",
        ".pm2/",
        ".stubby.yml",
        ".getdns/",
        ".digrc",
        ".unbound/",
        ".mbsyncrc",
        ".offlineimaprc",
        ".getmail/",
        ".usermin/",
        ".cpanel/",
        ".openssl.cnf",
        ".terraformrc",
        ".terraform.d/",
        ".pulumi/",
        ".linode-cli/",
        ".oci/",
        ".opc/",
        ".sqlplus_history",
        "login.sql",
        ".editorconfig",
        ".datadog-agent/",
        ".wp-cli/",
        ".bluemix/",
        ".ibmcloud/"
      ],
      "negated": false
    }
  },
  {
    "id": 930140,
    "msg": "Restricted File Access Attempt: AI Coding Assistant Artifact",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi"
    ],
    "targets": [
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "normalizePathWin"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        ".claude/",
        ".cursor/",
        ".continue/",
        ".aider/",
        ".roo/",
        ".zed/",
        ".cline/",
        ".kiro/",
        ".windsurf/",
        ".rovodev/",
        ".codex/",
        ".opencode/",
        ".a0proj/",
        ".plandex/",
        ".fabric/",
        ".n8n/",
        ".junie/",
        ".gemini/",
        ".openclaw/",
        ".clawdbot/",
        ".trustclaw/",
        ".zeroclaw/",
        ".warp/",
        ".qwen_code",
        ".crush"
      ],
      "negated": false
    }
  },
  {
    "id": 931100,
    "msg": "Possible Remote File Inclusion (RFI) Attack: URL Parameter using IP Address",
    "severity": "CRITICAL",
    "tags": [
      "attack-rfi"
    ],
    "targets": [
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "^(f(?:ile|tps?)|https?|ssh)://(?:\\[?[0-9a-f]+:[0-:a-f]+\\]?|[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 931110,
    "msg": "Possible Remote File Inclusion (RFI) Attack: Common RFI Vulnerable Parameter Name used w/URL Payload",
    "severity": "CRITICAL",
    "tags": [
      "attack-rfi"
    ],
    "targets": [
      "QUERY_STRING"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "(?:\\binclude[\\t-\\r \\x0b]*\\([^\\)]*|mosConfig_absolute_path|(?:_(?:CONF\\[path|SERVER\\[DOCUMENT_ROOT)|path\\[docroot|config\\[root_dir)\\]|GALLERY_BASEDIR|appserv_root)=(?:f(?:ile|tps?)|https?)://",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 931120,
    "msg": "Possible Remote File Inclusion (RFI) Attack: URL Payload Used w/Trailing Question Mark Character (?)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rfi"
    ],
    "targets": [
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "^(?:file|ftps?|https?).*?\\?+$",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932230,
    "msg": "Remote Command Execution: Unix Command Injection (2-3 chars)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|[ls][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e|n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|[\\n\\r;=`\\{]|\\|\\|?|&&?|^\\x5c|\\$(?:\\(\\(?|[\\[\\{])|<(?:\\(|<<)|>\\(|\\([\\t-\\r \\x0b]*\\))[\\t-\\r \\x0b]*(?:[!\\$\\(\\{][\\t-\\r \\x0b]*|(?:[0-9A-Z_a-z]+=[^\\t-\\r \\x0b]+|\\$[0-9A-Z_a-z]+)[\\t-\\r \\x0b]+)*[\\t-\\r \\x0b]*[\"']*(?:[\"'-\\+\\--9\\?A-\\]_a-z\\|]+/)?[\"'\\x5c]*(?:(?:7[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[arx][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?|(?:b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z|c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[89][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?9|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)|d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?f|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|q[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)|f[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:g|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s|q)|[kz][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r|p[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|k[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?g|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z)|r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|(?:s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?h|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n)|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c|b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:3[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m|c)|x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|z)|y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?|l[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?|z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:4[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?))[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?-[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?(?:[&\\),<>\\|]{1,10}|(?:[\\-\\.0-9A-Z_a-z][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?){1,10}[\\t-\\r \\x0b&\\),<>\\|\\}]{1,10})|r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*)|g[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?(?:[&\\),<>\\|]{1,10}|(?:[\\-\\.0-9A-Z_a-z][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?){1,10}[\\t-\\r \\x0b&\\),<>\\|\\}]{1,10})|(?:d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|[hr][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c|p[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?g)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*))\\b",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932235,
    "msg": "Remote Command Execution: Unix Command Injection (command without evasion)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|[ls][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e|n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|[\\n\\r;=`\\{]|\\|\\|?|&&?|^\\x5c|\\$(?:\\(\\(?|[\\[\\{])|<(?:\\(|<<)|>\\(|\\([\\t-\\r \\x0b]*\\))[\\t-\\r \\x0b]*(?:[!\\$\\(\\{][\\t-\\r \\x0b]*|(?:[0-9A-Z_a-z]+=[^\\t-\\r \\x0b]+|\\$[0-9A-Z_a-z]+)[\\t-\\r \\x0b]+)*[\\t-\\r \\x0b]*[\"']*(?:[\"'-\\+\\--9\\?A-\\]_a-z\\|]+/)?[\"'\\x5c]*(?:(?:HEAD|POST|y(?:arn|elp))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|a(?:dd(?:group|user)|getty|(?:l(?:ias|pine)|tobm|xel)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|nsible|p(?:parmor_[^\\t-\\r \\x0b]{1,10}\\b|t(?:-get|itude[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|r(?:ch[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ia2c|j(?:-register|disp))|s(?:cii(?:-xfr|85)|pell)|u(?:ditctl|repot|search))|b(?:a(?:s(?:e(?:32|64[\"']?[\\t-\\r \\x0b&\\),<>\\|]|n(?:ame[\"']?[\\t-\\r \\x0b&\\),<>\\|]|c))|h[\"']?[\\t-\\r \\x0b&\\),<>\\|])|tch[\"']?[\\t-\\r \\x0b&\\),<>\\|])|lkid[\"']?[\\t-\\r \\x0b&\\),<>\\|]|pftrace|r(?:eaksw|(?:idge|wap)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|sd(?:cat|iff|tar)|u(?:iltin|n(?:dler[\"']?[\\t-\\r \\x0b&\\),<>\\|]|zip2)|s(?:ctl|ybox))|y(?:ebug|obu[\"']?[\\t-\\r \\x0b&\\),<>\\|])|z(?:c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|e(?:grep|xe[\"']?[\\t-\\r \\x0b&\\),<>\\|])|f?grep|ip2(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|recover)|less|more))|c(?:[89]9-gcc|a(?:(?:ncel|psh)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|rgo(?:-(?:audit|miri|watch)|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|ertbot|h(?:(?:(?:att|di)r|mod|o(?:om|wn)|root|sh)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:ck_(?:by_ssh|cups|log|memory|raid|s(?:sl_cert|tatusfile))|f(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|(?:flag|pas)s|g(?:passwd|rp[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|l(?:ang(?:\\+\\+|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|ippy-driver)|o(?:bc(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|run)|(?:lumn|m(?:m(?:and)?|p(?:oser|ress)))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|proc|w(?:say|think))|p(?:(?:an|io)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ulimit)|r(?:ash[\"']?[\\t-\\r \\x0b&\\),<>\\|]|on(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|tab))|s(?:cli[\"']?[\\t-\\r \\x0b&\\),<>\\|]|plit|vtool)|u(?:psfilter|rl[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|d(?:(?:ash|i(?:alog|ff)|vips)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|hclient|m(?:esg[\"']?[\\t-\\r \\x0b&\\),<>\\|]|idecode|setup)|o(?:(?:as|ne)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|cker(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|sbox)|pkg(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|e(?:2fsck|asy_install|(?:cho|fax|grep|macs|sac|val)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|n(?:d(?:if|sw)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|v-update)|x(?:(?:ec|p(?:and|(?:ec|or)t|r))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|iftool))|f(?:acter|d(?:(?:find|isk)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|u?mount)|(?:etch|grep|lock|unction)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|i(?:le(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|test)|(?:n(?:d|ger)|sh)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|o(?:ld[\"']?[\\t-\\r \\x0b&\\),<>\\|]|reach)|ping(?:6|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|tp(?:stats|who))|g(?:(?:awk|core|i(?:mp|nsh)|z(?:cat|exe|ip))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:ni(?:e[\"']?[\\t-\\r \\x0b&\\),<>\\|]|soimage)|t(?:cap|facl[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|hc(?:-[\"']?[\\t-\\r \\x0b&\\),<>\\|]|i(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|r(?:(?:cat|ep)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|oupmod)|tester|unzip)|h(?:(?:ash|i(?:ghlight|story))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:ad[\"']?[\\t-\\r \\x0b&\\),<>\\|]|xdump)|ost(?:id|name)|ping3|t(?:digest|op[\"']?[\\t-\\r \\x0b&\\),<>\\|]|passwd))|i(?:(?:conv|nstall)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|f(?:config|top[\"']?[\\t-\\r \\x0b&\\),<>\\|])|onice|p(?:6?tables|config|p(?:eveprinter|find|tool))|spell)|j(?:(?:ava|exec)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|o(?:in[\"']?[\\t-\\r \\x0b&\\),<>\\|]|urnalctl)|runscript)|k(?:ill(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|all)|nife[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sshell)|l(?:(?:a(?:st(?:comm|log(?:in)?)|tex)|ynx)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|dconfig|ess(?:echo|(?:fil|pip)e)|ftp(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|get)|o(?:(?:cate|ok)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|g(?:inctl|(?:nam|sav)e)|setup)|s(?:(?:-F|cpu|hw|mod|of|pci|usb)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|b_release)|trace|ua(?:la)?tex|wp-(?:d(?:ownload|ump)|mirror|request)|z(?:4c(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|at)|c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|[ef]?grep|less|m(?:a(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|dec|info)|ore)))|m(?:(?:a(?:il[qx]?|ke|wk)|utt)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|k(?:(?:dir|nod)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|fifo|temp)|locate|o(?:squitto|unt[\"']?[\\t-\\r \\x0b&\\),<>\\|])|sg(?:attrib|c(?:at|onv)|filter|merge|uniq)|ysql(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|admin|dump(?:slow)?|hotcopy|show))|n(?:(?:a(?:no|sm|wk)|ice|map|o(?:de|hup)|ping|roff)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|c(?:\\.(?:openbsd|traditional)|at[\"']?[\\t-\\r \\x0b&\\),<>\\|])|e(?:ofetch|t(?:(?:c|st)at|kit-ftp|plan))|s(?:enter|lookup|tat[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|o(?:ctave[\"']?[\\t-\\r \\x0b&\\),<>\\|]|nintr|p(?:en(?:ssl|v(?:pn|t))|kg[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|p(?:a(?:(?:cman|rted|tch)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|s(?:swd|te[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|d(?:b(?:2mb|3(?:\\.|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|f(?:la)?tex|ksh[\"']?[\\t-\\r \\x0b&\\),<>\\|])|er(?:(?:f|ms)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|l(?:5?[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sh))|(?:(?:ft|gre)p|opd|u(?:ppet|shd))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|hp(?:-cgi|[57][\"']?[\\t-\\r \\x0b&\\),<>\\|])|i(?:co(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|nv)|dstat|(?:gz|ng6?)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|k(?:exec|g_?info|ill[\"']?[\\t-\\r \\x0b&\\),<>\\|])|rint(?:env|f[\"']?[\\t-\\r \\x0b&\\),<>\\|])|s(?:(?:ed|ql)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ftp)|tar(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|grep)|y(?:3?versions|thon(?:[23]|[^\\t-\\r \\x0b]{1,10}\\b)))|r(?:(?:ak[eu]|bash|nano|oute|vi(?:ew|m))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:a(?:delf|lpath)|(?:(?:boo|dcarpe)t|name|p(?:eat|lace))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|stic)|l(?:ogin|wrap)|m(?:dir[\"']?[\\t-\\r \\x0b&\\),<>\\|]|t-(?:dump|tar)|user)|pm(?:db[\"']?[\\t-\\r \\x0b&\\),<>\\|]|(?:quer|verif)y)|sync(?:-ssl|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|u(?:by[^\\t-\\r \\x0b]{1,10}\\b|n(?:-(?:mailcap|parts)|c[\"']?[\\t-\\r \\x0b&\\),<>\\|])|st(?:-(?:analyzer|(?:g|ll)db)|c[\"']?[\\t-\\r \\x0b&\\),<>\\|]|doc|fmt|up)))|s(?:(?:ash|c(?:hed|r(?:een|ipt))|diff|(?:ft|na)p|l(?:eep|sh)|plit)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:(?:ndmail|rvice)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|t(?:arch|cap|env|facl[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sid))|h(?:\\.distrib|(?:red|u(?:f|tdown))[\"']?[\\t-\\r \\x0b&\\),<>\\|])|mbclient|o(?:(?:ca|r)t[\"']?[\\t-\\r \\x0b&\\),<>\\|]|elim)|qlite3|sh(?:-(?:a(?:dd|gent)|copy-id|key(?:ge|sca)n)|pass)|t(?:a(?:rt-stop-daemon|t[\"']?[\\t-\\r \\x0b&\\),<>\\|])|dbuf|r(?:ace|ings[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|udo(?:-rs|[\"']?[\\t-\\r \\x0b&\\),<>\\|]|_|edit|replay)|vn(?:a(?:dmin|uthz)|bench|dumpfilter|fsfs|look|mucc|rdump|s(?:erve|ync)|version)|ys(?:ctl|tem(?:ctl|d-resolve)))|t(?:a(?:ilf?[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sk(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|set))|c(?:l?sh[\"']?[\\t-\\r \\x0b&\\),<>\\|]|p(?:dump|ing|traceroute))|elnet|(?:ftp|mux|ouch)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ime(?:datectl|out[\"']?[\\t-\\r \\x0b&\\),<>\\|])|r(?:a(?:ceroute6?|p[\"']?[\\t-\\r \\x0b&\\),<>\\|])|off[\"']?[\\t-\\r \\x0b&\\),<>\\|])|shark)|u(?:(?:conv|limit)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|n(?:(?:ame|compress|iq|rar|s(?:et|hare)|xz)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|expand|l(?:ink[\"']?[\\t-\\r \\x0b&\\),<>\\|]|z(?:4[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ma))|pigz|z(?:ip[\"']?[\\t-\\r \\x0b&\\),<>\\|]|std))|p(?:2date[\"']?[\\t-\\r \\x0b&\\),<>\\|]|date-alternatives)|ser(?:(?:ad|mo)d|del)|u(?:de|en)code)|v(?:algrind|i(?:(?:[ep]w|gr|rsh)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|mdiff|sudo(?:-rs)?)|olatility[\"']?[\\t-\\r \\x0b&\\),<>\\|])|w(?:(?:all|get)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|h(?:iptail[\"']?[\\t-\\r \\x0b&\\),<>\\|]|o(?:ami|is[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|i(?:reshark|sh[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|x(?:(?:args|pad|term)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:latex|tex[\"']?[\\t-\\r \\x0b&\\),<>\\|])|mo(?:dmap|re[\"']?[\\t-\\r \\x0b&\\),<>\\|])|z(?:c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|d(?:ec[\"']?[\\t-\\r \\x0b&\\),<>\\|]|iff)|[ef]?grep|less|more))|z(?:athura|(?:c(?:at|mp)|diff|grep|less|run)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|[ef]grep|ip(?:c(?:loak|mp)|details|grep|info|(?:merg|not)e|split|tool)|mo(?:dload|re[\"']?[\\t-\\r \\x0b&\\),<>\\|])|s(?:oelim|td(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|(?:ca|m)t|grep|less))|ypper))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932120,
    "msg": "Remote Command Execution: Windows PowerShell Command Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "cmdLine"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        "powershell",
        "Add-Computer",
        "Add-Content",
        "Add-History",
        "Add-JobTrigger",
        "Add-LocalGroupMember",
        "Add-Member",
        "Add-PSSnapin",
        "Add-Type",
        "Checkpoint-Computer",
        "Clear-Content",
        "Clear-EventLog",
        "Clear-History",
        "Clear-Host",
        "Clear-Item",
        "Clear-ItemProperty",
        "Clear-RecycleBin",
        "Clear-Variable",
        "Compare-Object",
        "Complete-Transaction",
        "Compress-Archive",
        "Connect-PSSession",
        "Connect-WSMan",
        "Convert-Path",
        "Convert-String",
        "ConvertFrom-Csv",
        "ConvertFrom-Json",
        "ConvertFrom-Markdown",
        "ConvertFrom-SddlString",
        "ConvertFrom-SecureString",
        "ConvertFrom-String",
        "ConvertFrom-StringData",
        "ConvertTo-Csv",
        "ConvertTo-Html",
        "ConvertTo-Json",
        "ConvertTo-SecureString",
        "ConvertTo-Xml",
        "Copy-Item",
        "Copy-ItemProperty",
        "Debug-Job",
        "Debug-Process",
        "Debug-Runspace",
        "Disable-ComputerRestore",
        "Disable-ExperimentalFeature",
        "Disable-JobTrigger",
        "Disable-LocalUser",
        "Disable-PSBreakpoint",
        "Disable-PSRemoting",
        "Disable-PSSessionConfiguration",
        "Disable-PSTrace",
        "Disable-PSWSManCombinedTrace",
        "Disable-RunspaceDebug",
        "Disable-ScheduledJob",
        "Disable-WSManCredSSP",
        "Disable-WSManTrace",
        "Disconnect-PSSession",
        "Disconnect-WSMan",
        "Enable-ComputerRestore",
        "Enable-ExperimentalFeature",
        "Enable-JobTrigger",
        "Enable-LocalUser",
        "Enable-PSBreakpoint",
        "Enable-PSRemoting",
        "Enable-PSSessionConfiguration",
        "Enable-PSTrace",
        "Enable-PSWSManCombinedTrace",
        "Enable-RunspaceDebug",
        "Enable-ScheduledJob",
        "Enable-WSManCredSSP",
        "Enable-WSManTrace",
        "Enter-PSHostProcess",
        "Enter-PSSession",
        "Exit-PSHostProcess",
        "Exit-PSSession",
        "Expand-Archive",
        "Export-Alias",
        "Export-BinaryMiLog",
        "Export-Clixml",
        "Export-Console",
        "Export-Counter",
        "Export-Csv",
        "Export-FormatData",
        "Export-ModuleMember",
        "Export-ODataEndpointProxy",
        "Export-PSSession",
        "Find-Command",
        "Find-DscResource",
        "Find-Module",
        "Find-Package",
        "Find-PackageProvider",
        "Find-RoleCapability",
        "Find-Script",
        "ForEach-Object",
        "Format-Custom",
        "Format-Hex",
        "Format-List",
        "Format-Table",
        "Format-Wide",
        "Get-Acl",
        "Get-Alias",
        "Get-AuthenticodeSignature",
        "Get-ChildItem",
        "Get-CimAssociatedInstance",
        "Get-CimClass",
        "Get-CimInstance",
        "Get-CimSession",
        "Get-Clipboard",
        "Get-CmsMessage",
        "Get-Command",
        "Get-ComputerInfo",
        "Get-ComputerRestorePoint",
        "Get-Content",
        "Get-ControlPanelItem",
        "Get-Counter",
        "Get-Credential",
        "Get-Culture",
        "Get-Date",
        "Get-Error",
        "Get-Event",
        "Get-EventLog",
        "Get-EventSubscriber",
        "Get-ExecutionPolicy",
        "Get-ExperimentalFeature",
        "Get-FileHash",
        "Get-FormatData",
        "Get-Help",
        "Get-History",
        "Get-Host",
        "Get-HotFix",
        "Get-InstalledModule",
        "Get-InstalledScript",
        "Get-IseSnippet",
        "Get-Item",
        "Get-ItemProperty",
        "Get-ItemPropertyValue",
        "Get-Job",
        "Get-JobTrigger",
        "Get-LocalGroup",
        "Get-LocalGroupMember",
        "Get-LocalUser",
        "Get-Location",
        "Get-LogProperties",
        "Get-MarkdownOption",
        "Get-Member",
        "Get-Module",
        "Get-OperationValidation",
        "Get-PSBreakpoint",
        "Get-PSCallStack",
        "Get-PSDrive",
        "Get-PSHostProcessInfo",
        "Get-PSProvider",
        "Get-PSReadLineKeyHandler",
        "Get-PSReadLineOption",
        "Get-PSRepository",
        "Get-PSSession",
        "Get-PSSessionCapability",
        "Get-PSSessionConfiguration",
        "Get-PSSnapin",
        "Get-PSSubsystem",
        "Get-Package",
        "Get-PackageProvider",
        "Get-PackageSource",
        "Get-PfxCertificate",
        "Get-Process",
        "Get-Random",
        "Get-Runspace",
        "Get-RunspaceDebug",
        "Get-ScheduledJob",
        "Get-ScheduledJobOption",
        "Get-Service",
        "Get-TimeZone",
        "Get-TraceSource",
        "Get-Transaction",
        "Get-TypeData",
        "Get-UICulture",
        "Get-Unique",
        "Get-Uptime",
        "Get-Variable",
        "Get-Verb",
        "Get-WSManCredSSP",
        "Get-WSManInstance",
        "Get-WinEvent",
        "Get-WmiObject",
        "Group-Object",
        "Import-Alias",
        "Import-BinaryMiLog",
        "Import-Clixml",
        "Import-Counter",
        "Import-Csv",
        "Import-IseSnippet",
        "Import-LocalizedData",
        "Import-Module",
        "Import-PSSession",
        "Import-PackageProvider",
        "Import-PowerShellDataFile",
        "Install-Module",
        "Install-Package",
        "Install-PackageProvider",
        "Install-Script",
        "Invoke-AsWorkflow",
        "Invoke-CimMethod",
        "Invoke-Command",
        "Invoke-Expression",
        "Invoke-History",
        "Invoke-Item",
        "Invoke-OperationValidation",
        "Invoke-RestMethod",
        "Invoke-WSManAction",
        "Invoke-WebRequest",
        "Invoke-WmiMethod",
        "Join-Path",
        "Join-String",
        "Limit-EventLog",
        "Measure-Command",
        "Measure-Object",
        "Move-Item",
        "Move-ItemProperty",
        "New-Alias",
        "New-CimInstance",
        "New-CimSession",
        "New-CimSessionOption",
        "New-Event",
        "New-EventLog",
        "New-FileCatalog",
        "New-Guid",
        "New-IseSnippet",
        "New-Item",
        "New-ItemProperty",
        "New-JobTrigger",
        "New-LocalGroup",
        "New-LocalUser",
        "New-Module",
        "New-ModuleManifest",
        "New-Object",
        "New-PSDrive",
        "New-PSRoleCapabilityFile",
        "New-PSSession",
        "New-PSSessionConfigurationFile",
        "New-PSSessionOption",
        "New-PSTransportOption",
        "New-PSWorkflowExecutionOption",
        "New-PSWorkflowSession",
        "New-ScheduledJobOption",
        "New-ScriptFileInfo",
        "New-Service",
        "New-TemporaryFile",
        "New-TimeSpan",
        "New-Variable",
        "New-WSManInstance",
        "New-WSManSessionOption",
        "New-WebServiceProxy",
        "New-WinEvent",
        "Out-Default",
        "Out-File",
        "Out-GridView",
        "Out-Host",
        "Out-Null",
        "Out-Printer",
        "Out-String",
        "Pop-Location",
        "Protect-CmsMessage",
        "Publish-Module",
        "Publish-Script",
        "Push-Location",
        "Read-Host",
        "Receive-Job",
        "Receive-PSSession",
        "Register-ArgumentCompleter",
        "Register-CimIndicationEvent",
        "Register-EngineEvent",
        "Register-ObjectEvent",
        "Register-PSRepository",
        "Register-PSSessionConfiguration",
        "Register-PackageSource",
        "Register-ScheduledJob",
        "Register-WmiEvent",
        "Remove-Alias",
        "Remove-CimInstance",
        "Remove-CimSession",
        "Remove-Computer",
        "Remove-Event",
        "Remove-EventLog",
        "Remove-Item",
        "Remove-ItemProperty",
        "Remove-Job",
        "Remove-JobTrigger",
        "Remove-LocalGroup",
        "Remove-LocalGroupMember",
        "Remove-LocalUser",
        "Remove-Module",
        "Remove-PSBreakpoint",
        "Remove-PSDrive",
        "Remove-PSReadLineKeyHandler",
        "Remove-PSSession",
        "Remove-PSSnapin",
        "Remove-Service",
        "Remove-TypeData",
        "Remove-Variable",
        "Remove-WSManInstance",
        "Remove-WmiObject",
        "Rename-Computer",
        "Rename-Item",
        "Rename-ItemProperty",
        "Rename-LocalGroup",
        "Rename-LocalUser",
        "Reset-ComputerMachinePassword",
        "Resolve-Path",
        "Restart-Computer",
        "Restart-Service",
        "Restore-Computer",
        "Resume-Job",
        "Resume-Service",
        "Save-Help",
        "Save-Module",
        "Save-Package",
        "Save-Script",
        "Select-Object",
        "Select-String",
        "Select-Xml",
        "Send-MailMessage",
        "Set-Acl",
        "Set-Alias",
        "Set-AuthenticodeSignature",
        "Set-CimInstance",
        "Set-Clipboard",
        "Set-Content",
        "Set-Date",
        "Set-ExecutionPolicy",
        "Set-Item",
        "Set-ItemProperty",
        "Set-JobTrigger",
        "Set-LocalGroup",
        "Set-LocalUser",
        "Set-Location",
        "Set-LogProperties",
        "Set-MarkdownOption",
        "Set-PSBreakpoint",
        "Set-PSDebug",
        "Set-PSReadLineKeyHandler",
        "Set-PSReadLineOption",
        "Set-PSRepository",
        "Set-PSSessionConfiguration",
        "Set-PackageSource",
        "Set-ScheduledJob",
        "Set-ScheduledJobOption",
        "Set-Service",
        "Set-StrictMode",
        "Set-TimeZone",
        "Set-TraceSource",
        "Set-Variable",
        "Set-WSManInstance",
        "Set-WSManQuickConfig",
        "Set-WmiInstance",
        "Show-Command",
        "Show-ControlPanelItem",
        "Show-EventLog",
        "Show-Markdown",
        "Sort-Object",
        "Split-Path",
        "Start-Job",
        "Start-Process",
        "Start-Service",
        "Start-Sleep",
        "Start-ThreadJob",
        "Start-Trace",
        "Start-Transaction",
        "Start-Transcript",
        "Stop-Computer",
        "Stop-Job",
        "Stop-Process",
        "Stop-Service",
        "Stop-Trace",
        "Stop-Transcript",
        "Suspend-Job",
        "Suspend-Service",
        "Switch-Process",
        "Tee-Object",
        "Test-ComputerSecureChannel",
        "Test-Connection",
        "Test-FileCatalog",
        "Test-Json",
        "Test-ModuleManifest",
        "Test-PSSessionConfigurationFile",
        "Test-Path",
        "Test-ScriptFileInfo",
        "Test-WSMan",
        "Trace-Command",
        "Unblock-File",
        "Undo-Transaction",
        "Uninstall-Module",
        "Uninstall-Package",
        "Uninstall-Script",
        "Unprotect-CmsMessage",
        "Unregister-Event",
        "Unregister-PSRepository",
        "Unregister-PSSessionConfiguration",
        "Unregister-PackageSource",
        "Unregister-ScheduledJob",
        "Update-FormatData",
        "Update-Help",
        "Update-List",
        "Update-Module",
        "Update-ModuleManifest",
        "Update-Script",
        "Update-ScriptFileInfo",
        "Update-TypeData",
        "Use-Transaction",
        "Wait-Debugger",
        "Wait-Event",
        "Wait-Job",
        "Wait-Process",
        "Where-Object",
        "Write-Debug",
        "Write-Error",
        "Write-EventLog",
        "Write-Host",
        "Write-Information",
        "Write-Output",
        "Write-Progress",
        "Write-Verbose",
        "Write-Warning"
      ],
      "negated": false
    }
  },
  {
    "id": 932125,
    "msg": "Remote Command Execution: Windows Powershell Alias Command Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:[\\n\\r;`\\{]|\\|\\|?|&&?)[\\t-\\r \\x0b]*[\\t-\\r \\x0b\"'\\(,@]*(?:[\"'\\.-9A-Z_a-z]+/|(?:[\"'\\x5c\\^]*[0-9A-Z_a-z][\"'\\x5c\\^]*:.*|[ \"'\\.-9A-Z\\x5c\\^_a-z]*)\\x5c)?[\"\\^]*(?:(?:a[\"\\^]*(?:c|s[\"\\^]*n[\"\\^]*p)|e[\"\\^]*(?:b[\"\\^]*p|p[\"\\^]*(?:a[\"\\^]*l|c[\"\\^]*s[\"\\^]*v|s[\"\\^]*n)|[tx][\"\\^]*s[\"\\^]*n)|f[\"\\^]*(?:[cltw]|o[\"\\^]*r[\"\\^]*e[\"\\^]*a[\"\\^]*c[\"\\^]*h)|i[\"\\^]*(?:[cr][\"\\^]*m|e[\"\\^]*x|h[\"\\^]*y|i|p[\"\\^]*(?:a[\"\\^]*l|c[\"\\^]*s[\"\\^]*v|m[\"\\^]*o|s[\"\\^]*n)|s[\"\\^]*e|w[\"\\^]*(?:m[\"\\^]*i|r))|m[\"\\^]*(?:[dpv]|o[\"\\^]*u[\"\\^]*n[\"\\^]*t)|o[\"\\^]*g[\"\\^]*v|p[\"\\^]*(?:o[\"\\^]*p|u[\"\\^]*s[\"\\^]*h)[\"\\^]*d|t[\"\\^]*r[\"\\^]*c[\"\\^]*m|w[\"\\^]*j[\"\\^]*b)[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|c[\"\\^]*(?:(?:(?:d|h[\"\\^]*d[\"\\^]*i[\"\\^]*r|v[\"\\^]*p[\"\\^]*a)[\"\\^]*|p[\"\\^]*(?:[ip][\"\\^]*)?)[\\t-\\r \\x0b,\\./;<>].*|l[\"\\^]*(?:(?:[cipv]|h[\"\\^]*y)[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|s)|n[\"\\^]*s[\"\\^]*n)|d[\"\\^]*(?:(?:b[\"\\^]*p|e[\"\\^]*l|i[\"\\^]*(?:f[\"\\^]*f|r))[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|n[\"\\^]*s[\"\\^]*n)|g[\"\\^]*(?:(?:(?:(?:a[\"\\^]*)?l|b[\"\\^]*p|d[\"\\^]*r|h[\"\\^]*y|(?:w[\"\\^]*m[\"\\^]*)?i|j[\"\\^]*b|[uv])[\"\\^]*|c[\"\\^]*(?:[ims][\"\\^]*)?|m[\"\\^]*(?:o[\"\\^]*)?|s[\"\\^]*(?:n[\"\\^]*(?:p[\"\\^]*)?|v[\"\\^]*))[\\t-\\r \\x0b,\\./;<>].*|e[\"\\^]*r[\"\\^]*r|p[\"\\^]*(?:(?:s[\"\\^]*)?[\\t-\\r \\x0b,\\./;<>].*|v))|l[\"\\^]*s|n[\"\\^]*(?:(?:a[\"\\^]*l|d[\"\\^]*r|[iv]|m[\"\\^]*o|s[\"\\^]*n)[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|p[\"\\^]*s[\"\\^]*s[\"\\^]*c)|r[\"\\^]*(?:(?:(?:(?:b[\"\\^]*)?p|e[\"\\^]*n|(?:w[\"\\^]*m[\"\\^]*)?i|j[\"\\^]*b|n[\"\\^]*[ip])[\"\\^]*|d[\"\\^]*(?:r[\"\\^]*)?|m[\"\\^]*(?:(?:d[\"\\^]*i[\"\\^]*r|o)[\"\\^]*)?|s[\"\\^]*n[\"\\^]*(?:p[\"\\^]*)?|v[\"\\^]*(?:p[\"\\^]*a[\"\\^]*)?)[\\t-\\r \\x0b,\\./;<>].*|c[\"\\^]*(?:j[\"\\^]*b[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|s[\"\\^]*n)|u[\"\\^]*j[\"\\^]*b)|s[\"\\^]*(?:(?:(?:a[\"\\^]*(?:j[\"\\^]*b|l|p[\"\\^]*s|s[\"\\^]*v)|b[\"\\^]*p|[cv]|w[\"\\^]*m[\"\\^]*i)[\"\\^]*|l[\"\\^]*(?:s[\"\\^]*)?|p[\"\\^]*(?:(?:j[\"\\^]*b|p[\"\\^]*s|s[\"\\^]*v)[\"\\^]*)?)[\\t-\\r \\x0b,\\./;<>].*|h[\"\\^]*c[\"\\^]*m|u[\"\\^]*j[\"\\^]*b))(?:\\.[\"\\^]*[0-9A-Z_a-z]+)?\\b",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932130,
    "msg": "Remote Command Execution: Unix Shell Expression Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "cmdLine"
    ],
    "op": {
      "type": "rx",
      "source": "\\$(?:\\((?:[^\\)]+|\\([^\\)]+\\))\\)|\\{[^\\}]+\\}|\\[[^\\]]*\\])|[<>]\\([^\\)]+\\)|/[0-9A-Z_a-z]*\\[[^\\]]+\\]",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932140,
    "msg": "Remote Command Execution: Windows FOR/IF Command Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "cmdLine"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:for(?:/[dflr].*)? %+[^ ]+ in\\(.*\\)[\\t-\\r \\x0b]?do|if(?:/i)?(?: not)?(?: (?:e(?:xist|rrorlevel)|defined|cmdextversion)\\b|[ \\(].*(?:\\b(?:g(?:eq|tr)|equ|neq|l(?:eq|ss))\\b|==)))",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932270,
    "msg": "Remote Command Execution: Unix Shell Expression Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "cmdLine"
    ],
    "op": {
      "type": "rx",
      "source": "~[\\+\\-](?:$|[0-9]+)",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932280,
    "msg": "Remote Command Execution: Brace Expansion Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "\\{[0-9A-Z_a-z]*,[,\\-0-9A-Z_a-z]*\\}",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932250,
    "msg": "Remote Command Execution: Direct Unix Command Execution",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:^(?:json\\.|\\x5c)?|b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|[ls][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e|n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|[\\n\\r;=`\\{]|\\|\\|?|&&?|\\$(?:\\(\\(?|[\\[\\{])|<(?:\\(|<<)|>\\(|\\([\\t-\\r \\x0b]*\\))[\\t-\\r \\x0b]*(?:[!\\$\\(\\{][\\t-\\r \\x0b]*|(?:[0-9A-Z_a-z]+=[^\\t-\\r \\x0b]+|\\$[0-9A-Z_a-z]+)[\\t-\\r \\x0b]+)*[\\t-\\r \\x0b]*[\"']*(?:[\"'-\\+\\--9\\?A-\\]_a-z\\|]+/)?[\"'\\x5c]*(?:(?:7[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[arx][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?|(?:b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z|c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[89][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?9|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)|d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?f|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|q[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)|f[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:g|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s|q)|[kz][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r|p[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|k[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?g|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?z)|r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|(?:s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?h|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n)|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c|b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:3[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m|c)|x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:x[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|z)|y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?|l[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?|z[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:4[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?)?))[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?-[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?(?:[&\\),<>\\|]{1,10}|(?:[\\-\\.0-9A-Z_a-z][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?){1,10}[\\t-\\r \\x0b&\\),<>\\|\\}]{1,10})|r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?j[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*)|g[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?(?:[&\\),<>\\|]{1,10}|(?:[\\-\\.0-9A-Z_a-z][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?){1,10}[\\t-\\r \\x0b&\\),<>\\|\\}]{1,10})|(?:d[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b|[hr][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c|p[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?g)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932260,
    "msg": "Remote Command Execution: Direct Unix Command Execution",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:^(?:json\\.|\\x5c)?|b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|[ls][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e|n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|[\\n\\r;=`\\{]|\\|\\|?|&&?|\\$(?:\\(\\(?|[\\[\\{])|<(?:\\(|<<)|>\\(|\\([\\t-\\r \\x0b]*\\))[\\t-\\r \\x0b]*(?:[!\\$\\(\\{][\\t-\\r \\x0b]*|(?:[0-9A-Z_a-z]+=[^\\t-\\r \\x0b]+|\\$[0-9A-Z_a-z]+)[\\t-\\r \\x0b]+)*[\\t-\\r \\x0b]*[\"']*(?:[\"'-\\+\\--9\\?A-\\]_a-z\\|]+/)?[\"'\\x5c]*(?:a(?:ddgroup|nsible|pparmor_[^\\t-\\r \\x0b]{1,10}\\b|rj(?:-register|disp)|tobm[\"']?[\\t-\\r \\x0b&\\),<>\\|]|u(?:ditctl|repot|search))|b(?:ase(?:32|64[\"']?[\\t-\\r \\x0b&\\),<>\\|]|nc)|(?:lkid|rwap|yobu)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sd(?:cat|iff|tar)|u(?:iltin|nzip2|sybox)|z(?:c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|e(?:grep|xe[\"']?[\\t-\\r \\x0b&\\),<>\\|])|f?grep|ip2(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|recover)|less|more))|c(?:[89]9-gcc|argo-(?:audit|miri|watch)|h(?:(?:attr|mod|o(?:om|wn)|sh)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ef-|g(?:passwd|rp[\"']?[\\t-\\r \\x0b&\\),<>\\|])|pass)|l(?:ang\\+\\+|ippy-driver)|o(?:bc(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|run)|mm[\"']?[\\t-\\r \\x0b&\\),<>\\|]|proc)|(?:p(?:an|io)|scli)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|d(?:(?:iff|mesg|vips)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|o(?:as[\"']?[\\t-\\r \\x0b&\\),<>\\|]|cker-)|pkg(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|e(?:2fsck|(?:fax|grep|macs|nd(?:if|sw)|sac|xpr)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|f(?:d(?:(?:find|isk)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|u?mount)|grep[\"']?[\\t-\\r \\x0b&\\),<>\\|]|iletest|ping(?:6|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|tp(?:stats|who))|g(?:(?:core|insh|z(?:cat|exe|ip))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|(?:etca|unzi)p|hc(?:-[\"']?[\\t-\\r \\x0b&\\),<>\\|]|i(?:-|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|r(?:(?:cat|ep)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|oupmod))|(?:htop|jexec)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|i(?:(?:conv|ftop)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|pp(?:eveprinter|find|tool))|l(?:ast(?:comm|log(?:in)?)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ess(?:echo|(?:fil|pip)e)|ftp(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|get)|osetup|s(?:(?:-F|cpu|hw|mod|of|pci|usb)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|b_release)|wp-download|z(?:4c(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|at)|c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|[ef]?grep|less|m(?:a(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|dec|info)|ore)))|m(?:a(?:ilq|wk)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|k(?:fifo|nod[\"']?[\\t-\\r \\x0b&\\),<>\\|]|temp)|locate|ysql(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|admin|dump(?:slow)?|hotcopy|show))|n(?:(?:a(?:sm|wk)|(?:ma|ohu)p|ping|roff|stat)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|c(?:\\.(?:openbsd|traditional)|at[\"']?[\\t-\\r \\x0b&\\),<>\\|])|et(?:(?:c|st)at|kit-ftp|plan))|o(?:nintr|pkg[\"']?[\\t-\\r \\x0b&\\),<>\\|])|p(?:d(?:b(?:2mb|3(?:\\.|[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|ksh[\"']?[\\t-\\r \\x0b&\\),<>\\|])|(?:er(?:f|l5?)|(?:ft|gre)p|(?:op|ush)d|s(?:ed|ql))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|hp(?:-cgi|[57][\"']?[\\t-\\r \\x0b&\\),<>\\|])|i(?:conv|(?:gz|ng6)[\"']?[\\t-\\r \\x0b&\\),<>\\|])|k(?:exec|ill[\"']?[\\t-\\r \\x0b&\\),<>\\|])|rint(?:env|f[\"']?[\\t-\\r \\x0b&\\),<>\\|])|tar(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|diff|grep)|y(?:3?versions|thon[23]))|r(?:(?:aku|bash|nano|pmdb|vi(?:ew|m))[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:alpath|boot[\"']?[\\t-\\r \\x0b&\\),<>\\|])|m(?:dir[\"']?[\\t-\\r \\x0b&\\),<>\\|]|t-(?:dump|tar)|user)|sync(?:-ssl|[\"']?[\\t-\\r \\x0b&\\),<>\\|])|u(?:nc[\"']?[\\t-\\r \\x0b&\\),<>\\|]|st(?:-(?:analyzer|(?:g|ll)db)|c[\"']?[\\t-\\r \\x0b&\\),<>\\|]|doc|fmt|up)))|s(?:(?:diff|ftp|lsh|ocat)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|e(?:ndmail[\"']?[\\t-\\r \\x0b&\\),<>\\|]|t(?:cap|env|sid))|h(?:\\.distrib|uf[\"']?[\\t-\\r \\x0b&\\),<>\\|])|sh-(?:a(?:dd|gent)|copy-id)|udo(?:-rs|[\"']?[\\t-\\r \\x0b&\\),<>\\|]|_|edit|replay)|vn(?:a(?:dmin|uthz)|bench|dumpfilter|fsfs|look|mucc|rdump|s(?:erve|ync)|version)|ysctl)|t(?:(?:ailf|ftp|imeout|mux)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|c(?:l?sh[\"']?[\\t-\\r \\x0b&\\),<>\\|]|p(?:ing|traceroute))|elnet|r(?:a(?:ceroute6?|p[\"']?[\\t-\\r \\x0b&\\),<>\\|])|off[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|u(?:conv[\"']?[\\t-\\r \\x0b&\\),<>\\|]|n(?:(?:ame|iq|rar|xz)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|lz(?:4[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ma)|pigz|zstd)|ser(?:(?:ad|mo)d|del))|vi(?:(?:gr|pw|rsh)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|sudo(?:-rs)?)|w(?:get[\"']?[\\t-\\r \\x0b&\\),<>\\|]|ho(?:ami|is[\"']?[\\t-\\r \\x0b&\\),<>\\|]))|x(?:(?:args|etex|more|pad|term)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|z(?:c(?:at|mp)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|d(?:ec[\"']?[\\t-\\r \\x0b&\\),<>\\|]|iff)|[ef]?grep|less|more))|z(?:(?:c(?:at|mp)|diff|grep|less|run)[\"']?[\\t-\\r \\x0b&\\),<>\\|]|[ef]grep|ip(?:c(?:loak|mp)|details|grep|info|(?:merg|not)e|split|tool)|mo(?:dload|re[\"']?[\\t-\\r \\x0b&\\),<>\\|])|std(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|]|(?:ca|m)t|grep|less)))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932340,
    "msg": "Remote Command Execution: Direct Unix Command Execution (No Arguments)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?y[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?b[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?x|(?:c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?d|e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?v|v[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l)|w[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h)[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|[ls][\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?r[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?c[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e|n[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?h[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?p|t[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?m[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?e[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?(?:[\"']?[\\t-\\r \\x0b&\\),<>\\|].*|o[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?u[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?t)|[\\n\\r;=`\\{]|\\|\\|?|&&?|^\\x5c|\\$(?:\\(\\(?|[\\[\\{])|<(?:\\(|<<)|>\\(|\\([\\t-\\r \\x0b]*\\))[\\t-\\r \\x0b]*(?:[!\\$\\(\\{][\\t-\\r \\x0b]*|(?:[0-9A-Z_a-z]+=[^\\t-\\r \\x0b]+|\\$[0-9A-Z_a-z]+)[\\t-\\r \\x0b]+)*[\\t-\\r \\x0b]*[\"']*(?:[\"'-\\+\\--9\\?A-\\]_a-z\\|]+/)?[\"'\\x5c]*(?:aptitude|d(?:f|mesg)|env|h(?:ostname|top)|(?:(?:io|vm)sta|reboo)t|l(?:ast(?:log(?:in)?)?|s)|mysql(?:[^\\t-\\r \\x0b]{1,10}\\b)?|ps(?:ql)?|s(?:et|hutdown|u)|who(?:ami|is)?)[\"']?$",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932330,
    "msg": "Remote Command Execution: Unix shell history invocation",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "!-\\d",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932160,
    "msg": "Remote Command Execution: Unix Shell Code Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "cmdLine",
      "normalizePath"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        "${CDPATH}",
        "${DIRSTACK}",
        "${HOME}",
        "${HOSTNAME}",
        "${IFS}",
        "${OLDPWD}",
        "${OSTYPE}",
        "${PATH}",
        "${PWD}",
        "${SHELL}",
        "$CDPATH",
        "$DIRSTACK",
        "$HOME",
        "$HOSTNAME",
        "$IFS",
        "$OLDPWD",
        "$OSTYPE",
        "$PATH",
        "$PWD",
        "$SHELL",
        "bin/7z",
        "bin/7za",
        "bin/7zr",
        "bin/7zx",
        "bin/aa-",
        "bin/ab",
        "bin/auditctl",
        "bin/aurepot",
        "bin/ausearch",
        "bin/addgroup",
        "bin/adduser",
        "bin/agetty",
        "bin/alpine",
        "bin/ansible",
        "bin/apparmor_",
        "bin/apt",
        "bin/apt-get",
        "bin/aptitude",
        "bin/ar",
        "bin/arch",
        "bin/aria2c",
        "bin/arj",
        "bin/arjdisp",
        "bin/arj-register",
        "bin/arp",
        "bin/as",
        "bin/ascii-xfr",
        "bin/ascii85",
        "bin/ash",
        "bin/aspell",
        "bin/at",
        "bin/atobm",
        "bin/awk",
        "bin/axel",
        "bin/aws",
        "bin/base32",
        "bin/base64",
        "bin/basename",
        "bin/basenc",
        "bin/bash",
        "bin/batch",
        "bin/blkid",
        "bin/bpftrace",
        "bin/breaksw",
        "bin/bridge",
        "bin/brwap",
        "bin/bsdcat",
        "bin/bsdiff",
        "bin/bsdtar",
        "bin/bundler",
        "bin/bunzip2",
        "bin/busctl",
        "bin/busybox",
        "bin/byebug",
        "bin/byobu",
        "bin/bzcat",
        "bin/bzcmp",
        "bin/bzdiff",
        "bin/bzegrep",
        "bin/bzexe",
        "bin/bzfgrep",
        "bin/bzgrep",
        "bin/bzip2",
        "bin/bzip2recover",
        "bin/bzless",
        "bin/bzmore",
        "bin/bzz",
        "bin/c89",
        "bin/c89-gcc",
        "bin/c99",
        "bin/c99-gcc",
        "bin/cancel",
        "bin/capsh",
        "bin/cargo",
        "bin/cargo-audit",
        "bin/cargo-miri",
        "bin/cargo-watch",
        "bin/cat",
        "bin/cc",
        "bin/certbot",
        "bin/chattr",
        "bin/check_by_ssh",
        "bin/check_cups",
        "bin/check_log",
        "bin/check_memory",
        "bin/check_raid",
        "bin/check_ssl_cert",
        "bin/check_statusfile",
        "bin/chef",
        "bin/chef-",
        "bin/chflags",
        "bin/chgrp",
        "bin/chmod",
        "bin/choom",
        "bin/chown",
        "bin/chpass",
        "bin/chgpasswd",
        "bin/chroot",
        "bin/chsh",
        "bin/clang",
        "bin/clang++",
        "bin/clippy-driver",
        "bin/cmp",
        "bin/cobc",
        "bin/cobcrun",
        "bin/column",
        "bin/comm",
        "bin/command",
        "bin/composer",
        "bin/compress",
        "bin/coproc",
        "bin/core_perl/zipdetails",
        "bin/cowsay",
        "bin/cowthink",
        "bin/cp",
        "bin/cpan",
        "bin/cpio",
        "bin/cpulimit",
        "bin/crash",
        "bin/cron",
        "bin/crontab",
        "bin/cscli",
        "bin/csh",
        "bin/csplit",
        "bin/csvtool",
        "bin/cupsfilter",
        "bin/curl",
        "bin/cut",
        "bin/dash",
        "bin/date",
        "bin/df",
        "bin/dd",
        "bin/dhclient",
        "bin/dialog",
        "bin/diff",
        "bin/dig",
        "bin/dir",
        "bin/dmesg",
        "bin/dmidecode",
        "bin/dmsetup",
        "bin/dnf",
        "bin/doas",
        "bin/docker",
        "bin/docker-",
        "bin/dosbox",
        "bin/dpkg",
        "bin/dpkg-",
        "bin/du",
        "bin/dvips",
        "bin/e2fsck",
        "bin/easy_install",
        "bin/eb",
        "bin/echo",
        "bin/ed",
        "bin/efax",
        "bin/egrep",
        "bin/emacs",
        "bin/env",
        "bin/env-update",
        "bin/eqn",
        "bin/es",
        "bin/esh",
        "bin/ex",
        "bin/exec",
        "bin/exiftool",
        "bin/expand",
        "bin/expect",
        "bin/expr",
        "bin/facter",
        "bin/fc",
        "bin/fdfind",
        "bin/fdisk",
        "bin/fdmount",
        "bin/fdumount",
        "bin/fetch",
        "bin/fgrep",
        "bin/file",
        "bin/filetest",
        "bin/find",
        "bin/finger",
        "bin/fish",
        "bin/flock",
        "bin/fmt",
        "bin/fold",
        "bin/fping",
        "bin/fping6",
        "bin/ftp",
        "bin/ftpstats",
        "bin/ftpwho",
        "bin/gawk",
        "bin/gcc",
        "bin/gcore",
        "bin/gdb",
        "bin/gem",
        "bin/genie",
        "bin/genisoimage",
        "bin/GET",
        "bin/HEAD",
        "bin/POST",
        "bin/getcap",
        "bin/getfacl",
        "bin/ghc",
        "bin/ghc-",
        "bin/ghci",
        "bin/ghci-",
        "bin/gimp",
        "bin/ginsh",
        "bin/git",
        "bin/go",
        "bin/gpg",
        "bin/grc",
        "bin/grcat",
        "bin/grep",
        "bin/groupmod",
        "bin/gtester",
        "bin/gunzip",
        "bin/gzcat",
        "bin/gzexe",
        "bin/gzip",
        "bin/hash",
        "bin/hd",
        "bin/head",
        "bin/hexdump",
        "bin/highlight",
        "bin/hostid",
        "bin/hostname",
        "bin/hping3",
        "bin/htdigest",
        "bin/htop",
        "bin/htpasswd",
        "bin/iconv",
        "bin/id",
        "bin/ifconfig",
        "bin/iftop",
        "bin/install",
        "bin/ionice",
        "bin/ip",
        "bin/ip6tables",
        "bin/ipconfig",
        "bin/ippeveprinter",
        "bin/ippfind",
        "bin/ipptool",
        "bin/iptables",
        "bin/irb",
        "bin/ispell",
        "bin/java",
        "bin/jexec",
        "bin/jjs",
        "bin/jobs",
        "bin/join",
        "bin/journalctl",
        "bin/jq",
        "bin/jrunscript",
        "bin/kill",
        "bin/killall",
        "bin/knife",
        "bin/ksh",
        "bin/ksshell",
        "bin/last",
        "bin/lastcomm",
        "bin/lastlog",
        "bin/lastlogin",
        "bin/latex",
        "bin/ld",
        "bin/ldconfig",
        "bin/ldd",
        "bin/less",
        "bin/lessecho",
        "bin/lessfile",
        "bin/lesspipe",
        "bin/lftp",
        "bin/lftpget",
        "bin/links",
        "bin/ln",
        "bin/local",
        "bin/locate",
        "bin/loginctl",
        "bin/logname",
        "bin/logsave",
        "bin/look",
        "bin/losetup",
        "bin/lp",
        "bin/ls",
        "bin/ls-F",
        "bin/lsb_release",
        "bin/lscpu",
        "bin/lshw",
        "bin/lsmod",
        "bin/lsof",
        "bin/lspci",
        "bin/lsusb",
        "bin/ltrace",
        "bin/lua",
        "bin/lualatex",
        "bin/luatex",
        "bin/lwp-download",
        "bin/lwp-dump",
        "bin/lwp-mirror",
        "bin/lwp-request",
        "bin/lynx",
        "bin/lz",
        "bin/lz4",
        "bin/lz4c",
        "bin/lz4cat",
        "bin/lzcat",
        "bin/lzcmp",
        "bin/lzdiff",
        "bin/lzegrep",
        "bin/lzfgrep",
        "bin/lzgrep",
        "bin/lzless",
        "bin/lzma",
        "bin/lzmadec",
        "bin/lzmainfo",
        "bin/lzmore",
        "bin/mail",
        "bin/mailq",
        "bin/mailx",
        "bin/make",
        "bin/man",
        "bin/mawk",
        "bin/mkdir",
        "bin/mkfifo",
        "bin/mknod",
        "bin/mktemp",
        "bin/mlocate",
        "bin/more",
        "bin/mosquitto",
        "bin/mount",
        "bin/msgattrib",
        "bin/msgcat",
        "bin/msgconv",
        "bin/msgfilter",
        "bin/msgmerge",
        "bin/msguniq",
        "bin/mtr",
        "bin/mutt",
        "bin/mv",
        "bin/mysql",
        "bin/mysqladmin",
        "bin/mysqldump",
        "bin/mysqldumpslow",
        "bin/mysqlhotcopy",
        "bin/mysqlshow",
        "bin/nano",
        "bin/nasm",
        "bin/nawk",
        "bin/nc",
        "bin/nc.openbsd",
        "bin/nc.traditional",
        "bin/ncat",
        "bin/neofetch",
        "bin/net",
        "bin/netcat",
        "bin/netkit-ftp",
        "bin/netplan",
        "bin/netstat",
        "bin/nice",
        "bin/nl",
        "bin/nm",
        "bin/nmap",
        "bin/node",
        "bin/nohup",
        "bin/nping",
        "bin/npm",
        "bin/nroff",
        "bin/nsenter",
        "bin/nslookup",
        "bin/nstat",
        "bin/octave",
        "bin/od",
        "bin/onintr",
        "bin/openssl",
        "bin/openvpn",
        "bin/openvt",
        "bin/opkg",
        "bin/pacman",
        "bin/parted",
        "bin/passwd",
        "bin/paste",
        "bin/patch",
        "bin/pax",
        "bin/pdb",
        "bin/pdb2mb",
        "bin/pdb3",
        "bin/pdb3.",
        "bin/pdflatex",
        "bin/pdftex",
        "bin/pdksh",
        "bin/perf",
        "bin/perl",
        "bin/perl5",
        "bin/perlsh",
        "bin/perms",
        "bin/pf",
        "bin/pftp",
        "bin/pg",
        "bin/pgrep",
        "bin/php",
        "bin/php-cgi",
        "bin/php5",
        "bin/php7",
        "bin/pic",
        "bin/pico",
        "bin/piconv",
        "bin/pidstat",
        "bin/pigz",
        "bin/ping",
        "bin/ping6",
        "bin/pip",
        "bin/pkexec",
        "bin/pkg",
        "bin/pkg_info",
        "bin/pkginfo",
        "bin/pkill",
        "bin/popd",
        "bin/pr",
        "bin/printenv",
        "bin/printf",
        "bin/pry",
        "bin/ps",
        "bin/psed",
        "bin/psftp",
        "bin/psql",
        "bin/ptar",
        "bin/ptardiff",
        "bin/ptargrep",
        "bin/ptx",
        "bin/puppet",
        "bin/pushd",
        "bin/pwd",
        "bin/pxz",
        "bin/python",
        "bin/python2",
        "bin/python3",
        "bin/pyversions",
        "bin/py3versions",
        "bin/rake",
        "bin/raku",
        "bin/rar",
        "bin/rbash",
        "bin/rc",
        "bin/rcp",
        "bin/readelf",
        "bin/realpath",
        "bin/reboot",
        "bin/red",
        "bin/redcarpet",
        "bin/rename",
        "bin/replace",
        "bin/restic",
        "bin/rev",
        "bin/rlogin",
        "bin/rlwrap",
        "bin/rm",
        "bin/rmdir",
        "bin/rmuser",
        "bin/rnano",
        "bin/route",
        "bin/rpm",
        "bin/rpmdb",
        "bin/rpmquery",
        "bin/rpmverify",
        "bin/rsync",
        "bin/rsync-ssl",
        "bin/ruby",
        "bin/runc",
        "bin/run-mailcap",
        "bin/run-parts",
        "bin/rustc",
        "bin/rustdoc",
        "bin/rustfmt",
        "bin/rustup",
        "bin/rust-analyzer",
        "bin/rust-gdb",
        "bin/rust-lldb",
        "bin/rview",
        "bin/rvim",
        "bin/sash",
        "bin/sched",
        "bin/scp",
        "bin/screen",
        "bin/script",
        "bin/sdiff",
        "bin/sed",
        "bin/sendmail",
        "bin/service",
        "bin/setarch",
        "bin/setcap",
        "bin/setfacl",
        "bin/setsid",
        "bin/sftp",
        "bin/sg",
        "bin/sh",
        "bin/sh.distrib",
        "bin/shred",
        "bin/shuf",
        "bin/shutdown",
        "bin/sleep",
        "bin/slsh",
        "bin/smbclient",
        "bin/snap",
        "bin/socat",
        "bin/soelim",
        "bin/sort",
        "bin/source",
        "bin/split",
        "bin/sqlite3",
        "bin/ss",
        "bin/ssh",
        "bin/ssh-add",
        "bin/ssh-agent",
        "bin/ssh-copy-id",
        "bin/ssh-keygen",
        "bin/ssh-keyscan",
        "bin/sshpass",
        "bin/stat",
        "bin/start-stop-daemon",
        "bin/stdbuf",
        "bin/strace",
        "bin/strings",
        "bin/su",
        "bin/sudo",
        "bin/sudoedit",
        "bin/sudoreplay",
        "bin/sudo-rs",
        "bin/sudo_",
        "bin/svn",
        "bin/svnadmin",
        "bin/svnauthz",
        "bin/svnbench",
        "bin/svndumpfilter",
        "bin/svnfsfs",
        "bin/svnlook",
        "bin/svnmucc",
        "bin/svnrdump",
        "bin/svnserve",
        "bin/svnsync",
        "bin/svnversion",
        "bin/sysctl",
        "bin/systemctl",
        "bin/systemd-resolve",
        "bin/tac",
        "bin/tail",
        "bin/tailf",
        "bin/tar",
        "bin/task",
        "bin/taskset",
        "bin/tbl",
        "bin/tclsh",
        "bin/tcpdump",
        "bin/tcping",
        "bin/tcptraceroute",
        "bin/tcsh",
        "bin/tee",
        "bin/telnet",
        "bin/tex",
        "bin/tftp",
        "bin/tic",
        "bin/time",
        "bin/timedatectl",
        "bin/timeout",
        "bin/tmux",
        "bin/top",
        "bin/touch",
        "bin/traceroute",
        "bin/traceroute6",
        "bin/troff",
        "bin/trap",
        "bin/tshark",
        "bin/uconv",
        "bin/ul",
        "bin/ulimit",
        "bin/uname",
        "bin/uncompress",
        "bin/unexpand",
        "bin/uniq",
        "bin/unlink",
        "bin/unlz4",
        "bin/unlzma",
        "bin/unpigz",
        "bin/unrar",
        "bin/unset",
        "bin/unshare",
        "bin/unxz",
        "bin/unzip",
        "bin/unzstd",
        "bin/up2date",
        "bin/update-alternatives",
        "bin/useradd",
        "bin/userdel",
        "bin/usermod",
        "bin/uudecode",
        "bin/uuencode",
        "bin/valgrind",
        "bin/vi",
        "bin/view",
        "bin/vigr",
        "bin/vim",
        "bin/vimdiff",
        "bin/vipw",
        "bin/virsh",
        "bin/visudo",
        "bin/visudo-rs",
        "bin/volatility",
        "bin/w",
        "bin/w3m",
        "bin/wall",
        "bin/watch",
        "bin/wc",
        "bin/wget",
        "bin/whiptail",
        "bin/who",
        "bin/whoami",
        "bin/whois",
        "bin/wireshark",
        "bin/wish",
        "bin/xargs",
        "bin/xelatex",
        "bin/xetex",
        "bin/xmodmap",
        "bin/xmore",
        "bin/xpad",
        "bin/xterm",
        "bin/xxd",
        "bin/xz",
        "bin/xzcat",
        "bin/xzcmp",
        "bin/xzdec",
        "bin/xzdiff",
        "bin/xzegrep",
        "bin/xzfgrep",
        "bin/xzgrep",
        "bin/xzless",
        "bin/xzmore",
        "bin/yarn",
        "bin/yelp",
        "bin/yes",
        "bin/yum",
        "bin/zathura",
        "bin/zcat",
        "bin/zcmp",
        "bin/zdiff",
        "bin/zegrep",
        "bin/zfgrep",
        "bin/zgrep",
        "bin/zip",
        "bin/zipcloak",
        "bin/zipcmp",
        "bin/zipdetails",
        "bin/zipgrep",
        "bin/zipinfo",
        "bin/zipmerge",
        "bin/zipnote",
        "bin/zipsplit",
        "bin/ziptool",
        "bin/zless",
        "bin/zmore",
        "bin/zrun",
        "bin/zsh",
        "bin/zsoelim",
        "bin/zstd",
        "bin/zstdcat",
        "bin/zstdgrep",
        "bin/zstdless",
        "bin/zstdmt",
        "bin/zypper",
        "dev/fd",
        "dev/null",
        "dev/stderr",
        "dev/stdin",
        "dev/stdout",
        "dev/tcp",
        "dev/udp",
        "dev/zero",
        "etc/alternatives/rmt",
        "etc/group",
        "etc/master.passwd",
        "etc/passwd",
        "etc/pwd.db",
        "etc/rmt",
        "etc/shadow",
        "etc/shells",
        "etc/spwd.db",
        "proc/self",
        "sbin/capsh",
        "sbin/logsave",
        "sbin/rmt",
        "sbin/rmt-dump",
        "sbin/rmt-tar",
        "sbin/service",
        "sbin/start-stop-daemon"
      ],
      "negated": false
    }
  },
  {
    "id": 932170,
    "msg": "Remote Command Execution: Shellshock (CVE-2014-6271)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "REQUEST_LINE"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "^\\([\\t-\\r ]*\\)[\\t-\\r ]+\\{",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932171,
    "msg": "Remote Command Execution: Shellshock (CVE-2014-6271)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "^(?:json\\.)?\\([\\t-\\r \\x0b]*\\)[\\t-\\r \\x0b]+\\{",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932175,
    "msg": "Remote Command Execution: Unix shell alias invocation",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "\\ba[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?l[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?i[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?a[\"'\\)\\[\\x5c]*(?:(?:(?:\\|\\||&&)[\\t-\\r \\x0b]*)?\\$[!#\\(\\*\\-0-9\\?@_a-\\{]*)?\\x5c?s\\b[\\t-\\r \\x0b]+(?:[\\+\\-][a-z]+\\+?[\\t-\\r \\x0b]+)?[!\"%',-\\.0-9@-Z_a-z]+=[^\\t-\\r \\x0b]",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 932370,
    "msg": "Remote Command Execution: Windows Command Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:[\\n\\r;`\\{]|\\|\\|?|&&?)[\\t-\\r \\x0b]*[\\t-\\r \\x0b\"'\\(,@]*(?:[\"'\\.-9A-Z_a-z]+/|(?:[\"'\\x5c\\^]*[0-9A-Z_a-z][\"'\\x5c\\^]*:[^\\x5c]*|[ \"'\\.-9A-Z\\x5c\\^_a-z]*)\\x5c)?[\"\\^]*(?:a[\"\\^]*(?:c[\"\\^]*c[\"\\^]*c[\"\\^]*h[\"\\^]*e[\"\\^]*c[\"\\^]*k[\"\\^]*c[\"\\^]*o[\"\\^]*n[\"\\^]*s[\"\\^]*o[\"\\^]*l[\"\\^]*e|d[\"\\^]*(?:p[\"\\^]*l[\"\\^]*u[\"\\^]*s|v[\"\\^]*p[\"\\^]*a[\"\\^]*c[\"\\^]*k)|(?:g[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*e[\"\\^]*x[\"\\^]*e[\"\\^]*c[\"\\^]*u[\"\\^]*t[\"\\^]*o|(?:s[\"\\^]*p[\"\\^]*n[\"\\^]*e[\"\\^]*t[\"\\^]*_[\"\\^]*c[\"\\^]*o[\"\\^]*m[\"\\^]*p[\"\\^]*i[\"\\^]*l|t[\"\\^]*b[\"\\^]*r[\"\\^]*o[\"\\^]*k)[\"\\^]*e)[\"\\^]*r|p[\"\\^]*p[\"\\^]*(?:i[\"\\^]*n[\"\\^]*s[\"\\^]*t[\"\\^]*a[\"\\^]*l[\"\\^]*l[\"\\^]*e[\"\\^]*r|v[\"\\^]*l[\"\\^]*p))|b[\"\\^]*(?:a[\"\\^]*s[\"\\^]*h|g[\"\\^]*i[\"\\^]*n[\"\\^]*f[\"\\^]*o|i[\"\\^]*t[\"\\^]*s[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n)|c[\"\\^]*(?:d[\"\\^]*b|e[\"\\^]*r[\"\\^]*t[\"\\^]*(?:o[\"\\^]*c|r[\"\\^]*e[\"\\^]*q|u[\"\\^]*t[\"\\^]*i[\"\\^]*l)|l[\"\\^]*_[\"\\^]*(?:i[\"\\^]*n[\"\\^]*v[\"\\^]*o[\"\\^]*c[\"\\^]*a[\"\\^]*t[\"\\^]*i[\"\\^]*o[\"\\^]*n|l[\"\\^]*o[\"\\^]*a[\"\\^]*d[\"\\^]*a[\"\\^]*s[\"\\^]*s[\"\\^]*e[\"\\^]*m[\"\\^]*b[\"\\^]*l[\"\\^]*y|m[\"\\^]*u[\"\\^]*t[\"\\^]*e[\"\\^]*x[\"\\^]*v[\"\\^]*e[\"\\^]*r[\"\\^]*i[\"\\^]*f[\"\\^]*i[\"\\^]*e[\"\\^]*r[\"\\^]*s)|m[\"\\^]*(?:d(?:[\"\\^]*(?:k[\"\\^]*e[\"\\^]*y|l[\"\\^]*3[\"\\^]*2))?|s[\"\\^]*t[\"\\^]*p)|o[\"\\^]*(?:m[\"\\^]*s[\"\\^]*v[\"\\^]*c[\"\\^]*s|n[\"\\^]*(?:f[\"\\^]*i[\"\\^]*g[\"\\^]*s[\"\\^]*e[\"\\^]*c[\"\\^]*u[\"\\^]*r[\"\\^]*i[\"\\^]*t[\"\\^]*y[\"\\^]*p[\"\\^]*o[\"\\^]*l[\"\\^]*i[\"\\^]*c[\"\\^]*y|h[\"\\^]*o[\"\\^]*s[\"\\^]*t|t[\"\\^]*r[\"\\^]*o[\"\\^]*l)|r[\"\\^]*e[\"\\^]*g[\"\\^]*e[\"\\^]*n)|r[\"\\^]*e[\"\\^]*a[\"\\^]*t[\"\\^]*e[\"\\^]*d[\"\\^]*u[\"\\^]*m[\"\\^]*p|s[\"\\^]*(?:c(?:[\"\\^]*r[\"\\^]*i[\"\\^]*p[\"\\^]*t)?|i)|u[\"\\^]*s[\"\\^]*t[\"\\^]*o[\"\\^]*m[\"\\^]*s[\"\\^]*h[\"\\^]*e[\"\\^]*l[\"\\^]*l[\"\\^]*h[\"\\^]*o[\"\\^]*s[\"\\^]*t)|d[\"\\^]*(?:a[\"\\^]*t[\"\\^]*a[\"\\^]*s[\"\\^]*v[\"\\^]*c[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|e[\"\\^]*(?:f[\"\\^]*a[\"\\^]*u[\"\\^]*l[\"\\^]*t[\"\\^]*p[\"\\^]*a[\"\\^]*c[\"\\^]*k|s[\"\\^]*k(?:[\"\\^]*t[\"\\^]*o[\"\\^]*p[\"\\^]*i[\"\\^]*m[\"\\^]*g[\"\\^]*d[\"\\^]*o[\"\\^]*w[\"\\^]*n[\"\\^]*l[\"\\^]*d[\"\\^]*r)?|v[\"\\^]*(?:i[\"\\^]*c[\"\\^]*e[\"\\^]*c[\"\\^]*r[\"\\^]*e[\"\\^]*d[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*i[\"\\^]*a[\"\\^]*l[\"\\^]*d[\"\\^]*e[\"\\^]*p[\"\\^]*l[\"\\^]*o[\"\\^]*y[\"\\^]*m[\"\\^]*e[\"\\^]*n[\"\\^]*t|t[\"\\^]*o[\"\\^]*o[\"\\^]*l[\"\\^]*s[\"\\^]*l[\"\\^]*a[\"\\^]*u[\"\\^]*n[\"\\^]*c[\"\\^]*h[\"\\^]*e[\"\\^]*r))|f[\"\\^]*s[\"\\^]*(?:h[\"\\^]*i[\"\\^]*m|v[\"\\^]*c)|i[\"\\^]*(?:a[\"\\^]*n[\"\\^]*t[\"\\^]*z|s[\"\\^]*k[\"\\^]*s[\"\\^]*h[\"\\^]*a[\"\\^]*d[\"\\^]*o[\"\\^]*w)|n[\"\\^]*(?:s[\"\\^]*c[\"\\^]*m[\"\\^]*d|x)|o[\"\\^]*t[\"\\^]*n[\"\\^]*e[\"\\^]*t|u[\"\\^]*m[\"\\^]*p[\"\\^]*6[\"\\^]*4|x[\"\\^]*c[\"\\^]*a[\"\\^]*p)|e[\"\\^]*(?:s[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*u[\"\\^]*t[\"\\^]*l|v[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*v[\"\\^]*w[\"\\^]*r|x[\"\\^]*(?:c[\"\\^]*e[\"\\^]*l|p[\"\\^]*(?:a[\"\\^]*n[\"\\^]*d|l[\"\\^]*o[\"\\^]*r[\"\\^]*e[\"\\^]*r)|t[\"\\^]*(?:e[\"\\^]*x[\"\\^]*p[\"\\^]*o[\"\\^]*r[\"\\^]*t|r[\"\\^]*a[\"\\^]*c[\"\\^]*3[\"\\^]*2)))|f[\"\\^]*(?:i[\"\\^]*n[\"\\^]*(?:d[\"\\^]*s[\"\\^]*t|g[\"\\^]*e)[\"\\^]*r|l[\"\\^]*t[\"\\^]*m[\"\\^]*c|o[\"\\^]*r[\"\\^]*f[\"\\^]*i[\"\\^]*l[\"\\^]*e[\"\\^]*s|s[\"\\^]*(?:i(?:[\"\\^]*a[\"\\^]*n[\"\\^]*y[\"\\^]*c[\"\\^]*p[\"\\^]*u)?|u[\"\\^]*t[\"\\^]*i[\"\\^]*l)|t[\"\\^]*p)|g[\"\\^]*(?:f[\"\\^]*x[\"\\^]*d[\"\\^]*o[\"\\^]*w[\"\\^]*n[\"\\^]*l[\"\\^]*o[\"\\^]*a[\"\\^]*d[\"\\^]*w[\"\\^]*r[\"\\^]*a[\"\\^]*p[\"\\^]*p[\"\\^]*e[\"\\^]*r|p[\"\\^]*s[\"\\^]*c[\"\\^]*r[\"\\^]*i[\"\\^]*p[\"\\^]*t)|h[\"\\^]*h|i[\"\\^]*(?:e[\"\\^]*(?:4[\"\\^]*u[\"\\^]*i[\"\\^]*n[\"\\^]*i[\"\\^]*t|a[\"\\^]*d[\"\\^]*v[\"\\^]*p[\"\\^]*a[\"\\^]*c[\"\\^]*k|e[\"\\^]*x[\"\\^]*e[\"\\^]*c|f[\"\\^]*r[\"\\^]*a[\"\\^]*m[\"\\^]*e)|l[\"\\^]*a[\"\\^]*s[\"\\^]*m|m[\"\\^]*e[\"\\^]*w[\"\\^]*d[\"\\^]*b[\"\\^]*l[\"\\^]*d|n[\"\\^]*(?:f[\"\\^]*d[\"\\^]*e[\"\\^]*f[\"\\^]*a[\"\\^]*u[\"\\^]*l[\"\\^]*t[\"\\^]*i[\"\\^]*n[\"\\^]*s[\"\\^]*t[\"\\^]*a[\"\\^]*l|s[\"\\^]*t[\"\\^]*a[\"\\^]*l[\"\\^]*l[\"\\^]*u[\"\\^]*t[\"\\^]*i)[\"\\^]*l)|j[\"\\^]*s[\"\\^]*c|l[\"\\^]*(?:a[\"\\^]*u[\"\\^]*n[\"\\^]*c[\"\\^]*h[\"\\^]*-[\"\\^]*v[\"\\^]*s[\"\\^]*d[\"\\^]*e[\"\\^]*v[\"\\^]*s[\"\\^]*h[\"\\^]*e[\"\\^]*l[\"\\^]*l|d[\"\\^]*i[\"\\^]*f[\"\\^]*d[\"\\^]*e)|m[\"\\^]*(?:a[\"\\^]*(?:k[\"\\^]*e[\"\\^]*c[\"\\^]*a[\"\\^]*b|n[\"\\^]*a[\"\\^]*g[\"\\^]*e[\"\\^]*-[\"\\^]*b[\"\\^]*d[\"\\^]*e|v[\"\\^]*i[\"\\^]*n[\"\\^]*j[\"\\^]*e[\"\\^]*c[\"\\^]*t)|f[\"\\^]*t[\"\\^]*r[\"\\^]*a[\"\\^]*c[\"\\^]*e|i[\"\\^]*c[\"\\^]*r[\"\\^]*o[\"\\^]*s[\"\\^]*o[\"\\^]*f[\"\\^]*t|m[\"\\^]*c|p[\"\\^]*c[\"\\^]*m[\"\\^]*d[\"\\^]*r[\"\\^]*u[\"\\^]*n|s[\"\\^]*(?:(?:b[\"\\^]*u[\"\\^]*i[\"\\^]*l|o[\"\\^]*h[\"\\^]*t[\"\\^]*m[\"\\^]*e)[\"\\^]*d|c[\"\\^]*o[\"\\^]*n[\"\\^]*f[\"\\^]*i[\"\\^]*g|d[\"\\^]*(?:e[\"\\^]*p[\"\\^]*l[\"\\^]*o[\"\\^]*y|t)|h[\"\\^]*t[\"\\^]*(?:a|m[\"\\^]*l)|i[\"\\^]*e[\"\\^]*x[\"\\^]*e[\"\\^]*c|p[\"\\^]*u[\"\\^]*b|x[\"\\^]*s[\"\\^]*l))|n[\"\\^]*(?:e[\"\\^]*t[\"\\^]*s[\"\\^]*h|t[\"\\^]*d[\"\\^]*s[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l)|o[\"\\^]*(?:d[\"\\^]*b[\"\\^]*c[\"\\^]*c[\"\\^]*o[\"\\^]*n[\"\\^]*f|f[\"\\^]*f[\"\\^]*l[\"\\^]*i[\"\\^]*n[\"\\^]*e[\"\\^]*s[\"\\^]*c[\"\\^]*a[\"\\^]*n[\"\\^]*n[\"\\^]*e[\"\\^]*r[\"\\^]*s[\"\\^]*h[\"\\^]*e[\"\\^]*l[\"\\^]*l|n[\"\\^]*e[\"\\^]*d[\"\\^]*r[\"\\^]*i[\"\\^]*v[\"\\^]*e[\"\\^]*s[\"\\^]*t[\"\\^]*a[\"\\^]*n[\"\\^]*d[\"\\^]*a[\"\\^]*l[\"\\^]*o[\"\\^]*n[\"\\^]*e[\"\\^]*u[\"\\^]*p[\"\\^]*d[\"\\^]*a[\"\\^]*t[\"\\^]*e[\"\\^]*r|p[\"\\^]*e[\"\\^]*n[\"\\^]*c[\"\\^]*o[\"\\^]*n[\"\\^]*s[\"\\^]*o[\"\\^]*l[\"\\^]*e)|p[\"\\^]*(?:c[\"\\^]*(?:a[\"\\^]*l[\"\\^]*u[\"\\^]*a|w[\"\\^]*(?:r[\"\\^]*u[\"\\^]*n|u[\"\\^]*t[\"\\^]*l))|(?:e[\"\\^]*s[\"\\^]*t[\"\\^]*e|s)[\"\\^]*r|(?:k[\"\\^]*t[\"\\^]*m[\"\\^]*o|u[\"\\^]*b[\"\\^]*p[\"\\^]*r)[\"\\^]*n|n[\"\\^]*p[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|o[\"\\^]*w[\"\\^]*e[\"\\^]*r[\"\\^]*p[\"\\^]*n[\"\\^]*t|r[\"\\^]*(?:e[\"\\^]*s[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*a[\"\\^]*t[\"\\^]*i[\"\\^]*o[\"\\^]*n[\"\\^]*h[\"\\^]*o[\"\\^]*s[\"\\^]*t|i[\"\\^]*n[\"\\^]*t(?:[\"\\^]*b[\"\\^]*r[\"\\^]*m)?|o[\"\\^]*(?:c[\"\\^]*d[\"\\^]*u[\"\\^]*m[\"\\^]*p|t[\"\\^]*o[\"\\^]*c[\"\\^]*o[\"\\^]*l[\"\\^]*h[\"\\^]*a[\"\\^]*n[\"\\^]*d[\"\\^]*l[\"\\^]*e[\"\\^]*r)))|r[\"\\^]*(?:a[\"\\^]*s[\"\\^]*a[\"\\^]*u[\"\\^]*t[\"\\^]*o[\"\\^]*u|c[\"\\^]*s[\"\\^]*i|(?:d[\"\\^]*r[\"\\^]*l[\"\\^]*e[\"\\^]*a[\"\\^]*k[\"\\^]*d[\"\\^]*i[\"\\^]*a|p[\"\\^]*c[\"\\^]*p[\"\\^]*i[\"\\^]*n)[\"\\^]*g|e[\"\\^]*(?:g(?:[\"\\^]*(?:a[\"\\^]*s[\"\\^]*m|e[\"\\^]*d[\"\\^]*i[\"\\^]*t|i[\"\\^]*(?:n[\"\\^]*i|s[\"\\^]*t[\"\\^]*e[\"\\^]*r[\"\\^]*-[\"\\^]*c[\"\\^]*i[\"\\^]*m[\"\\^]*p[\"\\^]*r[\"\\^]*o[\"\\^]*v[\"\\^]*i[\"\\^]*d[\"\\^]*e[\"\\^]*r)|s[\"\\^]*v[\"\\^]*(?:c[\"\\^]*s|r[\"\\^]*3[\"\\^]*2)))?|(?:m[\"\\^]*o[\"\\^]*t|p[\"\\^]*l[\"\\^]*a[\"\\^]*c)[\"\\^]*e)|u[\"\\^]*n[\"\\^]*(?:d[\"\\^]*l[\"\\^]*l[\"\\^]*3[\"\\^]*2|(?:e[\"\\^]*x[\"\\^]*e|s[\"\\^]*c[\"\\^]*r[\"\\^]*i[\"\\^]*p[\"\\^]*t)[\"\\^]*h[\"\\^]*e[\"\\^]*l[\"\\^]*p[\"\\^]*e[\"\\^]*r|o[\"\\^]*n[\"\\^]*c[\"\\^]*e))|s[\"\\^]*(?:c[\"\\^]*(?:[\\t-\\r \\x0b,\\./;<>].*|h[\"\\^]*t[\"\\^]*a[\"\\^]*s[\"\\^]*k[\"\\^]*s|r[\"\\^]*i[\"\\^]*p[\"\\^]*t[\"\\^]*r[\"\\^]*u[\"\\^]*n[\"\\^]*n[\"\\^]*e[\"\\^]*r)|e[\"\\^]*t[\"\\^]*(?:r[\"\\^]*e[\"\\^]*s|t[\"\\^]*i[\"\\^]*n[\"\\^]*g[\"\\^]*s[\"\\^]*y[\"\\^]*n[\"\\^]*c[\"\\^]*h[\"\\^]*o[\"\\^]*s[\"\\^]*t|u[\"\\^]*p[\"\\^]*a[\"\\^]*p[\"\\^]*i)|h[\"\\^]*(?:d[\"\\^]*o[\"\\^]*c[\"\\^]*v[\"\\^]*w|e[\"\\^]*l[\"\\^]*l[\"\\^]*3[\"\\^]*2)|q[\"\\^]*(?:l[\"\\^]*(?:d[\"\\^]*u[\"\\^]*m[\"\\^]*p[\"\\^]*e[\"\\^]*r|(?:t[\"\\^]*o[\"\\^]*o[\"\\^]*l[\"\\^]*s[\"\\^]*)?p[\"\\^]*s)|u[\"\\^]*i[\"\\^]*r[\"\\^]*r[\"\\^]*e[\"\\^]*l)|s[\"\\^]*h|t[\"\\^]*o[\"\\^]*r[\"\\^]*d[\"\\^]*i[\"\\^]*a[\"\\^]*g|y[\"\\^]*(?:n[\"\\^]*c[\"\\^]*a[\"\\^]*p[\"\\^]*p[\"\\^]*v[\"\\^]*p[\"\\^]*u[\"\\^]*b[\"\\^]*l[\"\\^]*i[\"\\^]*s[\"\\^]*h[\"\\^]*i[\"\\^]*n[\"\\^]*g[\"\\^]*s[\"\\^]*e[\"\\^]*r[\"\\^]*v[\"\\^]*e[\"\\^]*r|s[\"\\^]*s[\"\\^]*e[\"\\^]*t[\"\\^]*u[\"\\^]*p))|t[\"\\^]*(?:e[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|r[\"\\^]*a[\"\\^]*c[\"\\^]*k[\"\\^]*e[\"\\^]*r|t[\"\\^]*(?:d[\"\\^]*i[\"\\^]*n[\"\\^]*j[\"\\^]*e[\"\\^]*c[\"\\^]*t|t[\"\\^]*r[\"\\^]*a[\"\\^]*c[\"\\^]*e[\"\\^]*r))|u[\"\\^]*(?:n[\"\\^]*r[\"\\^]*e[\"\\^]*g[\"\\^]*m[\"\\^]*p[\"\\^]*2|p[\"\\^]*d[\"\\^]*a[\"\\^]*t[\"\\^]*e|t[\"\\^]*i[\"\\^]*l[\"\\^]*i[\"\\^]*t[\"\\^]*y[\"\\^]*f[\"\\^]*u[\"\\^]*n[\"\\^]*c[\"\\^]*t[\"\\^]*i[\"\\^]*o[\"\\^]*n[\"\\^]*s)|v[\"\\^]*(?:b[\"\\^]*c|e[\"\\^]*r[\"\\^]*c[\"\\^]*l[\"\\^]*s[\"\\^]*i[\"\\^]*d|i[\"\\^]*s[\"\\^]*u[\"\\^]*a[\"\\^]*l[\"\\^]*u[\"\\^]*i[\"\\^]*a[\"\\^]*v[\"\\^]*e[\"\\^]*r[\"\\^]*i[\"\\^]*f[\"\\^]*y[\"\\^]*n[\"\\^]*a[\"\\^]*t[\"\\^]*i[\"\\^]*v[\"\\^]*e|s[\"\\^]*(?:i[\"\\^]*i[\"\\^]*s[\"\\^]*e[\"\\^]*x[\"\\^]*e[\"\\^]*l[\"\\^]*a[\"\\^]*u[\"\\^]*n[\"\\^]*c[\"\\^]*h|j[\"\\^]*i[\"\\^]*t[\"\\^]*d[\"\\^]*e[\"\\^]*b[\"\\^]*u[\"\\^]*g[\"\\^]*g)[\"\\^]*e[\"\\^]*r)|w[\"\\^]*(?:a[\"\\^]*b|(?:f|m[\"\\^]*i)[\"\\^]*c|i[\"\\^]*n[\"\\^]*(?:g[\"\\^]*e[\"\\^]*t|r[\"\\^]*m|w[\"\\^]*o[\"\\^]*r[\"\\^]*d)|l[\"\\^]*r[\"\\^]*m[\"\\^]*d[\"\\^]*r|o[\"\\^]*r[\"\\^]*k[\"\\^]*f[\"\\^]*o[\"\\^]*l[\"\\^]*d[\"\\^]*e[\"\\^]*r[\"\\^]*s|s[\"\\^]*(?:(?:c[\"\\^]*r[\"\\^]*i[\"\\^]*p|r[\"\\^]*e[\"\\^]*s[\"\\^]*e)[\"\\^]*t|l)|t[\"\\^]*[\\t-\\r \\x0b,\\./;<>].*|u[\"\\^]*a[\"\\^]*u[\"\\^]*c[\"\\^]*l[\"\\^]*t)|x[\"\\^]*w[\"\\^]*i[\"\\^]*z[\"\\^]*a[\"\\^]*r[\"\\^]*d|z[\"\\^]*i[\"\\^]*p[\"\\^]*f[\"\\^]*l[\"\\^]*d[\"\\^]*r)(?:\\.[\"\\^]*[0-9A-Z_a-z]+)?\\b",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 932380,
    "msg": "Remote Command Execution: Windows Command Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "(?:[\\n\\r;`\\{]|\\|\\|?|&&?)[\\t-\\r \\x0b]*[\\t-\\r \\x0b\"'\\(,@]*(?:[\"'\\.-9A-Z_a-z]+/|(?:[\"'\\x5c\\^]*[0-9A-Z_a-z][\"'\\x5c\\^]*:[^\\x5c]*|[ \"'\\.-9A-Z\\x5c\\^_a-z]*)\\x5c)?[\"\\^]*(?:a[\"\\^]*(?:s[\"\\^]*s[\"\\^]*o[\"\\^]*c|t[\"\\^]*(?:m[\"\\^]*a[\"\\^]*d[\"\\^]*m|t[\"\\^]*r[\"\\^]*i[\"\\^]*b)|u[\"\\^]*(?:d[\"\\^]*i[\"\\^]*t[\"\\^]*p[\"\\^]*o[\"\\^]*l|t[\"\\^]*o[\"\\^]*(?:c[\"\\^]*(?:h[\"\\^]*k|o[\"\\^]*n[\"\\^]*v)|(?:f[\"\\^]*m|m[\"\\^]*o[\"\\^]*u[\"\\^]*n)[\"\\^]*t)))|b[\"\\^]*(?:c[\"\\^]*d[\"\\^]*(?:b[\"\\^]*o[\"\\^]*o|e[\"\\^]*d[\"\\^]*i)[\"\\^]*t|(?:d[\"\\^]*e[\"\\^]*h[\"\\^]*d|o[\"\\^]*o[\"\\^]*t)[\"\\^]*c[\"\\^]*f[\"\\^]*g|i[\"\\^]*t[\"\\^]*s[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n)|c[\"\\^]*(?:a[\"\\^]*c[\"\\^]*l[\"\\^]*s|e[\"\\^]*r[\"\\^]*t[\"\\^]*(?:r[\"\\^]*e[\"\\^]*q|u[\"\\^]*t[\"\\^]*i[\"\\^]*l)|h[\"\\^]*(?:c[\"\\^]*p|d[\"\\^]*i[\"\\^]*r|g[\"\\^]*(?:l[\"\\^]*o[\"\\^]*g[\"\\^]*o[\"\\^]*n|p[\"\\^]*o[\"\\^]*r[\"\\^]*t|u[\"\\^]*s[\"\\^]*r)|k[\"\\^]*(?:d[\"\\^]*s[\"\\^]*k|n[\"\\^]*t[\"\\^]*f[\"\\^]*s))|l[\"\\^]*e[\"\\^]*a[\"\\^]*n[\"\\^]*m[\"\\^]*g[\"\\^]*r|m[\"\\^]*(?:d(?:[\"\\^]*k[\"\\^]*e[\"\\^]*y)?|s[\"\\^]*t[\"\\^]*p)|s[\"\\^]*c[\"\\^]*r[\"\\^]*i[\"\\^]*p[\"\\^]*t)|d[\"\\^]*(?:c[\"\\^]*(?:d[\"\\^]*i[\"\\^]*a[\"\\^]*g|g[\"\\^]*p[\"\\^]*o[\"\\^]*f[\"\\^]*i[\"\\^]*x)|e[\"\\^]*(?:f[\"\\^]*r[\"\\^]*a[\"\\^]*g|l)|f[\"\\^]*s[\"\\^]*(?:d[\"\\^]*i[\"\\^]*a|r[\"\\^]*m[\"\\^]*i)[\"\\^]*g|i[\"\\^]*(?:a[\"\\^]*n[\"\\^]*t[\"\\^]*z|r|s[\"\\^]*(?:k[\"\\^]*(?:c[\"\\^]*o[\"\\^]*(?:m[\"\\^]*p|p[\"\\^]*y)|p[\"\\^]*(?:a[\"\\^]*r[\"\\^]*t|e[\"\\^]*r[\"\\^]*f)|r[\"\\^]*a[\"\\^]*i[\"\\^]*d|s[\"\\^]*h[\"\\^]*a[\"\\^]*d[\"\\^]*o[\"\\^]*w)|p[\"\\^]*d[\"\\^]*i[\"\\^]*a[\"\\^]*g))|n[\"\\^]*s[\"\\^]*c[\"\\^]*m[\"\\^]*d|(?:o[\"\\^]*s[\"\\^]*k[\"\\^]*e|r[\"\\^]*i[\"\\^]*v[\"\\^]*e[\"\\^]*r[\"\\^]*q[\"\\^]*u[\"\\^]*e[\"\\^]*r)[\"\\^]*y)|e[\"\\^]*(?:n[\"\\^]*d[\"\\^]*l[\"\\^]*o[\"\\^]*c[\"\\^]*a[\"\\^]*l|v[\"\\^]*e[\"\\^]*n[\"\\^]*t[\"\\^]*c[\"\\^]*r[\"\\^]*e[\"\\^]*a[\"\\^]*t[\"\\^]*e)|E[\"\\^]*v[\"\\^]*n[\"\\^]*t[\"\\^]*c[\"\\^]*m[\"\\^]*d|f[\"\\^]*(?:c|i[\"\\^]*(?:l[\"\\^]*e[\"\\^]*s[\"\\^]*y[\"\\^]*s[\"\\^]*t[\"\\^]*e[\"\\^]*m[\"\\^]*s|n[\"\\^]*d[\"\\^]*s[\"\\^]*t[\"\\^]*r)|l[\"\\^]*a[\"\\^]*t[\"\\^]*t[\"\\^]*e[\"\\^]*m[\"\\^]*p|o[\"\\^]*r[\"\\^]*f[\"\\^]*i[\"\\^]*l[\"\\^]*e[\"\\^]*s|r[\"\\^]*e[\"\\^]*e[\"\\^]*d[\"\\^]*i[\"\\^]*s[\"\\^]*k|s[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|(?:t[\"\\^]*y[\"\\^]*p|v[\"\\^]*e[\"\\^]*u[\"\\^]*p[\"\\^]*d[\"\\^]*a[\"\\^]*t)[\"\\^]*e)|g[\"\\^]*(?:e[\"\\^]*t[\"\\^]*(?:m[\"\\^]*a[\"\\^]*c|t[\"\\^]*y[\"\\^]*p[\"\\^]*e)|o[\"\\^]*t[\"\\^]*o|p[\"\\^]*(?:f[\"\\^]*i[\"\\^]*x[\"\\^]*u[\"\\^]*p|(?:r[\"\\^]*e[\"\\^]*s[\"\\^]*u[\"\\^]*l[\"\\^]*)?t|u[\"\\^]*p[\"\\^]*d[\"\\^]*a[\"\\^]*t[\"\\^]*e)|r[\"\\^]*a[\"\\^]*f[\"\\^]*t[\"\\^]*a[\"\\^]*b[\"\\^]*l)|h[\"\\^]*(?:e[\"\\^]*l[\"\\^]*p[\"\\^]*c[\"\\^]*t[\"\\^]*r|o[\"\\^]*s[\"\\^]*t[\"\\^]*n[\"\\^]*a[\"\\^]*m[\"\\^]*e)|i[\"\\^]*(?:c[\"\\^]*a[\"\\^]*c[\"\\^]*l[\"\\^]*s|p[\"\\^]*(?:c[\"\\^]*o[\"\\^]*n[\"\\^]*f[\"\\^]*i[\"\\^]*g|x[\"\\^]*r[\"\\^]*o[\"\\^]*u[\"\\^]*t[\"\\^]*e)|r[\"\\^]*f[\"\\^]*t[\"\\^]*p)|j[\"\\^]*e[\"\\^]*t[\"\\^]*p[\"\\^]*a[\"\\^]*c[\"\\^]*k|k[\"\\^]*(?:l[\"\\^]*i[\"\\^]*s[\"\\^]*t|s[\"\\^]*e[\"\\^]*t[\"\\^]*u[\"\\^]*p|t[\"\\^]*(?:m[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|p[\"\\^]*a[\"\\^]*s[\"\\^]*s))|l[\"\\^]*(?:o[\"\\^]*(?:d[\"\\^]*c[\"\\^]*t[\"\\^]*r|g[\"\\^]*(?:m[\"\\^]*a[\"\\^]*n|o[\"\\^]*f[\"\\^]*f))|p[\"\\^]*[qr])|m[\"\\^]*(?:a[\"\\^]*(?:c[\"\\^]*f[\"\\^]*i[\"\\^]*l[\"\\^]*e|k[\"\\^]*e[\"\\^]*c[\"\\^]*a[\"\\^]*b|p[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n)|k[\"\\^]*(?:d[\"\\^]*i[\"\\^]*r|l[\"\\^]*i[\"\\^]*n[\"\\^]*k)|m[\"\\^]*c|o[\"\\^]*u[\"\\^]*n[\"\\^]*t[\"\\^]*v[\"\\^]*o[\"\\^]*l|q[\"\\^]*(?:b[\"\\^]*k[\"\\^]*u[\"\\^]*p|(?:t[\"\\^]*g[\"\\^]*)?s[\"\\^]*v[\"\\^]*c)|s[\"\\^]*(?:d[\"\\^]*t|i[\"\\^]*(?:e[\"\\^]*x[\"\\^]*e[\"\\^]*c|n[\"\\^]*f[\"\\^]*o[\"\\^]*3[\"\\^]*2)|t[\"\\^]*s[\"\\^]*c))|n[\"\\^]*(?:b[\"\\^]*t[\"\\^]*s[\"\\^]*t[\"\\^]*a[\"\\^]*t|e[\"\\^]*t[\"\\^]*(?:c[\"\\^]*f[\"\\^]*g|d[\"\\^]*o[\"\\^]*m|s[\"\\^]*(?:h|t[\"\\^]*a[\"\\^]*t))|f[\"\\^]*s[\"\\^]*(?:a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n|s[\"\\^]*(?:h[\"\\^]*a[\"\\^]*r[\"\\^]*e|t[\"\\^]*a[\"\\^]*t))|l[\"\\^]*(?:b[\"\\^]*m[\"\\^]*g[\"\\^]*r|t[\"\\^]*e[\"\\^]*s[\"\\^]*t)|s[\"\\^]*l[\"\\^]*o[\"\\^]*o[\"\\^]*k[\"\\^]*u[\"\\^]*p|t[\"\\^]*(?:b[\"\\^]*a[\"\\^]*c[\"\\^]*k[\"\\^]*u[\"\\^]*p|c[\"\\^]*m[\"\\^]*d[\"\\^]*p[\"\\^]*r[\"\\^]*o[\"\\^]*m[\"\\^]*p[\"\\^]*t|f[\"\\^]*r[\"\\^]*s[\"\\^]*u[\"\\^]*t[\"\\^]*l))|o[\"\\^]*(?:f[\"\\^]*f[\"\\^]*l[\"\\^]*i[\"\\^]*n[\"\\^]*e|p[\"\\^]*e[\"\\^]*n[\"\\^]*f[\"\\^]*i[\"\\^]*l[\"\\^]*e[\"\\^]*s)|p[\"\\^]*(?:a[\"\\^]*(?:g[\"\\^]*e[\"\\^]*f[\"\\^]*i[\"\\^]*l[\"\\^]*e[\"\\^]*c[\"\\^]*o[\"\\^]*n[\"\\^]*f[\"\\^]*i|t[\"\\^]*h[\"\\^]*p[\"\\^]*i[\"\\^]*n)[\"\\^]*g|(?:b[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i|k[\"\\^]*t[\"\\^]*m[\"\\^]*o)[\"\\^]*n|e[\"\\^]*(?:n[\"\\^]*t[\"\\^]*n[\"\\^]*t|r[\"\\^]*f[\"\\^]*m[\"\\^]*o[\"\\^]*n)|n[\"\\^]*p[\"\\^]*u[\"\\^]*(?:n[\"\\^]*a[\"\\^]*t[\"\\^]*t[\"\\^]*e[\"\\^]*n[\"\\^]*d|t[\"\\^]*i[\"\\^]*l)|o[\"\\^]*(?:p[\"\\^]*d|w[\"\\^]*e[\"\\^]*r[\"\\^]*s[\"\\^]*h[\"\\^]*e[\"\\^]*l[\"\\^]*l)|r[\"\\^]*n[\"\\^]*(?:c[\"\\^]*n[\"\\^]*f[\"\\^]*g|(?:d[\"\\^]*r[\"\\^]*v|m[\"\\^]*n[\"\\^]*g)[\"\\^]*r|j[\"\\^]*o[\"\\^]*b[\"\\^]*s|p[\"\\^]*o[\"\\^]*r[\"\\^]*t|q[\"\\^]*c[\"\\^]*t[\"\\^]*l)|u[\"\\^]*(?:b[\"\\^]*p[\"\\^]*r[\"\\^]*n|s[\"\\^]*h[\"\\^]*(?:d|p[\"\\^]*r[\"\\^]*i[\"\\^]*n[\"\\^]*t[\"\\^]*e[\"\\^]*r[\"\\^]*c[\"\\^]*o[\"\\^]*n[\"\\^]*n[\"\\^]*e[\"\\^]*c[\"\\^]*t[\"\\^]*i[\"\\^]*o[\"\\^]*n[\"\\^]*s))|w[\"\\^]*(?:l[\"\\^]*a[\"\\^]*u[\"\\^]*n[\"\\^]*c[\"\\^]*h[\"\\^]*e[\"\\^]*r|s[\"\\^]*h))|q[\"\\^]*(?:a[\"\\^]*p[\"\\^]*p[\"\\^]*s[\"\\^]*r[\"\\^]*v|p[\"\\^]*r[\"\\^]*o[\"\\^]*c[\"\\^]*e[\"\\^]*s[\"\\^]*s|u[\"\\^]*s[\"\\^]*e[\"\\^]*r|w[\"\\^]*i[\"\\^]*n[\"\\^]*s[\"\\^]*t[\"\\^]*a)|r[\"\\^]*(?:d(?:[\"\\^]*p[\"\\^]*s[\"\\^]*i[\"\\^]*g[\"\\^]*n)?|e[\"\\^]*(?:f[\"\\^]*s[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|g(?:[\"\\^]*(?:i[\"\\^]*n[\"\\^]*i|s[\"\\^]*v[\"\\^]*r[\"\\^]*3[\"\\^]*2))?|l[\"\\^]*o[\"\\^]*g|(?:(?:p[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i|s[\"\\^]*c[\"\\^]*a)[\"\\^]*)?n|x[\"\\^]*e[\"\\^]*c)|i[\"\\^]*s[\"\\^]*e[\"\\^]*t[\"\\^]*u[\"\\^]*p|m[\"\\^]*d[\"\\^]*i[\"\\^]*r|o[\"\\^]*b[\"\\^]*o[\"\\^]*c[\"\\^]*o[\"\\^]*p[\"\\^]*y|p[\"\\^]*c[\"\\^]*(?:i[\"\\^]*n[\"\\^]*f[\"\\^]*o|p[\"\\^]*i[\"\\^]*n[\"\\^]*g)|s[\"\\^]*h|u[\"\\^]*n[\"\\^]*d[\"\\^]*l[\"\\^]*l[\"\\^]*3[\"\\^]*2|w[\"\\^]*i[\"\\^]*n[\"\\^]*s[\"\\^]*t[\"\\^]*a)|s[\"\\^]*(?:a[\"\\^]*n|c[\"\\^]*(?:h[\"\\^]*t[\"\\^]*a[\"\\^]*s[\"\\^]*k[\"\\^]*s|w[\"\\^]*c[\"\\^]*m[\"\\^]*d)|e[\"\\^]*(?:c[\"\\^]*e[\"\\^]*d[\"\\^]*i[\"\\^]*t|r[\"\\^]*v[\"\\^]*e[\"\\^]*r[\"\\^]*(?:(?:c[\"\\^]*e[\"\\^]*i[\"\\^]*p|w[\"\\^]*e[\"\\^]*r)[\"\\^]*o[\"\\^]*p[\"\\^]*t[\"\\^]*i[\"\\^]*n|m[\"\\^]*a[\"\\^]*n[\"\\^]*a[\"\\^]*g[\"\\^]*e[\"\\^]*r[\"\\^]*c[\"\\^]*m[\"\\^]*d)|t[\"\\^]*x)|f[\"\\^]*c|(?:h[\"\\^]*o[\"\\^]*w[\"\\^]*m[\"\\^]*o[\"\\^]*u[\"\\^]*n|u[\"\\^]*b[\"\\^]*s)[\"\\^]*t|x[\"\\^]*s[\"\\^]*t[\"\\^]*r[\"\\^]*a[\"\\^]*c[\"\\^]*e|y[\"\\^]*s[\"\\^]*(?:o[\"\\^]*c[\"\\^]*m[\"\\^]*g[\"\\^]*r|t[\"\\^]*e[\"\\^]*m[\"\\^]*i[\"\\^]*n[\"\\^]*f[\"\\^]*o))|t[\"\\^]*(?:a[\"\\^]*(?:k[\"\\^]*e[\"\\^]*o[\"\\^]*w[\"\\^]*n|p[\"\\^]*i[\"\\^]*c[\"\\^]*f[\"\\^]*g|s[\"\\^]*k[\"\\^]*(?:k[\"\\^]*i[\"\\^]*l[\"\\^]*l|l[\"\\^]*i[\"\\^]*s[\"\\^]*t))|(?:c[\"\\^]*m[\"\\^]*s[\"\\^]*e[\"\\^]*t[\"\\^]*u|f[\"\\^]*t)[\"\\^]*p|(?:(?:e[\"\\^]*l[\"\\^]*n[\"\\^]*e|i[\"\\^]*m[\"\\^]*e[\"\\^]*o[\"\\^]*u)[\"\\^]*|r[\"\\^]*a[\"\\^]*c[\"\\^]*e[\"\\^]*r[\"\\^]*(?:p[\"\\^]*)?)t|l[\"\\^]*n[\"\\^]*t[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*n|p[\"\\^]*m[\"\\^]*(?:t[\"\\^]*o[\"\\^]*o[\"\\^]*l|v[\"\\^]*s[\"\\^]*c[\"\\^]*m[\"\\^]*g[\"\\^]*r)|s[\"\\^]*(?:(?:d[\"\\^]*i[\"\\^]*s[\"\\^]*)?c[\"\\^]*o[\"\\^]*n|e[\"\\^]*c[\"\\^]*i[\"\\^]*m[\"\\^]*p|k[\"\\^]*i[\"\\^]*l[\"\\^]*l|p[\"\\^]*r[\"\\^]*o[\"\\^]*f)|y[\"\\^]*p[\"\\^]*e[\"\\^]*p[\"\\^]*e[\"\\^]*r[\"\\^]*f|z[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l)|u[\"\\^]*n[\"\\^]*(?:e[\"\\^]*x[\"\\^]*p[\"\\^]*o[\"\\^]*s[\"\\^]*e|i[\"\\^]*q[\"\\^]*u[\"\\^]*e[\"\\^]*i[\"\\^]*d|l[\"\\^]*o[\"\\^]*d[\"\\^]*c[\"\\^]*t[\"\\^]*r)|v[\"\\^]*s[\"\\^]*s[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n|w[\"\\^]*(?:a[\"\\^]*i[\"\\^]*t[\"\\^]*f[\"\\^]*o[\"\\^]*r|b[\"\\^]*a[\"\\^]*d[\"\\^]*m[\"\\^]*i[\"\\^]*n|(?:d[\"\\^]*s|e[\"\\^]*(?:c|v[\"\\^]*t))[\"\\^]*u[\"\\^]*t[\"\\^]*i[\"\\^]*l|h[\"\\^]*o[\"\\^]*a[\"\\^]*m[\"\\^]*i|i[\"\\^]*n[\"\\^]*(?:n[\"\\^]*t(?:[\"\\^]*3[\"\\^]*2)?|r[\"\\^]*s)|m[\"\\^]*i[\"\\^]*c|s[\"\\^]*c[\"\\^]*r[\"\\^]*i[\"\\^]*p[\"\\^]*t)|x[\"\\^]*c[\"\\^]*o[\"\\^]*p[\"\\^]*y)(?:\\.[\"\\^]*[0-9A-Z_a-z]+)?\\b",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 933100,
    "msg": "PHP Injection Attack: PHP Open Tag Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "<\\?(?:php[\\t-\\r \\x0b]|[\\t-\\r \\x0b=]|xml(?:[\\t-\\r \\x0b]+[^a-z]|:)|$)|\\[[/\\x5c]?php\\]|\\{/?php\\}",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 933120,
    "msg": "PHP Injection Attack: Configuration Directive Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "normalizePath"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:a(?:llow_url_(?:fopen|include)|pc.(?:coredump_unmap|en(?:able(?:_cli|d)|tries_hint)|(?:gc_)?ttl|mmap_file_mask|preload_path|s(?:erializer|hm_s(?:egments|ize)|lam_defense)|use_request_time)|rg_separator.(?:in|out)put|ssert.(?:active|(?:bai|quiet_eva)l|callback|exception|warning)|uto_(?:(?:ap|pre)pend_file|detect_line_endings|globals_jit))|b(?:cmath.scale|rowscap)|c(?:gi.(?:check_shebang_line|(?:discard_pat|np)h|f(?:ix_pathinfo|orce_redirect)|r(?:edirect_status_env|fc2616_headers))|hild_terminate|li(?:_server.color|.p(?:ager|rompt))|om.(?:a(?:llow_dcom|utoregister_(?:(?:casesensitiv|verbos)e|typelib))|(?:code_pag|typelib_fil)e|dotnet_version)|url.cainfo)|d(?:ate.(?:(?:default_l(?:at|ong)itud|timezon)e|sun(?:rise|set)_zenith)|ba.default_handler|efault_(?:(?:charse|socket_timeou)t|mimetype)|is(?:able_(?:classe|function)|play_(?:startup_)?error)s|oc(?:_roo|ref_(?:ex|roo))t)|e(?:n(?:able_(?:dl|post_data_reading)|gine)|rror_(?:(?:(?:ap|pre)pend_str|report)in|lo)g|x(?:i(?:f.(?:decode_(?:jis|unicode)_(?:intel|motorola)|encode_(?:jis|unicode))|t_on_timeout)|tension(?:_dir)?|p(?:ect.(?:log(?:file|user)|match_max|timeout)|ose_php)))|f(?:astcgi.(?:impersonate|logging)|fi.(?:enable|preload)|il(?:e_uploads|ter.default(?:_flags)?))|g(?:d.jpeg_ignore_warning|eoip.custom_directory)|h(?:ard_timeout|ighlight.(?:(?:commen|defaul)t|html|keyword|string)|tml_errors)|i(?:b(?:ase.(?:(?:allow_persisten|time(?:stamp)?forma)t|d(?:ateformat|efault_(?:charset|db|password|user))|max_(?:links|persistent))|m_db2.(?:binmode|i(?:5_(?:all(?:_pconnec|ow_commi)t|dbcs_alloc|ignore_userid)|nstance_name)))|conv.(?:in(?:put|ternal)|output)_encoding|g(?:binary.compact_strings|nore_(?:repeated_(?:errors|source)|user_abort))|m(?:a(?:gick.(?:locale_fix|progress_monitor|skip_version_check)|p.enable_insecure_rsh)|plicit_flush)|n(?:clude_path|put_encoding|t(?:ernal_encoding|l.(?:default_locale|error_level|use_exceptions))))|l(?:dap.max_links|og_errors(?:_max_len)?)|m(?:a(?:gic_quotes_(?:gpc|runtime)|il(?:.(?:add_x_header|force_extra_parameters|log)|parse.def_charset)|x_(?:execution_time|file_uploads|input_(?:nesting_level|time|vars)))|bstring.(?:detect_order|encoding_translation|func_overload|http_(?:input|output(?:_conv_mimetypes)?)|internal_encoding|language|regex_(?:retry|stack)_limit|s(?:trict_detection|ubstitute_character))|crypt.(?:algorithm|mode)s_dir|em(?:cache(?:.(?:allow_failover|c(?:hunk_size|ompress_threshold)|(?:default_por|lock_timeou)t|hash_(?:function|strategy)|max_failover_attempts|protocol|(?:session_)?redundancy)|d.(?:compression_(?:factor|t(?:hreshold|ype))|default_(?:binary_protocol|con(?:nect_timeout|sistent_hash))|s(?:e(?:rializer|ss_(?:binary(?:_protocol)?|con(?:nect_timeout|sistent_hash(?:_type)?)|lock(?:_(?:expire|retries|wait(?:_m(?:ax|in))?)|ing)|number_of_replicas|p(?:ersistent|refix)|r(?:andomize_replica_read|emove_failed(?:_servers)?)|s(?:asl_(?:password|username)|erver_failure_limit)))|tore_retry_count)|use_sasl))|ory_limit)|ysql(?:.(?:allow_(?:local_infile|persistent)|connect_timeout|default_(?:(?:hos|socke)t|p(?:assword|ort)|user)|max_(?:links|persistent)|trace_mode)|i.(?:allow_(?:local_infile|persistent)|default_(?:(?:hos|socke)t|p(?:ort|w)|user)|local_infile_directory|max_(?:links|persistent)|r(?:econnect|ollback_on_cached_plink))|nd.(?:collect_(?:memory_)?statistics|debug|(?:fetch_data_cop|sha256_server_public_ke)y|log_mask|mempool_default_size|net_(?:cmd_buffer_size|read_(?:buffer_size|timeout))|trace_alloc)))|o(?:ci8.(?:(?:connection_clas|event|old_oci_close_semantic)s|default_prefetch|max_persistent|p(?:ersistent_timeout|ing_interval|r(?:efetch_lob_size|ivileged_connect))|statement_cache_size)|dbc.(?:(?:allow|check)_persistent|default(?:_(?:cursortype|db|pw|user)|binmode|lrl)|max_(?:links|persistent))|p(?:cache.(?:blacklist_filename|c(?:ache_id|onsistency_checks)|dups_fix|e(?:nable(?:_(?:cli|file_override))?|rror_log)|f(?:ast_shutdown|ile_(?:cache(?:_(?:consistency_checks|fallback|only))?|update_protection)|orce_restart_timeout)|(?:huge_code_page|save_comment)s|in(?:herited_hack|terned_strings_buffer)|jit(?:_(?:b(?:isect_limit|(?:lacklist_(?:root|side)_trac|uffer_siz)e)|debug|hot_(?:func|loop|return|side_exit)|max_(?:exit_counter|(?:loop_unro|polymorphic_ca)ll|r(?:ecursive_(?:call|return)|oot_trace)|side_trace)s|prof_threshold))?|lo(?:ckfile_path|g_verbosity_level)|m(?:ax_(?:accelerated_files|(?:file_siz|wasted_percentag)e)|emory_consumption|map_base)|opt(?:_debug|imization)_level|pr(?:e(?:ferred_memory_model|load(?:_user)?)|otect_memory)|re(?:cord_warnings|strict_api|validate_(?:freq|path))|use_cwd|validate_(?:permission|root|timestamps))|en(?:_basedir|ssl.ca(?:file|path)))|utput_(?:(?:buffer|encod)ing|handler))|p(?:cre.(?:(?:backtrack|recursion)_lim|j)it|do(?:_odbc.(?:connection_pooling|db2_instance_name)|.dsn)|gsql.(?:a(?:llow|uto_reset)_persistent|(?:ignore|log)_notice|max_(?:links|persistent))|h(?:ar.(?:cache_list|re(?:adonly|quire_hash))|pdbg.(?:eol|path))|recision|ost_max_size)|r(?:e(?:alpath_cache_(?:size|ttl)|gister_argc_argv|port_(?:memleaks|zend_debug)|quest_order)|unkit.(?:internal_override|superglobal))|s(?:e(?:aslog.(?:appender(?:_retry)?|buffer_(?:disabled_in_cli|size)|d(?:efault_(?:basepath|datetime_format|logger|template)|isting_(?:(?:by_hou|folde)r|type))|ignore_warning|level|re(?:call_depth|mote_(?:hos|por|timeou)t)|t(?:hrow_exception|r(?:ace_(?:e(?:rror|xception)|notice|warning)|im_wrap))|use_buffer)|ndmail_(?:from|path)|rialize_precision|ssion.(?:auto_start|c(?:ache_(?:expire|limiter)|ookie_(?:domain|httponly|(?:lifetim|s(?:amesit|ecur))e|path))|entropy_(?:file|length)|gc_(?:divisor|maxlifetime|probability)|hash_(?:bits_per_character|function)|(?:lazy_writ|nam)e|referer_check|s(?:ave_(?:handler|path)|erialize_handler|id_(?:bits_per_character|length))|trans_sid_(?:host|tag)s|u(?:pload_progress.(?:cleanup|enabled|(?:min_)?freq|name|prefix)|se_(?:(?:only_)?cookies|strict_mode|trans_sid))))|hort_open_tag|mtp(?:_port)?|oap.wsdl_cache(?:_(?:dir|enabled|limit|ttl))?|ql(?:.safe_mode|ite3.(?:defensive|extension_dir))|tomp.default_(?:broker|(?:connection|read)_timeout_u?sec)|woole.(?:aio_thread_num|display_errors|enable_(?:coroutine|library|preemptive_scheduler)|(?:fast_serializ|u(?:nixsock_buffer_siz|se_(?:namespac|shortnam)))e)|ys(?:_temp_dir|log.(?:f(?:acility|ilter)|ident)|vshm.init_mem))|t(?:aint.e(?:nable|rror_level)|idy.(?:clean_output|default_config)|ra(?:ck_errors|der.real_(?:precision|round_mode)))|u(?:nserialize_(?:callback_func|max_depth)|opz.(?:disable|exit|overloads)|pload(?:_(?:max_filesize|tmp_dir)|progress.file.filename_template)|rl_rewriter.(?:host|tag)s|ser_(?:agent|dir|ini.(?:cache_ttl|filename)))|v(?:8js.(?:flag|max_disposed_context)s|ariables_order|ld.(?:(?:activ|execut)e|skip_(?:ap|pre)pend))|w(?:in(?:cache.(?:chkinterval|enablecli|f(?:c(?:achesize|enabled(?:filter)?|ndetect)|ile(?:count|mapdir))|(?:ignorelis|namesal)t|maxfilesize|oc(?:achesize|enabled(?:filter)?)|reroute(?:_enabled|ini)|s(?:cachesize|rwlocks)|ttlmax|uc(?:achesize|enabled))|dows.show_crt_warning)|khtmltox.graphics)|x(?:bithack|hprof.output_dir|mlrpc_error(?:_number|s))|ya(?:c(?:.(?:compress_threshold|debug|enable(?:_cli)?|(?:key|value)s_memory_size|serializer)|onf.(?:check_dela|director)y)|f.(?:action_prefer|cache_config|environ|forward_limit|l(?:ibrary|owcase_path)|name_s(?:eparator|uffix)|use_(?:namespace|spl_autoload))|ml.(?:decode_(?:binary|(?:ph|timestam)p)|output_(?:canonical|indent|width))|r.(?:(?:connect_)?timeout|debug|expose_info|packager)|z.(?:keepalive|log_mask))|z(?:end(?:_extension|.(?:assertions|(?:detect_unicod|multibyt)e|e(?:nable_gc|xception_(?:ignore_args|string_param_max_len))|s(?:cript_encoding|ignal_check)))|lib.output_(?:compression(?:_level)?|handler)|ookeeper.(?:recv_timeout|sess(?:_lock_wait|ion_lock))))[\\t-\\r \\x0b]*=[^=]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 933130,
    "msg": "PHP Injection Attack: Variables Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "normalizePath",
      "urlDecodeUni"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        "$GLOBALS",
        "$_COOKIE",
        "$_ENV",
        "$_FILES",
        "$_GET",
        "$_POST",
        "$_REQUEST",
        "$_SERVER",
        "$_SESSION",
        "$argc",
        "$argv",
        "$http_âresponse_âheader",
        "$php_âerrormsg",
        "$HTTP_COOKIE_VARS",
        "$HTTP_ENV_VARS",
        "$HTTP_GET_VARS",
        "$HTTP_POST_FILES",
        "$HTTP_POST_VARS",
        "$HTTP_RAW_POST_DATA",
        "$HTTP_REQUEST_VARS",
        "$HTTP_SERVER_VARS"
      ],
      "negated": false
    }
  },
  {
    "id": 933135,
    "msg": "PHP Injection Attack: Variable Access Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "\\$[\\t-\\r ]*\\{[\\t-\\r ]*[^\\t-\\r ][^\\{\\}]*\\}",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 933140,
    "msg": "PHP Injection Attack: I/O Stream Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "php://(?:std(?:in|out|err)|(?:in|out)put|f(?:d|ilter)|memory|temp)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 933200,
    "msg": "PHP Injection Attack: Wrapper scheme detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "removeNulls",
      "cmdLine"
    ],
    "op": {
      "type": "rx",
      "source": "(?:bzip2|expect|glob|ogg|(?:ph|r)ar|ssh2(?:.(?:s(?:hell|(?:ft|c)p)|exec|tunnel))?|z(?:ip|lib))://",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 933150,
    "msg": "PHP Injection Attack: High-Risk PHP Function Name Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "pm",
      "phrases": [
        "array_diff_uassoc",
        "array_diff_ukey",
        "array_filter",
        "array_intersect_uassoc",
        "array_intersect_ukey",
        "array_key_exists",
        "array_map",
        "array_push",
        "array_reduce",
        "array_shift",
        "array_udiff",
        "array_udiff_assoc",
        "array_udiff_uassoc",
        "array_uintersect",
        "array_uintersect_assoc",
        "array_uintersect_uassoc",
        "array_values",
        "base64_decode",
        "base64_encode",
        "bson_decode",
        "bson_encode",
        "bzdecompress",
        "bzopen",
        "call_user_func",
        "class_exists",
        "convert_uuencode",
        "curl_exec",
        "curl_file_create",
        "curl_init",
        "debug_backtrace",
        "dirname",
        "error_reporting",
        "escapeshellarg",
        "escapeshellcmd",
        "exif_imagetype",
        "exif_read_data",
        "exif_tagname",
        "exif_thumbnail",
        "fclose",
        "file_exists",
        "file_get_contents",
        "finfo_open",
        "fsockopen",
        "ftp_connect",
        "ftp_get",
        "ftp_nb_get",
        "ftp_nb_put",
        "ftp_put",
        "function_exists",
        "fwrite",
        "get_cfg_var",
        "get_class",
        "get_class_methods",
        "get_class_vars",
        "get_current_user",
        "get_defined_constants",
        "get_defined_functions",
        "get_defined_vars",
        "get_meta_tags",
        "getcwd",
        "getenv",
        "getimagesize",
        "getlastmod",
        "getmygid",
        "getmyinode",
        "getmypid",
        "getmyuid",
        "gzcompress",
        "gzdecode",
        "gzdeflate",
        "gzencode",
        "gzfile",
        "gzinflate",
        "gzopen",
        "gzread",
        "gzuncompress",
        "gzwrite",
        "hash_file",
        "hash_hmac_file",
        "hash_update_file",
        "header_register_callback",
        "hex2bin",
        "highlight_file",
        "html_entity_decode",
        "htmlentities",
        "htmlspecialchars",
        "htmlspecialchars_decode",
        "image2wbmp",
        "imagecreatefromgif",
        "imagecreatefromjpeg",
        "imagecreatefrompng",
        "imagecreatefromwbmp",
        "imagecreatefromxbm",
        "imagecreatefromxpm",
        "imagegd",
        "imagegd2",
        "ini_get",
        "ini_get_all",
        "ini_set",
        "iptcembed",
        "is_array",
        "is_dir",
        "is_executable",
        "is_file",
        "is_null",
        "is_numeric",
        "is_object",
        "is_readable",
        "is_writable",
        "is_writeable",
        "iterator_apply",
        "json_decode",
        "json_encode",
        "mb_ereg",
        "mb_ereg_match",
        "mb_ereg_replace",
        "mb_ereg_replace_callback",
        "mb_eregi",
        "mb_eregi_replace",
        "mb_parse_str",
        "md5_file",
        "method_exists",
        "move_uploaded_file",
        "mysql_query",
        "number_format",
        "ob_clean",
        "ob_end_clean",
        "ob_end_flush",
        "ob_flush",
        "ob_get_clean",
        "ob_get_contents",
        "ob_get_flush",
        "ob_start",
        "odbc_connect",
        "odbc_exec",
        "odbc_execute",
        "odbc_result",
        "odbc_result_all",
        "parse_ini_file",
        "parse_str",
        "parse_url",
        "pfsockopen",
        "pg_connect",
        "pg_execute",
        "pg_prepare",
        "pg_query",
        "php_strip_whitespace",
        "php_uname",
        "phpversion",
        "posix_getegid",
        "posix_geteuid",
        "posix_getgid",
        "posix_getlogin",
        "posix_getpwnam",
        "posix_getpwuid",
        "posix_kill",
        "posix_mkfifo",
        "posix_mknod",
        "posix_ttyname",
        "preg_match",
        "preg_match_all",
        "preg_replace",
        "preg_replace_callback",
        "preg_replace_callback_array",
        "preg_split",
        "print_r",
        "proc_close",
        "proc_get_status",
        "proc_nice",
        "proc_open",
        "proc_terminate",
        "putenv",
        "rawurldecode",
        "rawurlencode",
        "read_exif_data",
        "readdir",
        "readgzfile",
        "register_shutdown_function",
        "register_tick_function",
        "rename_function",
        "runkit_constant_add",
        "runkit_constant_redefine",
        "runkit_function_add",
        "runkit_function_copy",
        "runkit_function_redefine",
        "runkit_function_rename",
        "runkit_method_add",
        "runkit_method_copy",
        "runkit_method_redefine",
        "runkit_method_rename",
        "session_set_save_handler",
        "session_start",
        "set_error_handler",
        "set_exception_handler",
        "set_include_path",
        "set_magic_quotes_runtime",
        "setdefaultstub",
        "settype",
        "sha1_file",
        "shell_exec",
        "show_source",
        "simplexml_load_file",
        "simplexml_load_string",
        "socket_connect",
        "socket_create",
        "spl_autoload_register",
        "sqlite_array_query",
        "sqlite_create_aggregate",
        "sqlite_create_function",
        "sqlite_exec",
        "sqlite_open",
        "sqlite_popen",
        "sqlite_query",
        "sqlite_single_query",
        "sqlite_unbuffered_query",
        "str_replace",
        "stream_context_create",
        "stream_socket_client",
        "stripcslashes",
        "stripslashes",
        "strlen",
        "strpos",
        "strrev",
        "strtolower",
        "strtotime",
        "strtoupper",
        "uasort",
        "ucfirst",
        "uksort",
        "urldecode",
        "urlencode",
        "var_dump",
        "zlib_decode"
      ],
      "negated": false
    },
    "chain": [
      {
        "target": "MATCHED_VARS",
        "transforms": [],
        "op": {
          "type": "pm",
          "phrases": [
            "(",
            ")"
          ],
          "negated": false
        }
      }
    ]
  },
  {
    "id": 933160,
    "msg": "PHP Injection Attack: High-Risk PHP Function Call Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "\\b\\(?[\"']*(?:assert(?:_options)?|c(?:hr|reate_function)|e(?:val|x(?:ec|p))|f(?:ile(?:group)?|open|puts)|glob|i(?:mage(?:gif|(?:jpe|pn)g|wbmp|xbm)|s_a|ntval)|m(?:d5|kdir)|o(?:pendir|rd)|p(?:assthru|hpinfo|open|r(?:intf|ev))|r(?:eadfile|trim)|s(?:t(?:rip_tags|at)|ubstr|ystem)|tmpfile|u(?:n(?:(?:pac|lin)k|serialize)|sort))(?:/\\*[^\\*]*\\*+(?:[^\\*/][^\\*]*\\*+)*/|(?:#|//)[^\\n\\r]*[\\n\\r]|[\\t-\\r \\x0b\"])*[\"']*\\)?[\\t-\\r \\x0b]*\\([^\\)]*\\)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 933170,
    "msg": "PHP Injection Attack: Serialized Object Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "[oOcC]:\\d+:\".+?\":\\d+:\\{.*\\}",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 933180,
    "msg": "PHP Injection Attack: Variable Function Call Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "\\$+(?:[A-Z_a-z\\x7f-\\xff][0-9A-Z_a-z\\x7f-\\xff]*|[\\t-\\r \\x0b]*\\{[^\\}]+\\})(?:[\\t-\\r \\x0b]|\\[(?:[^\\[\\]]|\\[[^\\]]+\\])+\\]|\\{[^\\}]+\\}|/(?:\\*[^\\*]*\\*+(?:[^\\*/][^\\*]*\\*+)*/|/[^\\n\\r]*[\\n\\r])|#[^\\n\\r]*[\\n\\r])*\\(.*\\)",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 933210,
    "msg": "PHP Injection Attack: Variable Function Call Found",
    "severity": "CRITICAL",
    "tags": [
      "attack-injection-php"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "replaceComments",
      "removeWhitespace"
    ],
    "op": {
      "type": "rx",
      "source": "(?:\\((?:.+\\)(?:[\"'][\\-0-9A-Z_a-z]+[\"'])?\\(.+|[^\\)]*string[^\\)]*\\)[\\t-\\r \\x0b\"'\\-\\.0-9A-\\[\\]_a-\\{\\}]+\\([^\\)]*)|(?:\\[[0-9]+\\]|\\{[0-9]+\\}|\\$[^\\(\\),\\./;\\x5c]+|[\"'][\\-0-9A-Z\\x5c_a-z]+[\"'])\\(.+)\\);",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934100,
    "msg": "Node.js Injection Attack 1/2",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce",
      "attack-injection-generic"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "jsDecode",
      "removeWhitespace",
      "base64Decode",
      "urlDecodeUni",
      "jsDecode",
      "removeWhitespace"
    ],
    "multiMatch": true,
    "op": {
      "type": "rx",
      "source": "_(?:\\$\\$ND_FUNC\\$\\$_|_js_function)|(?:\\beval|new[\\t-\\r \\x0b]+Function[\\t-\\r \\x0b]*)\\(|(?:String\\.fromCharCod|Module:prototyp)e|function\\(\\)\\{|this\\.constructor|module\\.exports=|\\([\\t-\\r \\x0b]*[^0-9A-Z_a-z]child_process[^0-9A-Z_a-z][\\t-\\r \\x0b]*\\)|cons(?:tructor:constructor|ole(?:\\.(?:(?:debu|lo)g|error|info|trace|warn)(?:\\.call)?\\(|\\[[\"'`](?:(?:debu|lo)g|error|info|trace|warn)[\"'`]\\]))|process(?:\\.(?:(?:a(?:ccess|ppendfile|rgv|vailability)|c(?:aveats|h(?:mod|own)|(?:los|opyfil)e|p|reate(?:read|write)stream)|ex(?:ec(?:file)?|ists)|f(?:ch(?:mod|own)|data(?:sync)?|s(?:tat|ync)|utimes)|inodes|l(?:chmod|ink|stat|utimes)|mkd(?:ir|temp)|open(?:dir)?|r(?:e(?:ad(?:dir|file|link|v)?|name)|m)|s(?:pawn(?:file)?|tat|ymlink)|truncate|u(?:n(?:link|watchfile)|times)|w(?:atchfile|rite(?:file|v)?))(?:sync)?(?:\\.call)?\\(|binding|constructor|env|global|main(?:Module)?|process|require)|\\[[\"'`](?:(?:a(?:ccess|ppendfile|rgv|vailability)|c(?:aveats|h(?:mod|own)|(?:los|opyfil)e|p|reate(?:read|write)stream)|ex(?:ec(?:file)?|ists)|f(?:ch(?:mod|own)|data(?:sync)?|s(?:tat|ync)|utimes)|inodes|l(?:chmod|ink|stat|utimes)|mkd(?:ir|temp)|open(?:dir)?|r(?:e(?:ad(?:dir|file|link|v)?|name)|m)|s(?:pawn(?:file)?|tat|ymlink)|truncate|u(?:n(?:link|watchfile)|times)|w(?:atchfile|rite(?:file|v)?))(?:sync)?|binding|constructor|env|global|main(?:Module)?|process|require)[\"'`]\\])|(?:binding|constructor|env|global|main(?:Module)?|process|require)\\[|require(?:\\.(?:resolve(?:\\.call)?\\(|main|extensions|cache)|\\[[\"'`](?:(?:resolv|cach)e|main|extensions)[\"'`]\\])",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934110,
    "msg": "Possible Server Side Request Forgery (SSRF) Attack: Cloud provider metadata URL in Parameter",
    "severity": "CRITICAL",
    "tags": [
      "attack-ssrf"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "pm",
      "phrases": [
        "http://instance-data/latest/",
        "http://169.254.169.254/latest/",
        "http://2852039166/latest/",
        "http://025177524776/latest/",
        "http://0251.0376.0251.0376/latest/",
        "http://0xA9.0xFE.0xA9.0xFE/latest/",
        "http://0xA9FEA9FE/latest/",
        "http://0251.254.169.254/latest/",
        "http://[::ffff:a9fe:a9fe]/latest/",
        "http://[0:0:0:0:0:ffff:a9fe:a9fe]/latest/",
        "http://[0:0:0:0:0:ffff:169.254.169.254]/latest/",
        "http://169.254.169.254.nip.io/latest/",
        "http://nicob.net/redir-http-169.254.169.254:80-",
        "http://2130706433/",
        "http://3232235521/",
        "http://3232235777/",
        "http://2852039166/",
        "http://[::]:",
        "http://localtest.me",
        "http://127.0.0.1.nip.io",
        "http://127.127.127.127",
        "http://127.0.1.3",
        "http://127.0.0.0",
        "http://127.0.0.1",
        "http://0.0.0.0",
        "http://localhost",
        "http://0177.0.0.1/",
        "http://[::1]",
        "http://[0000::1]",
        "http://[::ffff:127.0.0.1]",
        "http://[0:0:0:0:0:ffff:127.0.0.1]",
        "http://0/",
        "http://127.1",
        "http://127.0.1",
        "http:127.0.0.1",
        "http://169.254.170.2/v2",
        "http://169.254.169.254/computeMetadata/v1/",
        "http://metadata.google.internal/computeMetadata/v1/",
        "http://metadata/computeMetadata/v1/",
        "http://2852039166/computeMetadata/v1/",
        "http://025177524776/computeMetadata/v1/",
        "http://0251.0376.0251.0376/computeMetadata/v1/",
        "http://[::ffff:a9fe:a9fe]/computeMetadata/v1/",
        "http://[0:0:0:0:0:ffff:a9fe:a9fe]/computeMetadata/v1/",
        "http://[0:0:0:0:0:ffff:169.254.169.254]/computeMetadata/v1/",
        "http://169.254.169.254.nip.io/computeMetadata/v1/",
        "http://0xA9.0xFE.0xA9.0xFE/computeMetadata/v1/",
        "http://0xA9FEA9FE/computeMetadata/v1/",
        "http://0251.254.169.254/computeMetadata/v1/",
        "gopher://metadata.google.internal",
        "http://metadata.google.internal/computeMetadata/v1/instance/disks/?recursive=true",
        "http://metadata.google.internal/computeMetadata/v1beta1/",
        "http://169.254.169.254/metadata/v1.json",
        "https://metadata.packet.net/userdata",
        "http://169.254.169.254/metadata/v1/",
        "http://169.254.169.254/metadata/instance?api-version=2017-04-02",
        "http://169.254.169.254/metadata/instance/network/interface/0/ipv4/ipAddress/0/publicIpAddress?api-version=2017-04-02&format=text",
        "http://2852039166/metadata/v1/",
        "http://025177524776/metadata/v1/",
        "http://0251.0376.0251.0376/metadata/v1/",
        "http://[::ffff:a9fe:a9fe]/metadata/v1/",
        "http://[0:0:0:0:0:ffff:a9fe:a9fe]/metadata/v1/",
        "http://[0:0:0:0:0:ffff:169.254.169.254]/metadata/v1/",
        "http://169.254.169.254.nip.io/metadata/v1/",
        "http://0xA9.0xFE.0xA9.0xFE/metadata/v1/",
        "http://0xA9FEA9FE/metadata/v1/",
        "http://0251.254.169.254/metadata/v1/",
        "http://169.254.169.254/openstack",
        "http://169.254.169.254/2009-04-04/meta-data/",
        "http://192.0.0.192/latest/",
        "http://100.100.100.200/latest/meta-data/",
        "http://rancher-metadata/",
        "http://127.0.0.1:2375",
        "http://2130706433:2375/",
        "http://[::]:2375/",
        "http://[0000::1]:2375/",
        "http://[0:0:0:0:0:ffff:127.0.0.1]:2375/",
        "http://2130706433:2375/",
        "http://017700000001:2375/",
        "http://0x7f000001:2375/",
        "http://0xc0a80014:2375/",
        "http://127.0.0.1:2379",
        "http://169ã254ã169ã254",
        "http://169ï½¡254ï½¡169ï½¡254",
        "http://â¯â¨ãâ¡â¤â£ãâ¯â¨ï½¡â¡â¤â£",
        "http://âªâ§ââ¨ï½¡âªâ§ââï½¡âªâ§ââ¨ï½¡âªâ§ââ",
        "http://âªâ§ââ¨ââââ¨ââ",
        "http://â¡â§â¤â¡âªâ¢â¨â â¥â¥",
        "http://â£â¡â¤ï½¡â¤â âªï½¡â£â¡â¤ï½¡â¤â âª",
        "http://âªâ¡â¤â ãâªâ¢â¦â¥ãâªâ¡â¤â ãâªâ¢â¦â¥",
        "http://âªâªâ¡â¤â ï½¡âªâªâªâ¢â¦â¥ï½¡âªâªâªâªâ¡â¤â ï½¡âªâªâªâªâªâ¢â¦â¥",
        "http://[::â â¥â¨ï½¡â¡â¤â£ï½¡â¯â¨ï½¡â¡â¤â£]",
        "http://[::ââââ:â â¥â¨ãâ¡â¤â£ãâ¯â¨ãâ¡â¤â£]",
        "http://âªâ§ââ¨ãâªâ¢â¦â¥ãâ£â¢â¤â â§",
        "http://âªâ§ââ¨ï½¡â¯â¥â§â¨â¥â¥â¡",
        "http://âªâªâ¡â¤â ãâ¯â¥â§â¨â¥â¥â¡",
        "http://âªâªâ¡â¤â ï½¡âªâ§ââï½¡â£â¢â¤â â§",
        "jar:http://127.0.0.1!/",
        "jar:https://127.0.0.1!/",
        "jar:ftp://127.0.0.1!/",
        "gopher://127.0.0.1",
        "gopher://localhost",
        "http://localhost:9001/2018-06-01/runtime/"
      ],
      "negated": false
    }
  },
  {
    "id": 934190,
    "msg": "Possible Server Side Request Forgery (SSRF) Attack: Scheme-less localhost or internal hostname detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-ssrf"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "pm",
      "phrases": [
        "localhost/",
        "localhost.localdomain/",
        "localhost4/",
        "localhost4.localdomain4/",
        "ipv6-localhost/",
        "ip6-loopback/",
        "host.docker.internal/",
        "gateway.docker.internal/",
        "kubernetes.docker.internal/",
        "host.containers.internal/",
        "kubernetes.default.svc.cluster.local/",
        "localtest.me/",
        "lvh.me/"
      ],
      "negated": false
    }
  },
  {
    "id": 934130,
    "msg": "JavaScript Prototype Pollution",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce",
      "attack-injection-generic"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "jsDecode"
    ],
    "multiMatch": true,
    "op": {
      "type": "rx",
      "source": "__proto__|constructor[\\t-\\r \\x0b]*(?:\\.|\\]?\\[)[\\t-\\r \\x0b]*prototype",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934150,
    "msg": "Ruby Injection Attack",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce",
      "attack-injection-generic"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "Process[\\t-\\r \\x0b]*\\.[\\t-\\r \\x0b]*spawn[\\t-\\r \\x0b]*\\(",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934160,
    "msg": "Node.js DoS attack",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce",
      "attack-injection-generic"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "jsDecode",
      "base64Decode",
      "urlDecodeUni",
      "jsDecode",
      "replaceComments"
    ],
    "multiMatch": true,
    "op": {
      "type": "rx",
      "source": "while[\\t-\\r \\x0b]*\\([\\t-\\r \\x0b\\(]*(?:!+(?:false|null|undefined|NaN|[\\+\\-]?0|\"{2}|'{2}|`{2})|(?:!!)*(?:(?:t(?:rue|his)|[\\+\\-]?(?:Infinity|[1-9][0-9]*)|new [A-Za-z][0-9A-Z_a-z]*|window|String|(?:Boolea|Functio)n|Object|Array)\\b|\\{[^\\}]*\\}|\\[[^\\]]*\\]|\"[^\"]+\"|'[^']+'|`[^`]+`)).*\\)",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934170,
    "msg": "PHP data scheme attack",
    "severity": "CRITICAL",
    "tags": [
      "attack-ssrf"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "^(?:json\\.)?data:(?:(?:\\*|[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]+)/(?:\\*|[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]+)|\\*)(?:[\\t-\\r \\x0b]*;[\\t-\\r \\x0b]*(?:charset[\\t-\\r \\x0b]*=[\\t-\\r \\x0b]*\"?(?:iso-8859-15?|utf-8|windows-1252)\\b\"?|(?:[^\\t-\\r \\x0b-\"\\(\\),/:-\\?\\[-\\]c\\{\\}]|c(?:[^!\"\\(\\),/:-\\?\\[-\\]h\\{\\}]|h(?:[^!\"\\(\\),/:-\\?\\[-\\]a\\{\\}]|a(?:[^!\"\\(\\),/:-\\?\\[-\\]r\\{\\}]|r(?:[^!\"\\(\\),/:-\\?\\[-\\]s\\{\\}]|s(?:[^!\"\\(\\),/:-\\?\\[-\\]e\\{\\}]|e[^!\"\\(\\),/:-\\?\\[-\\]t\\{\\}]))))))[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]*[\\t-\\r \\x0b]*=[\\t-\\r \\x0b]*[^!\\(\\),/:-\\?\\[-\\]\\{\\}]+);?)*(?:[\\t-\\r \\x0b]*,[\\t-\\r \\x0b]*(?:(?:\\*|[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]+)/(?:\\*|[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]+)|\\*)(?:[\\t-\\r \\x0b]*;[\\t-\\r \\x0b]*(?:charset[\\t-\\r \\x0b]*=[\\t-\\r \\x0b]*\"?(?:iso-8859-15?|utf-8|windows-1252)\\b\"?|(?:[^\\t-\\r \\x0b-\"\\(\\),/:-\\?\\[-\\]c\\{\\}]|c(?:[^!\"\\(\\),/:-\\?\\[-\\]h\\{\\}]|h(?:[^!\"\\(\\),/:-\\?\\[-\\]a\\{\\}]|a(?:[^!\"\\(\\),/:-\\?\\[-\\]r\\{\\}]|r(?:[^!\"\\(\\),/:-\\?\\[-\\]s\\{\\}]|s(?:[^!\"\\(\\),/:-\\?\\[-\\]e\\{\\}]|e[^!\"\\(\\),/:-\\?\\[-\\]t\\{\\}]))))))[^!\"\\(\\),/:-\\?\\[-\\]\\{\\}]*[\\t-\\r \\x0b]*=[\\t-\\r \\x0b]*[^!\\(\\),/:-\\?\\[-\\]\\{\\}]+);?)*)*",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 934200,
    "msg": "Server-Side Template Injection (SSTI) Attack",
    "severity": "CRITICAL",
    "tags": [
      "attack-ssti",
      "attack-injection-generic"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "(?:\\{\\{[^\\}]*?(?:[\\(\\*]|__)[^\\}]*?\\}|#\\{[^\\}]*?(?:[\\(\\*]|__)[^\\}]*?)\\}|<%=?[\\t-\\r \\x0b]*[^%]*?(?:[\\(\\*]|__)[^%]*?%>",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 941100,
    "msg": "XSS Attack Detected via libinjection",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "detectXSS",
      "negated": false
    }
  },
  {
    "id": 941110,
    "msg": "XSS Filter - Category 1: Script Tag Vector",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<script[^>]*>(?:[\\t-\\r ]|[^\\t-\\r ])*?",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941120,
    "msg": "XSS Filter - Category 2: Event Handler Vector",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "[\\t-\\r \"'\\(,/-9;=`]on[a-z]{3,50}[\\t-\\r \\(,;]*?=[^=]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941130,
    "msg": "XSS Filter - Category 3: Attribute Vector",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": ".(?:\\b(?:(?:x(?:link:href|html|mlns)|data:text/html|formaction)\\b|pattern[\\t-\\r \\x0b]*=)|(?:!ENTITY[\\t-\\r \\x0b]+(?:%[\\t-\\r \\x0b]+)?[^\\t-\\r \\x0b]+[\\t-\\r \\x0b]+(?:SYSTEM|PUBLIC)|@import|;base64)\\b)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941140,
    "msg": "XSS Filter - Category 4: Javascript URI Vector",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls",
      "removeWhitespace"
    ],
    "op": {
      "type": "rx",
      "source": "[a-z]+=(?:[^:=]+:[^;]+;)*?[^:=]+:url\\(javascript",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941160,
    "msg": "NoScript XSS InjectionChecker: HTML Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<[^0-9<>A-Z_a-z]*(?:[^\\t-\\r \\x0b\"'<>]*:)?[^0-9<>A-Z_a-z]*[^0-9A-Z_a-z]*?(?:s[^0-9A-Z_a-z]*?(?:c[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?p[^0-9A-Z_a-z]*?t|t[^0-9A-Z_a-z]*?y[^0-9A-Z_a-z]*?l[^0-9A-Z_a-z]*?e|v[^0-9A-Z_a-z]*?g|e[^0-9A-Z_a-z]*?t[^0-9>A-Z_a-z])|f[^0-9A-Z_a-z]*?o[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?m|d[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?a[^0-9A-Z_a-z]*?l[^0-9A-Z_a-z]*?o[^0-9A-Z_a-z]*?g|m[^0-9A-Z_a-z]*?(?:a[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?q[^0-9A-Z_a-z]*?u[^0-9A-Z_a-z]*?e[^0-9A-Z_a-z]*?e|e[^0-9A-Z_a-z]*?t[^0-9A-Z_a-z]*?a[^0-9>A-Z_a-z])|(?:l[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?n[^0-9A-Z_a-z]*?k|o[^0-9A-Z_a-z]*?b[^0-9A-Z_a-z]*?j[^0-9A-Z_a-z]*?e[^0-9A-Z_a-z]*?c[^0-9A-Z_a-z]*?t|e[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?b[^0-9A-Z_a-z]*?e[^0-9A-Z_a-z]*?d|a[^0-9A-Z_a-z]*?(?:p[^0-9A-Z_a-z]*?p[^0-9A-Z_a-z]*?l[^0-9A-Z_a-z]*?e[^0-9A-Z_a-z]*?t|u[^0-9A-Z_a-z]*?d[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?o|n[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?a[^0-9A-Z_a-z]*?t[^0-9A-Z_a-z]*?e)|p[^0-9A-Z_a-z]*?a[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?a[^0-9A-Z_a-z]*?m|i?[^0-9A-Z_a-z]*?f[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?a[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?e|b[^0-9A-Z_a-z]*?(?:a[^0-9A-Z_a-z]*?s[^0-9A-Z_a-z]*?e|o[^0-9A-Z_a-z]*?d[^0-9A-Z_a-z]*?y|i[^0-9A-Z_a-z]*?n[^0-9A-Z_a-z]*?d[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?n[^0-9A-Z_a-z]*?g[^0-9A-Z_a-z]*?s)|i[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?a?[^0-9A-Z_a-z]*?g[^0-9A-Z_a-z]*?e?|v[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?d[^0-9A-Z_a-z]*?e[^0-9A-Z_a-z]*?o)[^0-9>A-Z_a-z])|(?:<[0-9A-Z_a-z][^\\t-\\r \\x0b/]*[\\t-\\r \\x0b/]|[\"'](?:[^\\t-\\r \\x0b/]*[\\t-\\r \\x0b/])?)(?:background|formaction|lowsrc|on(?:a(?:bort|ctivate|d(?:apteradded|dtrack)|fter(?:print|(?:scriptexecu|upda)te)|lerting|n(?:imation(?:cancel|end|iteration|start)|tennastatechange)|ppcommand|u(?:dio(?:end|process|start)|xclick))|b(?:e(?:fore(?:(?:(?:(?:de)?activa|scriptexecu)t|toggl)e|c(?:opy|ut)|editfocus|input|p(?:aste|rint)|u(?:nload|pdate))|gin(?:Event)?)|l(?:ocked|ur)|oun(?:ce|dary)|roadcast|usy)|c(?:a(?:(?:ch|llschang)ed|nplay(?:through)?|rdstatechange)|(?:ell|fstate)change|h(?:a(?:rging(?:time)?cha)?nge|ecking)|l(?:ick|ose)|o(?:m(?:mand(?:update)?|p(?:lete|osition(?:end|start|update)))|n(?:nect(?:ed|ing)|t(?:extmenu|rolselect))|py)|u(?:echange|t))|d(?:ata(?:(?:availabl|chang)e|error|setc(?:hanged|omplete))|blclick|e(?:activate|livery(?:error|success)|vice(?:found|light|(?:mo|orienta)tion|proximity))|i(?:aling|s(?:abled|c(?:hargingtimechange|onnect(?:ed|ing))))|o(?:m(?:a(?:ctivate|ttrmodified)|(?:characterdata|subtree)modified|focus(?:in|out)|mousescroll|node(?:inserted(?:intodocument)?|removed(?:fromdocument)?))|wnloading)|r(?:ag(?:drop|e(?:n(?:d|ter)|xit)|(?:gestur|leav)e|over|start)|op)|urationchange)|e(?:mptied|n(?:abled|d(?:ed|Event)?|ter)|rror(?:update)?|xit)|f(?:ailed|i(?:lterchange|nish)|o(?:cus(?:in|out)?|rm(?:change|input))|ullscreenchange)|g(?:amepad(?:axismove|button(?:down|up)|(?:dis)?connected)|et)|h(?:ashchange|e(?:adphoneschange|l[dp])|olding)|i(?:cc(?:cardlockerror|infochange)|n(?:coming|put|valid))|key(?:down|press|up)|l(?:evelchange|o(?:ad(?:e(?:d(?:meta)?data|nd)|start)?|secapture)|y)|m(?:ark|essage|o(?:use(?:down|enter|(?:lea|mo)ve|o(?:ut|ver)|up|wheel)|ve(?:end|start)?|z(?:a(?:fterpaint|udioavailable)|(?:beforeresiz|orientationchang|t(?:apgestur|imechang))e|(?:edgeui(?:c(?:ancel|omplet)|start)e|network(?:down|up)loa)d|fullscreen(?:change|error)|m(?:agnifygesture(?:start|update)?|ouse(?:hittest|pixelscroll))|p(?:ointerlock(?:change|error)|resstapgesture)|rotategesture(?:start|update)?|s(?:crolledareachanged|wipegesture(?:end|start|update)?))))|no(?:match|update)|o(?:(?:bsolet|(?:ff|n)lin)e|pen|verflow(?:changed)?)|p(?:a(?:ge(?:hide|show)|int|(?:st|us)e)|lay(?:ing)?|o(?:inter(?:down|enter|(?:(?:lea|mo)v|rawupdat)e|o(?:ut|ver)|up)|p(?:state|up(?:hid(?:den|ing)|show(?:ing|n))))|ro(?:gress|pertychange))|r(?:atechange|e(?:adystatechange|ceived|movetrack|peat(?:Event)?|quest|s(?:et|ize|u(?:lt|m(?:e|ing)))|trieving)|ow(?:e(?:nter|xit)|s(?:delete|inserted)))|s(?:croll(?:end)?|e(?:arch|ek(?:complete|ed|ing)|lect(?:ionchange|start)?|n(?:ding|t)|t)|how|(?:ound|peech)(?:end|start)|t(?:a(?:lled|rt|t(?:echange|uschanged))|k(?:comma|sessione)nd|op)|u(?:bmit|ccess|spend)|vg(?:abort|error|(?:un)?load|resize|scroll|zoom))|t(?:ext|ime(?:out|update)|o(?:ggle|uch(?:cancel|en(?:d|ter)|(?:lea|mo)ve|start))|ransition(?:cancel|end|run|start))|u(?:n(?:derflow|handledrejection|load)|p(?:dateready|gradeneeded)|s(?:erproximity|sdreceived))|v(?:ersion|o(?:ic|lum)e)change|w(?:a(?:it|rn)ing|ebkit(?:animation(?:end|iteration|start)|(?:playbacktargetavailabilitychange|transitionen)d)|heel)|zoom)|ping|s(?:rc|tyle))[\\x08-\\n\\f\\r ]*?=",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941170,
    "msg": "NoScript XSS InjectionChecker: Attribute Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "(?:[^0-9A-Z_a-z]|^)(?:javascript:(?:.+[\\(\\.<=\\[\\x5c]|.*?(?:\\bname\\b|\\x5c[ux][0-9]))|data:(?:(?:[a-z][0-9A-Z_a-z]+/[0-9A-Z_a-z][\\+\\-0-9A-Z_a-z]+[0-9A-Z_a-z])?[,;]|.*?(?:;.*?\\b(?:base64|charset=)|,.*?<.*?[0-9A-Z_a-z].*?>)))|@[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?p[^0-9A-Z_a-z]*?o[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?t[^0-9A-Z_a-z]*?(?:/\\*.*?)?(?:[\"']|[^0-9A-Z_a-z]*?u[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?l.*?\\()|-[^0-9A-Z_a-z]*?m[^0-9A-Z_a-z]*?o[^0-9A-Z_a-z]*?z[^0-9A-Z_a-z]*?-[^0-9A-Z_a-z]*?b[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?n[^0-9A-Z_a-z]*?d[^0-9A-Z_a-z]*?i[^0-9A-Z_a-z]*?n[^0-9A-Z_a-z]*?g[^:]*?:[^0-9A-Z_a-z]*?u[^0-9A-Z_a-z]*?r[^0-9A-Z_a-z]*?l.*?\\(",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941180,
    "msg": "Node-Validator Deny List Keywords",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "pm",
      "phrases": [
        "document.cookie",
        "document.domain",
        "document.querySelector",
        "document.body.appendChild",
        "document.write",
        ".parentnode",
        ".innerhtml",
        "window.location",
        "-moz-binding",
        "<!--",
        "<![cdata["
      ],
      "negated": false
    }
  },
  {
    "id": 941190,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<style.*?>.*?(?:@[\\x5ci]|(?:[:=]|&#x?0*(?:58|3[AD]|61);?).*?(?:[\\(\\x5c]|&#x?0*(?:40|28|92|5C);?))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941200,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "(?:<.*[:]?vmlframe.*?[\\t-\\r /+]*?src[\\t-\\r /+]*=)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941210,
    "msg": "Javascript Word Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "(?:j|&#(?:0*(?:74|106)|x0*[46]A);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:a|&#(?:0*(?:65|97)|x0*[46]1);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:v|&#(?:0*(?:86|118)|x0*[57]6);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:a|&#(?:0*(?:65|97)|x0*[46]1);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:s|&#(?:0*(?:115|83)|x0*[57]3);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:c|&#(?:x0*[46]3|0*(?:99|67));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:r|&#(?:x0*[57]2|0*(?:114|82));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:i|&#(?:x0*[46]9|0*(?:105|73));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:p|&#(?:x0*[57]0|0*(?:112|80));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:t|&#(?:x0*[57]4|0*(?:116|84));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?::|&(?:#(?:0*58|x0*3A);?|colon;)).",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941220,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "(?:v|&#(?:0*(?:118|86)|x0*[57]6);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:b|&#(?:0*(?:98|66)|x0*[46]2);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:s|&#(?:0*(?:115|83)|x0*[57]3);)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:c|&#(?:x0*[46]3|0*(?:99|67));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:r|&#(?:x0*[57]2|0*(?:114|82));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:i|&#(?:x0*[46]9|0*(?:105|73));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:p|&#(?:x0*[57]0|0*(?:112|80));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?:t|&#(?:x0*[57]4|0*(?:116|84));)(?:[\\t\\n\\r]|&(?:#(?:0*(?:9|1[03])|x0*[AD]);?|(?:tab|newline);))*(?::|&(?:#(?:0*58|x0*3A);?|colon;)).",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941230,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<EMBED[\\t-\\r /+].*?(?:src|type).*?=",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941240,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "lowercase",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<[?]?import(?:[\\t-\\r /+]|[^\\t-\\r ])*?implementation[\\t-\\r /+]*?=",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 941250,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<META[\\t-\\r \\x0b\\+/].*?http-equiv[\\t-\\r \\x0b\\+/]*=[\\t-\\r \\x0b\\+/]*[\"'`]?(?:[crs]|&#x?0*(?:6[37]|43|99|[578][23]|11[45]);?)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941260,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "(?:<META[\\t-\\r /+].*?charset[\\t-\\r /+]*=)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941270,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<LINK[\\t-\\r /+].*?href[\\t-\\r /+]*=",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941280,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<BASE[\\t-\\r /+].*?href[\\t-\\r /+]*=",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941290,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<APPLET[\\t-\\r /+>]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941300,
    "msg": "IE XSS Filters - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode",
      "cssDecode",
      "removeNulls"
    ],
    "op": {
      "type": "rx",
      "source": "<OBJECT[\\t-\\r \\x0b\\+/].*?(?:type|c(?:ode(?:type)?|lassid)|data)[\\t-\\r \\x0b\\+/]*=",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941310,
    "msg": "US-ASCII Malformed Encoding XSS Filter - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "lowercase",
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode"
    ],
    "op": {
      "type": "rx",
      "source": "\\xbc[^>\\xbe]*[>\\xbe]|<[^\\xbe]*\\xbe",
      "flags": "s",
      "negated": false
    },
    "chain": [
      {
        "target": "MATCHED_VARS",
        "transforms": [],
        "op": {
          "type": "rx",
          "source": "\\xbc[\\t-\\r \\x0b]*/[\\t-\\r \\x0b]*[^>\\xbe]*[>\\xbe]|<[\\t-\\r \\x0b]*/[\\t-\\r \\x0b]*[^\\xbe]*\\xbe",
          "flags": "s",
          "negated": false
        }
      }
    ]
  },
  {
    "id": 941350,
    "msg": "UTF-7 Encoding IE XSS - Attack Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "urlDecodeUni",
      "htmlEntityDecode",
      "jsDecode"
    ],
    "op": {
      "type": "rx",
      "source": "\\+ADw-.*(?:\\+AD4-|>)|<.*\\+AD4-",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 941360,
    "msg": "JSFuck / Hieroglyphy obfuscation detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [],
    "op": {
      "type": "rx",
      "source": "![!+ ]\\[\\]",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 941370,
    "msg": "JavaScript global variable found",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "urlDecodeUni",
      "compressWhitespace"
    ],
    "op": {
      "type": "rx",
      "source": "(?:self|document|t(?:his|op)|window)[\\t-\\r \\x0b]*(?:/\\*|[\\)\\[]).+?(?:\\]|\\*/)",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 941390,
    "msg": "Javascript method detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "htmlEntityDecode",
      "jsDecode"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:eval|set(?:timeout|interval)|new[\\t-\\r \\x0b]+Function|a(?:lert|tob)|btoa|(?:promp|impor)t|con(?:firm|sole\\.(?:log|dir))|fetch)[\\t-\\r \\x0b]*[\\(\\{]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 941400,
    "msg": "XSS JavaScript function without parentheses",
    "severity": "CRITICAL",
    "tags": [
      "attack-xss"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS",
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "urlDecodeUni",
      "compressWhitespace"
    ],
    "op": {
      "type": "rx",
      "source": "((?:\\[[^\\]]*\\]|Reflect)[^\\.]*\\.).*(?:map|sort|apply)[^\\.]*\\..*call[^`]*`.*`",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 942100,
    "msg": "SQL Injection Attack Detected via libinjection",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "removeNulls"
    ],
    "multiMatch": true,
    "op": {
      "type": "detectSQLi",
      "negated": false
    }
  },
  {
    "id": 942140,
    "msg": "SQL Injection Attack: Common DB Names Detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:d(?:atabas|b_nam)e[^0-9A-Z_a-z]*\\(|(?:information_schema|m(?:aster\\.\\.sysdatabases|s(?:db|ys(?:ac(?:cess(?:objects|storage|xml)|es)|modules2?|(?:object|querie|relationship)s))|ysql\\.db)|northwind|pg_(?:catalog|toast)|tempdb)\\b|s(?:chema(?:_name\\b|[^0-9A-Z_a-z]*\\()|(?:qlite_(?:temp_)?master|ys(?:aux|\\.database_name))\\b))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942151,
    "msg": "SQL Injection Attack: SQL function name detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:a(?:dd(?:dat|tim)e|es_(?:de|en)crypt|s(?:cii(?:str)?|in)|tan2?)|b(?:enchmark|i(?:n_to_num|t_(?:and|count|length|x?or)))|c(?:har(?:acter)?_length|eil(?:ing)?|o(?:alesce|ercibility|llation|(?:mpres)?s|n(?:cat(?:_ws)?|nection_id|v(?:ert_tz)?)|t)|rc32|ur(?:(?:dat|tim)e|rent_(?:date|setting|time(?:stamp)?|user)))|d(?:a(?:t(?:abase(?:_to_xml)?|e(?:_(?:add|format|sub)|diff))|y(?:name|of(?:month|week|year)))|count|e(?:code|s_(?:de|en)crypt)|ump)|e(?:n(?:c(?:ode|rypt)|ds_?with)|x(?:p(?:ort_set)?|tract(?:value)?))|f(?:i(?:el|n)d_in_set|ound_rows|rom_(?:base64|days|unixtime))|g(?:e(?:ometrycollection|t(?:_(?:format|lock)|pgusername))|(?:r(?:eates|oup_conca)|tid_subse)t)|hex(?:toraw)?|i(?:fnull|n(?:et6?_(?:aton|ntoa)|s(?:ert|tr)|terval)|s(?:_(?:(?:free|used)_lock|ipv(?:4(?:_(?:compat|mapped))?|6)|n(?:ot(?:_null)?|ull)|superuser)|null))|json(?:_(?:a(?:gg|rray(?:_(?:elements(?:_text)?|length))?)|build_(?:array|object)|e(?:ac|xtract_pat)h(?:_text)?|object(?:_(?:agg|keys))?|populate_record(?:set)?|strip_nulls|t(?:o_record(?:set)?|ypeof))|b(?:_(?:array(?:_(?:elements(?:_text)?|length))?|build_(?:array|object)|e(?:ac|xtract_pat)h(?:_text)?|insert|object(?:_(?:agg|keys))?|p(?:ath_(?:(?:exists|match)(?:_tz)?|query(?:_(?:(?:array|first)(?:_tz)?|tz))?)|opulate_record(?:set)?|retty)|s(?:et(?:_lax)?|trip_nulls)|t(?:o_record(?:set)?|ypeof)))?|path)?|l(?:ast_(?:day|insert_id)|case|east|i(?:kely|nestring)|o(?:_(?:from_bytea|put)|ad_file|ca(?:ltimestamp|te)|g(?:10|2))|pad|trim)|m(?:a(?:ke(?:_set|date)|ster_pos_wait)|d5|i(?:crosecon)?d|onthname|ulti(?:linestring|po(?:int|lygon)))|n(?:ame_const|ot_in|ullif)|o(?:ct(?:et_length)?|(?:ld_passwo)?rd)|p(?:eriod_(?:add|diff)|g_(?:client_encoding|(?:databas|read_fil)e|l(?:argeobject|s_dir)|sleep|user)|o(?:lygon|w)|rocedure_analyse)|qu(?:ery_to_xml|ote)|r(?:a(?:dians|nd|wtohex)|elease_lock|ow_(?:count|to_json)|pad|trim)|s(?:chema|e(?:c_to_time|ssion_user)|ha[12]?|in|oundex|q(?:lite_(?:compileoption_(?:get|used)|source_id)|rt)|t(?:arts_?with|d(?:dev_(?:po|sam)p)?|r(?:_to_date|cmp))|ub(?:(?:dat|tim)e|str(?:ing(?:_index)?)?)|ys(?:date|tem_user))|t(?:ime(?:_(?:format|to_sec)|diff|stamp(?:add|diff)?)|o(?:_(?:base64|jsonb?)|n?char|(?:day|second)s)|r(?:im|uncate))|u(?:case|n(?:compress(?:ed_length)?|hex|i(?:str|x_timestamp))|(?:pdatexm|se_json_nul)l|tc_(?:date|time(?:stamp)?)|uid(?:_short)?)|var(?:_(?:po|sam)p|iance)|we(?:ek(?:day|ofyear)|ight_string)|xmltype|yearweek)[^0-9A-Z_a-z]*\\(",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942160,
    "msg": "Detects blind sqli tests using sleep() or benchmark()",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "replaceComments"
    ],
    "op": {
      "type": "rx",
      "source": "(?:sleep[\\t-\\r ]*?\\(.*?\\)|benchmark[\\t-\\r ]*?\\(.*?\\,.*?\\))",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942170,
    "msg": "Detects SQL benchmark and sleep injection attempts including conditional queries",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "(?:select|;)[\\t-\\r \\x0b]+(?:benchmark|if|sleep)[\\t-\\r \\x0b]*?\\([\\t-\\r \\x0b]*?\\(?[\\t-\\r \\x0b]*?[0-9A-Z_a-z]+",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942190,
    "msg": "Detects SQL code execution and information gathering attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "removeCommentsChar"
    ],
    "op": {
      "type": "rx",
      "source": "[\"'`](?:[\\t-\\r \\x0b]*![\\t-\\r \\x0b]*[\"'<->`]|;?[\\t-\\r \\x0b]*(?:having|select|union\\b[\\t-\\r \\x0b]*(?:all|(?:distin|sele)ct))\\b[\\t-\\r \\x0b]*[^\\t-\\r \\x0b])|\\b(?:(?:(?:c(?:onnection_id|urrent_user)|database|schema|user)[\\t-\\r \\x0b]*?|select.*?[0-9A-Z_a-z]?user)\\(|exec(?:ute)?[\\t-\\r \\x0b]+master\\.|from[^0-9A-Z_a-z]+information_schema[^0-9A-Z_a-z]|into[\\t-\\r \\x0b\\+]+(?:dump|out)file[\\t-\\r \\x0b]*?[\"'`]|union(?:[\\t-\\r \\x0b]select[\\t-\\r \\x0b]@|[\\t-\\r \\x0b\\(0-9A-Z_a-z]*?select))|[\\t-\\r \\x0b]*?exec(?:ute)?.*?[^0-9A-Z_a-z]xp_cmdshell|[^0-9A-Z_a-z]iif[\\t-\\r \\x0b]*?\\(",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942220,
    "msg": "Looking for integer overflow attacks, these are taken from skipfish, except 2.2.2250738585072011e-308 is the \"magic number\" crash",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "^(?:json\\.)?(?:429496729[56]|2(?:14748364[78]|.22507385850720(?:07|11)e-308)|-(?:214748364[89]|0000023456)|00000(?:12345|23456)|1e309)$",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942230,
    "msg": "Detects conditional SQL injection attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "[\\t-\\r \\x0b\\(\\)]case[\\t-\\r \\x0b]+when.*?then|\\)[\\t-\\r \\x0b]*?like[\\t-\\r \\x0b]*?\\(|select.*?having[\\t-\\r \\x0b]*?[^\\t-\\r \\x0b]+[\\t-\\r \\x0b]*?[^\\t-\\r \\x0b0-9A-Z_a-z]|if[\\t-\\r \\x0b]?\\([0-9A-Z_a-z]+[\\t-\\r \\x0b]*?[<->~]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942240,
    "msg": "Detects MySQL charset switch and MSSQL DoS attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "alter[\\t-\\r \\x0b]*?[0-9A-Z_a-z]+.*?char(?:acter)?[\\t-\\r \\x0b]+set[\\t-\\r \\x0b]+[0-9A-Z_a-z]+|[\"'`](?:;*?[\\t-\\r \\x0b]*?waitfor[\\t-\\r \\x0b]+(?:time|delay)[\\t-\\r \\x0b]+[\"'`]|;.*?:[\\t-\\r \\x0b]*?goto)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942250,
    "msg": "Detects MATCH AGAINST, MERGE and EXECUTE IMMEDIATE injections",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "m(?:erge.*?using|atch[\\t-\\r \\x0b]*?[\\(\\)\\+-\\-0-9A-Z_a-z]+[\\t-\\r \\x0b]*?against)[\\t-\\r \\x0b]*?\\(|execute[\\t-\\r \\x0b]*?immediate[\\t-\\r \\x0b]*?[\"'`]",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942270,
    "msg": "Looking for basic sql injection. Common attack string for mysql, oracle and others",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "union.*?select.*?from",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942280,
    "msg": "Detects Postgres pg_sleep injection, waitfor delay attacks and database shutdown attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "select[\\t-\\r \\x0b]*?pg_sleep|waitfor[\\t-\\r \\x0b]*?delay[\\t-\\r \\x0b]?[\"'`]+[\\t-\\r \\x0b]?[0-9]|;[\\t-\\r \\x0b]*?shutdown[\\t-\\r \\x0b]*?(?:[#;\\{]|/\\*|--)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942290,
    "msg": "Finds basic MongoDB SQL injection attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "\\[?\\$(?:a(?:bs|c(?:cumulator|osh?)|dd(?:ToSet)?|ll(?:ElementsTrue)?|n(?:d|yElementTrue)|rray(?:ElemA|ToObjec)t|sinh?|tan[2h]?|vg)|b(?:etween|i(?:narySize|t(?:And|Not|(?:O|Xo)r)?)|ottomN?|sonSize|ucket(?:Auto)?)|c(?:eil|mp|o(?:n(?:cat(?:Arrays)?|d|vert)|sh?|unt|variance(?:Po|Sam)p)|urrentDate)|d(?:a(?:te(?:Add|Diff|From(?:Parts|String)|Subtract|T(?:o(?:Parts|String)|runc))|yOf(?:Month|Week|Year))|e(?:greesToRadians|nseRank|rivative)|iv(?:ide)?|ocumentNumber)|e(?:(?:a|lemMat)ch|q|x(?:ists|p(?:MovingAvg|r)?))|f(?:i(?:lter|rstN?)|loor|unction)|g(?:etField|roup|te?)|(?:hou|xo|yea)r|i(?:fNull|n(?:c|dexOf(?:Array|Bytes|CP)|tegral)?|s(?:Array|Number|o(?:DayOfWeek|Week(?:Year)?)))|jsonSchema|l(?:astN?|et|i(?:ke|(?:nearFil|tera)l)|n|o(?:cf|g(?:10)?)|t(?:e|rim)?)|m(?:a(?:p|xN?)|e(?:dian|rgeObjects|ta)|i(?:llisecond|n(?:N|ute)?)|o(?:d|nth)|ul(?:tiply)?)|n(?:atural|e|in|o[rt])|o(?:bjectToArray|r)|p(?:ercentile|o(?:[pw]|sition)|roject|u(?:ll(?:All)?|sh))|r(?:a(?:diansToDegrees|n(?:[dk]|ge))|e(?:(?:duc|nam)e|gex(?:Find(?:All)?|Match)?|place(?:All|One)|verseArray)|ound|trim)|s(?:(?:ampleRat|lic)e|e(?:cond|t(?:Difference|(?:Equal|WindowField)s|Field|I(?:ntersection|sSubset)|OnInsert|Union)?)|(?:hif|pli|qr)t|i(?:nh?|ze)|ort(?:Array)?|t(?:dDev(?:Po|Sam)p|r(?:Len(?:Bytes|CP)|casecmp))|u(?:b(?:str(?:Bytes|CP)?|tract)|m)|witch)|t(?:anh?|ext|o(?:Bool|D(?:(?:at|oubl)e|ecimal)|HashedIndexKey|Int|Lo(?:ng|wer)|ObjectId|String|U(?:UID|pper)|pN?)|r(?:im|unc)|s(?:Increment|Second)|ype)|unset|w(?:eek|here)|zip)\\b\\]?",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942320,
    "msg": "Detects MySQL and PostgreSQL stored procedure/function injections",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "create[\\t-\\r \\x0b]+(?:function|procedure)[\\t-\\r \\x0b]*?[0-9A-Z_a-z]+[\\t-\\r \\x0b]*?\\([\\t-\\r \\x0b]*?\\)[\\t-\\r \\x0b]*?-|d(?:eclare[^0-9A-Z_a-z]+[#@][\\t-\\r \\x0b]*?[0-9A-Z_a-z]+|iv[\\t-\\r \\x0b]*?\\([\\+\\-]*[\\t-\\r \\x0b\\.0-9]+,[\\+\\-]*[\\t-\\r \\x0b\\.0-9]+\\))|exec[\\t-\\r \\x0b]*?\\([\\t-\\r \\x0b]*?@|(?:lo_(?:impor|ge)t|procedure[\\t-\\r \\x0b]+analyse)[\\t-\\r \\x0b]*?\\(|;[\\t-\\r \\x0b]*?(?:declare|open)[\\t-\\r \\x0b]+[\\-0-9A-Z_a-z]+|::(?:b(?:igint|ool)|double[\\t-\\r \\x0b]+precision|int(?:eger)?|numeric|oid|real|(?:tex|smallin)t)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942350,
    "msg": "Detects MySQL UDF injection and other data/structure manipulation attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "replaceComments"
    ],
    "op": {
      "type": "rx",
      "source": "create[\\t-\\r \\x0b]+function[\\t-\\r \\x0b].+[\\t-\\r \\x0b]returns|;[\\t-\\r \\x0b]*?(?:alter|(?:(?:cre|trunc|upd)at|re(?:nam|plac))e|d(?:e(?:lete|sc)|rop)|(?:inser|selec)t|load)\\b[\\t-\\r \\x0b]*?[\\(\\[]?[0-9A-Z_a-z]{2,}",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942360,
    "msg": "Detects concatenated basic SQL injection and SQLLFI attempts",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "op": {
      "type": "rx",
      "source": "\\b(?:(?:alter|(?:(?:cre|trunc|upd)at|renam)e|de(?:lete|sc)|(?:inser|selec)t|load)[\\t-\\r \\x0b]+(?:char|group_concat|load_file)\\b[\\t-\\r \\x0b]*\\(?|end[\\t-\\r \\x0b]*?\\);)|[\\t-\\r \\x0b\\(]load_file[\\t-\\r \\x0b]*?\\(|[\"'`][\\t-\\r \\x0b]+regexp[^0-9A-Z_a-z]|[\"'0-9A-Z_-z][\\t-\\r \\x0b]+as\\b[\\t-\\r \\x0b]*[\"'0-9A-Z_-z]+[\\t-\\r \\x0b]*\\bfrom|^(?:json\\.)?[^A-Z_a-z]+[\\t-\\r \\x0b]*?(?:(?:(?:(?:cre|trunc)at|renam)e|d(?:e(?:lete|sc)|rop)|(?:inser|selec)t|load)[\\t-\\r \\x0b]+[0-9A-Z_a-z]+|u(?:pdate[\\t-\\r \\x0b]+[0-9A-Z_a-z]+|nion[\\t-\\r \\x0b]*(?:all|(?:sele|distin)ct)\\b)|alter[\\t-\\r \\x0b]*(?:a(?:(?:ggregat|pplication[\\t-\\r \\x0b]*rol)e|s(?:sembl|ymmetric[\\t-\\r \\x0b]*ke)y|u(?:dit|thorization)|vailability[\\t-\\r \\x0b]*group)|b(?:roker[\\t-\\r \\x0b]*priority|ufferpool)|c(?:ertificate|luster|o(?:l(?:latio|um)|nversio)n|r(?:edential|yptographic[\\t-\\r \\x0b]*provider))|d(?:atabase|efault|i(?:mension|skgroup)|omain)|e(?:(?:ndpoi|ve)nt|xte(?:nsion|rnal))|f(?:lashback|oreign|u(?:lltext|nction))|hi(?:erarchy|stogram)|group|in(?:dex(?:type)?|memory|stance)|java|l(?:a(?:ngua|r)ge|ibrary|o(?:ckdown|g(?:file[\\t-\\r \\x0b]*group|in)))|m(?:a(?:s(?:k|ter[\\t-\\r \\x0b]*key)|terialized)|e(?:ssage[\\t-\\r \\x0b]*type|thod)|odule)|(?:nicknam|queu)e|o(?:perator|utline)|p(?:a(?:ckage|rtition)|ermission|ro(?:cedur|fil)e)|r(?:e(?:mot|sourc)e|o(?:l(?:e|lback)|ute))|s(?:chema|e(?:arch|curity|rv(?:er|ice)|quence|ssion)|y(?:mmetric[\\t-\\r \\x0b]*key|nonym)|togroup)|t(?:able(?:space)?|ext|hreshold|r(?:igger|usted)|ype)|us(?:age|er)|view|w(?:ork(?:load)?|rapper)|x(?:ml[\\t-\\r \\x0b]*schema|srobject))\\b)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942500,
    "msg": "MySQL in-line comment detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni"
    ],
    "multiMatch": true,
    "op": {
      "type": "rx",
      "source": "/\\*[\\t-\\r \\x0b]*?[!\\+](?:[\\t-\\r \\x0b\\(\\)\\-0-9=A-Z_a-z]+)?\\*/",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942540,
    "msg": "SQL Authentication bypass (split query)",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "replaceComments"
    ],
    "op": {
      "type": "rx",
      "source": "^(?:[^']*'|[^\"]*\"|[^`]*`)[\\t-\\r \\x0b]*;",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 942560,
    "msg": "MySQL Scientific Notation payload detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "replaceComments"
    ],
    "op": {
      "type": "rx",
      "source": "1\\.e(?:[\\(\\),]|\\.[\\$0-9A-Z_a-z])",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 942550,
    "msg": "JSON-Based SQL Injection",
    "severity": "CRITICAL",
    "tags": [
      "attack-sqli"
    ],
    "targets": [
      "REQUEST_FILENAME",
      "ARGS_NAMES",
      "ARGS"
    ],
    "transforms": [
      "urlDecodeUni",
      "removeWhitespace"
    ],
    "op": {
      "type": "rx",
      "source": "[\"'`][\\[\\{][^#\\]\\}]*[\\]\\}]+[\"'`]|(?:[\\-@]>?|<@|@[\\?@]|\\?(?:(?:)|&|\\|#>)|#(?:>>|-)|->>|[<>])[\"'`](?:[\\[\\{][^#\\]\\}]*[\\]\\}]+[\"'`]|\\$[\\.\\[])|\\bjson_extract\\b[^\\(]*\\([^\\)]*\\)",
      "flags": "is",
      "negated": false
    }
  },
  {
    "id": 944100,
    "msg": "Remote Command Execution: Suspicious Java class detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS",
      "ARGS_NAMES",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer"
    ],
    "transforms": [
      "lowercase"
    ],
    "op": {
      "type": "rx",
      "source": "java\\.lang\\.(?:runtime|processbuilder)",
      "flags": "s",
      "negated": false
    }
  },
  {
    "id": 944110,
    "msg": "Remote Command Execution: Java process spawn (CVE-2017-9805)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS",
      "ARGS_NAMES",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer"
    ],
    "transforms": [
      "lowercase"
    ],
    "op": {
      "type": "rx",
      "source": "(?:runtime|processbuilder)",
      "flags": "s",
      "negated": false
    },
    "chain": [
      {
        "target": "MATCHED_VARS",
        "transforms": [],
        "op": {
          "type": "rx",
          "source": "(?:unmarshaller|base64data|java\\.)",
          "flags": "is",
          "negated": false
        }
      }
    ]
  },
  {
    "id": 944120,
    "msg": "Remote Command Execution: Java serialization (CVE-2015-4852)",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS",
      "ARGS_NAMES",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer"
    ],
    "transforms": [
      "lowercase"
    ],
    "op": {
      "type": "rx",
      "source": "(?:clonetransform|xmldecod)er|f(?:orclosure|ilewriter)|in(?:stantiate(?:factory|transformer)|vokertransformer)|(?:prototype(?:clone|serialization)factor|getpropert)y|whileclosure",
      "flags": "s",
      "negated": false
    },
    "chain": [
      {
        "target": "MATCHED_VARS",
        "transforms": [],
        "op": {
          "type": "rx",
          "source": "(?:runtime|processbuilder)",
          "flags": "s",
          "negated": false
        }
      }
    ]
  },
  {
    "id": 944130,
    "msg": "Suspicious Java class detected",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "ARGS",
      "ARGS_NAMES",
      "REQUEST_FILENAME",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer"
    ],
    "transforms": [],
    "op": {
      "type": "pm",
      "phrases": [
        "com.opensymphony.xwork2",
        "com.sun.org.apache",
        "classLoader",
        "declaredClass",
        "freemarker.core",
        "freemarker.template",
        "freemarker.ext.rhino",
        "java.io.BufferedInputStream",
        "java.io.BufferedReader",
        "java.io.ByteArrayInputStream",
        "java.io.ByteArrayOutputStream",
        "java.io.CharArrayReader",
        "java.io.DataInputStream",
        "java.io.File",
        "java.io.FileOutputStream",
        "java.io.FilePermission",
        "java.io.FileWriter",
        "java.io.FilterInputStream",
        "java.io.FilterOutputStream",
        "java.io.FilterReader",
        "java.io.InputStream",
        "java.io.IOException",
        "java.io.LineNumberReader",
        "java.io.ObjectInputStream",
        "java.io.ObjectOutputStream",
        "java.io.OutputStream",
        "java.io.PipedOutputStream",
        "java.io.PipedReader",
        "java.io.PrintStream",
        "java.io.PushbackInputStream",
        "java.io.Reader",
        "java.io.StringReader",
        "java.lang.Class",
        "java.lang.Enum",
        "java.lang.Integer",
        "java.lang.Number",
        "java.lang.Object",
        "java.lang.Process",
        "java.lang.ProcessBuilder",
        "java.lang.reflect",
        "java.lang.Runtime",
        "java.lang.String",
        "java.lang.System",
        "java.net.HttpURLConnection",
        "java.net.JarURLConnection",
        "java.net.DatagramSocket",
        "java.net.MulticastSocket",
        "java.net.ServerSocket",
        "java.net.Socket",
        "java.net.URL",
        "javassist",
        "javax.naming.InitialContext",
        "javax.script.ScriptEngineManager",
        "javax.xml.parsers",
        "javax.xml.stream",
        "OgnlContext",
        "OgnlUtil",
        "org.apache.commons",
        "org.apache.struts",
        "org.apache.struts2",
        "org.dom4j.io.SAXReader",
        "org.jdom2.input.SAXBuilder",
        "org.omg.CORBA",
        "org.xml.sax",
        "PropertyUtilsBean",
        "java.beans.XMLDecode",
        "java.nio.file",
        "sun.reflect"
      ],
      "negated": false
    }
  },
  {
    "id": 944150,
    "msg": "Potential Remote Command Execution: Log4j / Log4shell",
    "severity": "CRITICAL",
    "tags": [
      "attack-rce"
    ],
    "targets": [
      "REQUEST_LINE",
      "ARGS",
      "ARGS_NAMES",
      "REQUEST_HEADERS:User-Agent",
      "REQUEST_HEADERS:Referer"
    ],
    "transforms": [
      "urlDecodeUni",
      "jsDecode",
      "htmlEntityDecode"
    ],
    "op": {
      "type": "rx",
      "source": "(?:\\$|&dollar;?)(?:\\{|&l(?:brace|cub);?)(?:[^\\}]{0,15}(?:\\$|&dollar;?)(?:\\{|&l(?:brace|cub);?)|jndi|ctx)",
      "flags": "is",
      "negated": false
    }
  }
];

/** ThreatCrush's own rules (ids 10000-10999, tag `threatcrush`): not CRS, never counted as CRS. */
export const THREATCRUSH_RULES: readonly CrsRule[] = [
  {
    "id": 10001,
    "msg": "OS File Access Attempt in the request path",
    "severity": "CRITICAL",
    "tags": [
      "attack-lfi",
      "threatcrush"
    ],
    "targets": [
      "REQUEST_FILENAME"
    ],
    "transforms": [
      "utf8toUnicode",
      "urlDecodeUni",
      "normalizePathWin"
    ],
    "op": {
      "type": "rx",
      "source": "^/?(?:[a-z]:/)?(?:\\.history(?![0-9a-z])|apache/access\\.conf(?![0-9a-z])|apache/apache\\.conf(?![0-9a-z])|apache/apache2\\.conf(?![0-9a-z])|apache/audit_log(?![0-9a-z])|apache/conf(?![0-9a-z])|apache/default-server\\.conf(?![0-9a-z])|apache/error_log(?![0-9a-z])|apache/httpd\\.conf(?![0-9a-z])|apache/log(?![0-9a-z])|apache2/apache\\.conf(?![0-9a-z])|apache2/apache2\\.conf(?![0-9a-z])|apache2/conf(?![0-9a-z])|apache2/default-server\\.conf(?![0-9a-z])|apache2/envvars(?![0-9a-z])|apache2/httpd\\.conf(?![0-9a-z])|apache2/httpd2\\.conf(?![0-9a-z])|apache2/logs(?![0-9a-z])|apache2/mods(?![0-9a-z])|apache2/ports\\.conf(?![0-9a-z])|apache2/sites(?![0-9a-z])|apache2/ssl-global\\.conf(?![0-9a-z])|apache2/vhosts\\.d(?![0-9a-z])|apache22/conf(?![0-9a-z])|apache22/httpd\\.conf(?![0-9a-z])|apache22/logs(?![0-9a-z])|apache24/conf(?![0-9a-z])|apache24/httpd\\.conf(?![0-9a-z])|apache24/logs(?![0-9a-z])|boot/grub/grub\\.cfg(?![0-9a-z])|boot/grub/menu\\.lst(?![0-9a-z])|config/app\\.php(?![0-9a-z])|config/custom\\.php(?![0-9a-z])|config/database\\.php(?![0-9a-z])|configuration\\.php(?![0-9a-z])|cpanel/logs(?![0-9a-z])|data/elasticsearch(?![0-9a-z])|data/kafka(?![0-9a-z])|etc/\\.java(?![0-9a-z])|etc/acpi(?![0-9a-z])|etc/adduser\\.conf(?![0-9a-z])|etc/alias(?![0-9a-z])|etc/alsa(?![0-9a-z])|etc/alternatives(?![0-9a-z])|etc/amavis(?![0-9a-z])|etc/anacrontab(?![0-9a-z])|etc/ansible(?![0-9a-z])|etc/apache/access\\.conf(?![0-9a-z])|etc/apache/apache\\.conf(?![0-9a-z])|etc/apache/default-server\\.conf(?![0-9a-z])|etc/apache/httpd\\.conf(?![0-9a-z])|etc/apache/vhosts\\.conf(?![0-9a-z])|etc/apache2(?![0-9a-z])|etc/apm(?![0-9a-z])|etc/apparmor(?![0-9a-z])|etc/apport(?![0-9a-z])|etc/apt(?![0-9a-z])|etc/asciidoc(?![0-9a-z])|etc/at\\.allow(?![0-9a-z])|etc/at\\.deny(?![0-9a-z])|etc/audit(?![0-9a-z])|etc/avahi(?![0-9a-z])|etc/bash_completion\\.d(?![0-9a-z])|etc/bashrc(?![0-9a-z])|etc/bind(?![0-9a-z])|etc/binfmt\\.d(?![0-9a-z])|etc/bluetooth(?![0-9a-z])|etc/bonobo-activation(?![0-9a-z])|etc/bootptab(?![0-9a-z])|etc/brltty(?![0-9a-z])|etc/byobu(?![0-9a-z])|etc/ca-certificates(?![0-9a-z])|etc/calendar(?![0-9a-z])|etc/casper\\.conf(?![0-9a-z])|etc/centos-release(?![0-9a-z])|etc/chatscripts(?![0-9a-z])|etc/chkrootkit\\.conf(?![0-9a-z])|etc/chromium-browser(?![0-9a-z])|etc/chrootusers(?![0-9a-z])|etc/chttp\\.conf(?![0-9a-z])|etc/clam\\.d(?![0-9a-z])|etc/clamav(?![0-9a-z])|etc/cni(?![0-9a-z])|etc/console-setup(?![0-9a-z])|etc/coraza-waf(?![0-9a-z])|etc/cracklib(?![0-9a-z])|etc/cron\\.allow(?![0-9a-z])|etc/cron\\.d(?![0-9a-z])|etc/cron\\.hourly(?![0-9a-z])|etc/cron\\.monthly(?![0-9a-z])|etc/cron\\.weekly(?![0-9a-z])|etc/cron\\.yearly(?![0-9a-z])|etc/crontab(?![0-9a-z])|etc/crowdsec(?![0-9a-z])|etc/crypttab(?![0-9a-z])|etc/cups(?![0-9a-z])|etc/cvs-cron\\.conf(?![0-9a-z])|etc/cvs-pserver\\.conf(?![0-9a-z])|etc/dbus-1(?![0-9a-z])|etc/dconf(?![0-9a-z])|etc/debconf\\.conf(?![0-9a-z])|etc/debian_version(?![0-9a-z])|etc/default(?![0-9a-z])|etc/deluser\\.conf(?![0-9a-z])|etc/depmod\\.d(?![0-9a-z])|etc/dhcp(?![0-9a-z])|etc/dictionaries-common(?![0-9a-z])|etc/dkms(?![0-9a-z])|etc/dns2tcpd\\.conf(?![0-9a-z])|etc/dnsmasq\\.d(?![0-9a-z])|etc/docker(?![0-9a-z])|etc/dockeretc/dpkg(?![0-9a-z])|etc/dovecot(?![0-9a-z])|etc/e2fsck\\.conf(?![0-9a-z])|etc/elasticsearch(?![0-9a-z])|etc/emacs(?![0-9a-z])|etc/environment\\.d(?![0-9a-z])|etc/esound/esd\\.conf(?![0-9a-z])|etc/etter\\.conf(?![0-9a-z])|etc/exports(?![0-9a-z])|etc/fail2ban(?![0-9a-z])|etc/fedora-release(?![0-9a-z])|etc/firebird(?![0-9a-z])|etc/firefox(?![0-9a-z])|etc/firewall(?![0-9a-z])|etc/fonts(?![0-9a-z])|etc/foremost\\.conf(?![0-9a-z])|etc/freshclam\\.conf(?![0-9a-z])|etc/fstab(?![0-9a-z])|etc/ftpaccess(?![0-9a-z])|etc/ftpchroot(?![0-9a-z])|etc/ftphosts(?![0-9a-z])|etc/ftpusers(?![0-9a-z])|etc/fuse\\.conf(?![0-9a-z])|etc/fwupd(?![0-9a-z])|etc/gconf(?![0-9a-z])|etc/gdb(?![0-9a-z])|etc/gdm3(?![0-9a-z])|etc/geoclue(?![0-9a-z])|etc/ghostscript(?![0-9a-z])|etc/gimp(?![0-9a-z])|etc/gitlab(?![0-9a-z])|etc/glvnd(?![0-9a-z])|etc/gnome(?![0-9a-z])|etc/gnucash(?![0-9a-z])|etc/gnustep(?![0-9a-z])|etc/groff(?![0-9a-z])|etc/group(?![0-9a-z])|etc/grub\\.conf(?![0-9a-z])|etc/grub\\.d(?![0-9a-z])|etc/gshadow(?![0-9a-z])|etc/gss(?![0-9a-z])|etc/gtk-2\\.0(?![0-9a-z])|etc/gtk-3\\.0(?![0-9a-z])|etc/hdparm\\.conf(?![0-9a-z])|etc/host\\.conf(?![0-9a-z])|etc/hostname(?![0-9a-z])|etc/hosts(?![0-9a-z])|etc/hp(?![0-9a-z])|etc/http/conf(?![0-9a-z])|etc/http/httpd\\.conf(?![0-9a-z])|etc/httpd(?![0-9a-z])|etc/ifplugd(?![0-9a-z])|etc/imagemagick-6(?![0-9a-z])|etc/inetd\\.conf(?![0-9a-z])|etc/init(?![0-9a-z])|etc/insserv\\.conf\\.d(?![0-9a-z])|etc/ipfw(?![0-9a-z])|etc/iproute2(?![0-9a-z])|etc/iptables(?![0-9a-z])|etc/issue(?![0-9a-z])|etc/java(?![0-9a-z])|etc/kafka(?![0-9a-z])|etc/kbd/config(?![0-9a-z])|etc/kernel(?![0-9a-z])|etc/kibana(?![0-9a-z])|etc/ld\\.so\\.conf(?![0-9a-z])|etc/ldap(?![0-9a-z])|etc/letsencrypt(?![0-9a-z])|etc/libblockdev(?![0-9a-z])|etc/libibverbs\\.d(?![0-9a-z])|etc/libnl-3(?![0-9a-z])|etc/libpaper\\.d(?![0-9a-z])|etc/libreoffice(?![0-9a-z])|etc/lighttpd(?![0-9a-z])|etc/lilo\\.conf(?![0-9a-z])|etc/logcheck(?![0-9a-z])|etc/login\\.defs(?![0-9a-z])|etc/logrotate\\.conf(?![0-9a-z])|etc/logrotate\\.d(?![0-9a-z])|etc/logstash(?![0-9a-z])|etc/logwatch(?![0-9a-z])|etc/lsb-release(?![0-9a-z])|etc/ltrace\\.conf(?![0-9a-z])|etc/lvm(?![0-9a-z])|etc/lynx(?![0-9a-z])|etc/mail(?![0-9a-z])|etc/mandrake-release(?![0-9a-z])|etc/manpath\\.config(?![0-9a-z])|etc/mc(?![0-9a-z])|etc/menu(?![0-9a-z])|etc/miredo-server\\.conf(?![0-9a-z])|etc/miredo\\.conf(?![0-9a-z])|etc/miredo/miredo-server\\.conf(?![0-9a-z])|etc/miredo/miredo\\.conf(?![0-9a-z])|etc/modprobe\\.d(?![0-9a-z])|etc/modsecurity(?![0-9a-z])|etc/modulesf(?![0-9a-z])|etc/mongod\\.conf(?![0-9a-z])|etc/monit(?![0-9a-z])|etc/mono(?![0-9a-z])|etc/motd(?![0-9a-z])|etc/mplayer(?![0-9a-z])|etc/mpv(?![0-9a-z])|etc/mtab(?![0-9a-z])|etc/mtools\\.conf(?![0-9a-z])|etc/muddleftpd(?![0-9a-z])|etc/muddleftpd\\.com(?![0-9a-z])|etc/muttrc\\.d(?![0-9a-z])|etc/my\\.conf(?![0-9a-z])|etc/mysql(?![0-9a-z])|etc/netplan(?![0-9a-z])|etc/network(?![0-9a-z])|etc/networkmanager(?![0-9a-z])|etc/newsyslog\\.conf(?![0-9a-z])|etc/newt(?![0-9a-z])|etc/nghttpx(?![0-9a-z])|etc/nginx(?![0-9a-z])|etc/nikto(?![0-9a-z])|etc/npasswd(?![0-9a-z])|etc/nsswitch\\.conf(?![0-9a-z])|etc/nuxeo\\.conf(?![0-9a-z])|etc/odbcdatasources(?![0-9a-z])|etc/openal(?![0-9a-z])|etc/opendkim(?![0-9a-z])|etc/opendmarc(?![0-9a-z])|etc/openldap/ldap\\.conf(?![0-9a-z])|etc/openmpi(?![0-9a-z])|etc/opt(?![0-9a-z])|etc/os-release(?![0-9a-z])|etc/osxhttpd(?![0-9a-z])|etc/osync(?![0-9a-z])|etc/packagekit(?![0-9a-z])|etc/pam\\.conf(?![0-9a-z])|etc/pam\\.d(?![0-9a-z])|etc/pam\\.d/proftpd(?![0-9a-z])|etc/passwd(?![0-9a-z])|etc/password(?![0-9a-z])|etc/pcmcia(?![0-9a-z])|etc/perl(?![0-9a-z])|etc/php(?![0-9a-z])|etc/pki(?![0-9a-z])|etc/pm(?![0-9a-z])|etc/polkit-1(?![0-9a-z])|etc/postfix(?![0-9a-z])|etc/postgresql(?![0-9a-z])|etc/ppp(?![0-9a-z])|etc/printcap(?![0-9a-z])|etc/profile(?![0-9a-z])|etc/proftp\\.conf(?![0-9a-z])|etc/proftpd(?![0-9a-z])|etc/pulse(?![0-9a-z])|etc/pure-ftpd(?![0-9a-z])|etc/pureftpd(?![0-9a-z])|etc/python(?![0-9a-z])|etc/qemu(?![0-9a-z])|etc/rc\\.conf(?![0-9a-z])|etc/rc\\.d/rc\\.httpd(?![0-9a-z])|etc/rc0\\.d(?![0-9a-z])|etc/rc1\\.d(?![0-9a-z])|etc/rc2\\.d(?![0-9a-z])|etc/rc3\\.d(?![0-9a-z])|etc/rc4\\.d(?![0-9a-z])|etc/rc5\\.d(?![0-9a-z])|etc/rc6\\.d(?![0-9a-z])|etc/rcs\\.d(?![0-9a-z])|etc/redhat-release(?![0-9a-z])|etc/redis-sentinel\\.conf(?![0-9a-z])|etc/redis\\.conf(?![0-9a-z])|etc/resolv\\.conf(?![0-9a-z])|etc/resolvconf(?![0-9a-z])|etc/rsyslog\\.d(?![0-9a-z])|etc/samba(?![0-9a-z])|etc/sane\\.d(?![0-9a-z])|etc/scw-release(?![0-9a-z])|etc/security(?![0-9a-z])|etc/selinux(?![0-9a-z])|etc/sensors\\.conf(?![0-9a-z])|etc/sensors\\.d(?![0-9a-z])|etc/sensors3\\.conf(?![0-9a-z])|etc/sgml(?![0-9a-z])|etc/shadow(?![0-9a-z])|etc/signon-ui(?![0-9a-z])|etc/skel(?![0-9a-z])|etc/slackware-release(?![0-9a-z])|etc/smb\\.conf(?![0-9a-z])|etc/smbpasswd(?![0-9a-z])|etc/smi\\.conf(?![0-9a-z])|etc/snmp(?![0-9a-z])|etc/sogo(?![0-9a-z])|etc/sound(?![0-9a-z])|etc/spamassassin(?![0-9a-z])|etc/speech-dispatcher(?![0-9a-z])|etc/squid(?![0-9a-z])|etc/squirrelmail(?![0-9a-z])|etc/ssh(?![0-9a-z])|etc/ssl(?![0-9a-z])|etc/sso(?![0-9a-z])|etc/stunnel(?![0-9a-z])|etc/subgid(?![0-9a-z])|etc/subuid(?![0-9a-z])|etc/subversion(?![0-9a-z])|etc/sudoers(?![0-9a-z])|etc/suse-release(?![0-9a-z])|etc/sw-cp-server/applications\\.d(?![0-9a-z])|etc/sysconfig(?![0-9a-z])|etc/sysctl\\.conf(?![0-9a-z])|etc/sysctl\\.d(?![0-9a-z])|etc/syslog\\.conf(?![0-9a-z])|etc/sysstat(?![0-9a-z])|etc/system-release-cpe(?![0-9a-z])|etc/systemd(?![0-9a-z])|etc/termcap(?![0-9a-z])|etc/terminfo(?![0-9a-z])|etc/texmf(?![0-9a-z])|etc/thermald(?![0-9a-z])|etc/thnuclnt(?![0-9a-z])|etc/thunderbird(?![0-9a-z])|etc/timezone(?![0-9a-z])|etc/timidity(?![0-9a-z])|etc/tinyproxy(?![0-9a-z])|etc/tmpfiles\\.d(?![0-9a-z])|etc/tor/tor-tsocks\\.conf(?![0-9a-z])|etc/tsocks\\.conf(?![0-9a-z])|etc/ubuntu-advantage(?![0-9a-z])|etc/udev(?![0-9a-z])|etc/udisks2(?![0-9a-z])|etc/ufw(?![0-9a-z])|etc/unbound(?![0-9a-z])|etc/update-manager(?![0-9a-z])|etc/update-motd\\.d(?![0-9a-z])|etc/update-notifier(?![0-9a-z])|etc/updatedb\\.conf(?![0-9a-z])|etc/upower(?![0-9a-z])|etc/urlview(?![0-9a-z])|etc/usb_modeswitch\\.d(?![0-9a-z])|etc/utmp(?![0-9a-z])|etc/vhcs2/proftpd/proftpd\\.conf(?![0-9a-z])|etc/vim(?![0-9a-z])|etc/vmware(?![0-9a-z])|etc/vsftpd\\.chroot_list(?![0-9a-z])|etc/vsftpd\\.conf(?![0-9a-z])|etc/vsftpd/vsftpd\\.conf(?![0-9a-z])|etc/vulkan(?![0-9a-z])|etc/w3m(?![0-9a-z])|etc/webmin(?![0-9a-z])|etc/wicd(?![0-9a-z])|etc/wireshark(?![0-9a-z])|etc/wpa_supplicant(?![0-9a-z])|etc/wu-ftpd(?![0-9a-z])|etc/x11(?![0-9a-z])|etc/xdg(?![0-9a-z])|etc/xml(?![0-9a-z])|home/postgres(?![0-9a-z])|http/httpd\\.conf(?![0-9a-z])|httpd/conf/httpd\\.conf(?![0-9a-z])|includes/configure\\.php(?![0-9a-z])|inetpub/wwwroot/global\\.asa(?![0-9a-z])|jakarta/dist/tomcat(?![0-9a-z])|jakarta/tomcat/conf(?![0-9a-z])|jakarta/tomcat/logs(?![0-9a-z])|library/webserver/documents(?![0-9a-z])|lighttpd/conf(?![0-9a-z])|lighttpd/lighttpd\\.conf(?![0-9a-z])|lighttpd/log(?![0-9a-z])|localsettings\\.php(?![0-9a-z])|logs/access\\.log(?![0-9a-z])|logs/access_log(?![0-9a-z])|logs/error_log(?![0-9a-z])|logs/pure-ftpd\\.log(?![0-9a-z])|logs/samba\\.log(?![0-9a-z])|logs/security_debug_log(?![0-9a-z])|logs/security_log(?![0-9a-z])|lsws/conf(?![0-9a-z])|lsws/logs(?![0-9a-z])|mysql/bin/my\\.ini(?![0-9a-z])|mysql/data(?![0-9a-z])|mysql/my\\.ini(?![0-9a-z])|nginx/conf/nginx\\.conf(?![0-9a-z])|opt/apache(?![0-9a-z])|opt/apache2(?![0-9a-z])|opt/httpd/apache\\.conf(?![0-9a-z])|opt/httpd/apache2\\.conf(?![0-9a-z])|opt/httpd/conf/|opt/jboss(?![0-9a-z])|opt/lampp(?![0-9a-z])|opt/nuxeo(?![0-9a-z])|opt/tomcat(?![0-9a-z])|opt/xampp(?![0-9a-z])|pgsql/bin/pg_passwd(?![0-9a-z])|pgsql/data(?![0-9a-z])|php/apache\\.conf(?![0-9a-z])|php/apache2\\.conf(?![0-9a-z])|php/httpd\\.conf(?![0-9a-z])|php5/apache\\.conf(?![0-9a-z])|php5/apache2\\.conf(?![0-9a-z])|php5/httpd\\.conf(?![0-9a-z])|postgresql/log/|program files(?![0-9a-z])|psa/admin(?![0-9a-z])|pureftpd/etc(?![0-9a-z])|root/anaconda-ks\\.cfg(?![0-9a-z])|samba/lib(?![0-9a-z])|sb/config(?![0-9a-z])|server/default/conf(?![0-9a-z])|server/default/deploy(?![0-9a-z])|server/default/log(?![0-9a-z])|squirrelmail/www(?![0-9a-z])|system/library/webobjects/adaptors(?![0-9a-z])|system32/config(?![0-9a-z])|system32/inetsrv/config(?![0-9a-z])|tmp/|tmp/access\\.log(?![0-9a-z])|tmp/kafka-logs(?![0-9a-z])|typo3conf/localconf\\.php(?![0-9a-z])|usr/etc/pure-ftpd\\.conf(?![0-9a-z])|usr/home/user/lighttpd(?![0-9a-z])|usr/lib/cron/log(?![0-9a-z])|usr/lib/php(?![0-9a-z])|usr/lib/rpm/rpm\\.log(?![0-9a-z])|usr/lib/security(?![0-9a-z])|usr/local/zeus/web(?![0-9a-z])|usr/pkg/etc/httpd(?![0-9a-z])|usr/pkgsrc/net/pureftpd(?![0-9a-z])|usr/ports/contrib/pure-ftpd(?![0-9a-z])|usr/ports/ftp/pure-ftpd(?![0-9a-z])|usr/sbin/mudlogd(?![0-9a-z])|usr/sbin/mudpasswd(?![0-9a-z])|usr/share/adduser(?![0-9a-z])|usr/share/logs(?![0-9a-z])|usr/share/squirrelmail(?![0-9a-z])|usr/share/tomcat(?![0-9a-z])|usr/spool/lp(?![0-9a-z])|usr/spool/mqueue(?![0-9a-z])|var/adm(?![0-9a-z])|var/apache/logs(?![0-9a-z])|var/apache2/config\\.inc(?![0-9a-z])|var/cpanel(?![0-9a-z])|var/cron/log(?![0-9a-z])|var/data/elasticsearch(?![0-9a-z])|var/data/mysql-bin(?![0-9a-z])|var/htmp(?![0-9a-z])|var/lib/elasticsearch(?![0-9a-z])|var/lib/mysql(?![0-9a-z])|var/lib/pgsql(?![0-9a-z])|var/lib/squirrelmail(?![0-9a-z])|var/lighttpd(?![0-9a-z])|var/local/www/conf(?![0-9a-z])|var/log(?![0-9a-z])|var/lp/logs(?![0-9a-z])|var/mail(?![0-9a-z])|var/mysql-bin(?![0-9a-z])|var/mysql\\.log(?![0-9a-z])|var/nm2/postgresql\\.conf(?![0-9a-z])|var/postgresql(?![0-9a-z])|var/run/utmp(?![0-9a-z])|var/saf/_log(?![0-9a-z])|var/saf/port/log(?![0-9a-z])|var/spool(?![0-9a-z])|var/webmin(?![0-9a-z])|var/www(?![0-9a-z])|volumes/macintosh_hd(?![0-9a-z])|volumes/webbackup(?![0-9a-z])|wamp/bin/apache(?![0-9a-z])|wamp/bin/mysql(?![0-9a-z])|wamp/bin/php(?![0-9a-z])|wamp/logs(?![0-9a-z])|windows/comsetup\\.log(?![0-9a-z])|windows/debug/netsetup\\.log(?![0-9a-z])|windows/odbc\\.ini(?![0-9a-z])|windows/repair/setup\\.log(?![0-9a-z])|windows/setupact\\.log(?![0-9a-z])|windows/setupapi\\.log(?![0-9a-z])|windows/setuperr\\.log(?![0-9a-z])|windows/system32(?![0-9a-z])|windows/syswow64(?![0-9a-z])|windows/updspapi\\.log(?![0-9a-z])|windows/windowsupdate\\.log(?![0-9a-z])|windows/wmsetup\\.log(?![0-9a-z])|winnt/repair(?![0-9a-z])|winnt/system32/logfiles(?![0-9a-z])|wp-cli\\.|www/conf/httpd\\.conf(?![0-9a-z])|www/logs(?![0-9a-z])|xampp/apache/logs(?![0-9a-z])|xampp/filezillaftp(?![0-9a-z])|xampp/htdocs(?![0-9a-z])|xampp/mercurymail(?![0-9a-z])|xampp/mysql/data(?![0-9a-z])|xampp/php(?![0-9a-z])|xampp/sendmail(?![0-9a-z])|xampp/webalizer/webalizer\\.conf(?![0-9a-z]))",
      "flags": "i",
      "negated": false
    }
  }
];
